/**
 * Created by calhosh on 4/14/2017.
 */

import {
	actionIcAutorenew24px,
	actionIcCheckCircle24px,
	avIcPlaylistAddCheck24px
} from '@ey/motif-react-wrapper/assets/icons/index';

import {contentIcRemoveCircle24px, deviceIcAccessTime24px} from '@ey/motif-react-wrapper/assets/icons/index';

import envConfig from '@ey/voltron-config';

/* rastwe: 5/22/17 - I'm renaming all the id/name pairs to id/label, to
 * be in sync with the requirements of the Bootstrap SelectList control. */

export const serviceURL = 'serviceUrl';
export const reportURL = 'reportUrl';
export const ENGAGEMENTMETADATA_URL = '/engagementmetadata.json';
export const referenceDocumentsPageSize = 1000;
export const epeqr = 'PIC/EQR';
export const ep = 'PIC';
export const eqr = 'EQR';
export const digitalGam = 'Digital GAM';
export const emptyGuid = '00000000-0000-0000-0000-000000000000';
export const eqrReviewRequiredQuestionId = 15;
export const eqrReviewRequiredAnswerId = 311;
export const HELIX_PROJECT_FIT = `${envConfig.url.Helix_Analyzer_Base_Url}/`;
export const notSectorSpecific = '(Not Sector Specific)';
export const noOp = () => {};

export const entities = {
	all: 0,
	Document: 1,
	LeadSchedule: 2,
	Account: 3,
	SCOT: 4,
	ItProcess: 5,
	AuditPlan: 6,
	Risk: 7,
	Task: 8,
	Misstatement: 9,
	Deficiency: 10,
	GaComponent: 11,
	GaComponentInstruction: 12,
	GaComponentEvidence: 13,
	GaScope: 14,
	GaPrimaryInstruction: 15,
	GaPrimary: 16,
	ClientRequest: 17,
	WCGW: 18,
	Control: 19,
	IsSoApplication: 20,
	CanvasForm: 21,
	FormSection: 22,
	FormBody: 23,
	Assertion: 24,
	ClientEngagement: 25,
	ClientGroup: 26,
	EngagementTag: 27,
	Engagement: 28,
	FormHeader: 29,
	FormStatus: 30,
	EngagementUser: 31,
	ClientGroupUser: 32,
	PspIndex: 33,
	ItControl: 34,
	ItRisk: 35,
	automationLineItem: 36,
	pmAmount: 37,
	teAmount: 38,
	sadNominalAmount: 39,
	umtAmount: 40,
	annotation: 41,
	engagementComment: 42,
	Assignment: 43,
	PACEType: 44,
	TaskSection: 45,
	CalenderEvent: 46,
	Timephase: 47,
	GLAccount: 52
};

export const uiViews = {
	taskUserDefinedFilter: 1,
	document: 2,
	teamMember: 3,
	taskSystemSuggestedFilter: 4
};

export const financialStatementCategory = {
	BalanceSheet: 1,
	IncomeStatement: 2,
	All: 3
};
export const financialStatementCategoryName = {
	BalanceSheet: 'BalanceSheet',
	IncomeStatement: 'IncomeStatement',
	All: 'All'
};

export const misstatementAdjustmentGroup = {
	Adjustments: 'adjustments'
};

export const significantDisclosureCategory = {
	executionTypes: [1, 3]
};
export const significantDisclosureCategoryName = {
	significantDisclosures: 'significantDisclosure'
};

export const entityCategories = {
	SampleFilters: 'sampleFilters'
};

export const taskApiRoutes = {
	task: 'tasks/',
	category: 'TaskCategories/',
	engagement: 'Engagements/',
	workspace: 'Workspace/',
	relatedWCGWs: 'tasks/?expandRelatedWCGW=true',
	annotation: 'Annotations/',
	document: 'Documents/'
};

export const smartScreenRoutes = {
	sem: '/smartscreens/sem',
	fourFortyGl: '/smartscreens/440gl',
	independence: '/smartscreens/independence'
};

export const riskApiRoutes = {
	risks: 'risks/'
};

export const riskTypesApiRoutes = {
	riskTypes: 'riskTypes/'
};

export const assignmentApiRoutes = {
	assignment: 'Assignments'
};

export const wcgwApiRoutes = {
	wcgws: 'wcgws',
	associateTask: 'wcgws/{wcgwId}/tasks',
	unassociateTask: 'wcgws/{wcgwId}/tasks/{taskId}'
};

export const herculesRoutes = {
	activityfeed: '/activityfeed',
	archiveTimeline: '/archivetimeline',
	documents: '/documents',
	reviewNotes: '/reviewnotes',
	smartscreensIndependence: '/smartscreens/independence',
	sunrisersDrydock: '/sunrisers/drydock',
	wizardsDrydock: '/wizards/drydock',
	invinciblesDrydock: '/invincibles/drydock',
	sem: '/smartscreens/sem',
	schedulerrequests: '/schedulerrequests',
	tasks: '/tasks',
	reporting: '/reporting',
	dashboard: '/dashboard',
	groupsummary: '/groupsummary',
	receiveInstructions: '/receiveinstructions',
	buildSteps: '/buildsteps',
	adjustmentmodule: '/adjustmentmodule',
	financialStatements: '/financialstatements',
	collaboration: '/collaboration',
	collaborationv2: '/collaborationv2',
	helixProjects: '/helixprojects'
};

export const reviewNoteRoutes = {
	reviewNoteHub: '/reviewnotes/',
	path: {
		all: {id: entities.all, path: 'all'},
		document: {id: entities.Document, path: 'document'},
		task: {id: entities.Task, path: 'task'},
		form: {id: entities.CanvasForm, path: 'form'}
	},
	engagementComment: 'comments/',
	annotation: 'annotations/',
	users: 'Users/',
	hash: {
		add: '#AddNote',
		addDocNote: '#AddDocNote',
		addTaskNote: '#AddTaskNote',
		editNote: '#EditNote'
	},
	include: {
		roles: 'Roles'
	}
};

export const independenceRoutes = {
	hash: {
		details: '#details',
		list: '#list'
	}
};

export const documentRoutes = {
	approvals: '/approvals/',
	extensions: '/extensions/',
	document: 'documents/'
};

export const reportingRoutes = {
	hub: 'reports',
	validationChecks: 'reports/validationchecks'
};

export const archiveTimelineRoutes = {
	routes: {
		arcTimeline: 'archivetimeline'
	},
	endpoints: {
		validation: 'validations/',
		CheckLists: 'CheckLists',
		Archive: 'Archives'
	},
	hash: {}
};

export const activityFeedRoutes = {
	routes: {
		activityFeed: '/activityfeed'
	},
	endpoints: {
		groupActivities: 'groupActivities'
	},
	query: {
		groupRole: 'groupRole',
		activityType: 'activityType',
		entityGuid: 'entityGuid',
		summary: 'summary'
	},
	hash: {}
};

export const agGridFieldDataSeparator = '|FIELD|';

export const dateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const timeFormat24 = 'HH:mm:ss';

// ISA 220 validations.
// If the client year end date falls before December 15, 2023, then the user should NOT see the ISA 220 validations on the archive checklist.
// Otherwise, the user should see the ISA 220 validations on the archive checklist.
export const ISA220ValidationsDate = '2023-12-15T23:59:59';

export var reviewNoteApiUrl =
	'engagements/{engagementid}/Annotations/{taskid}?expand=Task&categoryId={categoryid}&statusId={statusid}';

export const userPreferenceRoutes = {
	userPreference: 'Users/Me?engagementId='
};

export const taskGroupSectionsUrl = 'TaskSections';

export const assignmentsRoute = 'assignments';

export const AuditPhases = {
	ViewAll: -1,
	ScopeAndStrategy: 1,
	Execution: 2,
	ConclusionAndWrapup: 3
};

export const configurationsRoutes = {
	configurations: 'Configurations'
};

export const TeamSummaryCategoryId = 9;

export const TaskType = [
	{value: 1, taskName: 'Control Task', taskAbbr: 'TOC'},
	{value: 2, taskName: 'Control Task - Control', taskAbbr: 'TOC'},
	{value: 3, taskName: 'Control Task - ELC', taskAbbr: 'TOC'},
	{value: 4, taskName: 'Control Task - IT/SO', taskAbbr: 'TOC'},
	{value: 5, taskName: 'Control Task - MP', taskAbbr: 'TOC'},
	{value: 6, taskName: 'Control Task - SO', taskAbbr: 'TOC'},
	{value: 7, taskName: 'Response Task', taskAbbr: 'RT'},
	{value: 8, taskName: 'Cashflow Misstatement Response Task', taskAbbr: 'RT'},
	{value: 9, taskName: 'Deficiency Response Task', taskAbbr: 'RT'},
	{
		value: 10,
		taskName: 'Disclosure Misstatement Response Task',
		taskAbbr: '	RT'
	},
	{value: 11, taskName: 'Misstatement Response Task', taskAbbr: 'RT'},
	{value: 12, taskName: 'Standard Task', taskAbbr: ''},
	{value: 13, taskName: 'Other Standard Task', taskAbbr: 'OST'},
	{value: 14, taskName: 'Primary Standard Task', taskAbbr: '	PST'},
	{value: 15, taskName: 'Substantive Task', taskAbbr: ''},
	{value: 16, taskName: 'Other Substantive Procedure Task', taskAbbr: 'OSP'},
	{value: 17, taskName: 'Primary Substantive Procedure Task', taskAbbr: 'PSP'},
	{value: 18, taskName: 'Walkthrough Task', taskAbbr: 'WT'},
	{value: 19, taskName: 'Walkthrough Task - IT/SO', taskAbbr: 'WT'},
	{value: 20, taskName: 'Walkthrough Task - SCOT', taskAbbr: 'WT'},
	{value: 21, taskName: 'Todo', taskAbbr: ''},
	{value: 22, taskName: 'Account Conclusion Task', taskAbbr: 'ACT'},
	{value: 23, taskName: 'Group Task', taskAbbr: 'GT'},
	{value: 24, taskName: 'Primary Group Task', taskAbbr: 'GT'},
	{value: 25, taskName: 'Component Group Task', taskAbbr: 'GT'},
	{
		value: 26,
		taskName: 'IT/SO Other Substantive Procedure Task',
		taskAbbr: 'OSP'
	},
	{value: 27, taskName: 'Component Group Task Unlinked', taskAbbr: 'GT'}
];

export const TaskGroup = [
	{value: 1, name: 'Perform General Planning Procedures'},
	{value: 2, name: 'Accounts Flow'},
	{value: 3, name: 'Significant Class of Transactions (SCOTs) Flow'},
	{value: 4, name: 'IT Applications & Service Organizations Flow'},
	{value: 5, name: 'Combined Risk Assessment (CRA) Flow'},
	{value: 6, name: 'Audit Plan Flow'},
	{value: 7, name: 'Wrap Up Engagement Procedures'},
	{value: 8, name: 'Summary of Audit Differences (SAD)'},
	{value: 9, name: 'Evaluate Audit Results'},
	{value: 10, name: 'Perform General Audit Procedures'},
	{value: 11, name: 'Group Structure Flow'},
	{value: 12, name: 'Group Instructions Flow'},
	{value: 13, name: 'Primary Group Tasks'},
	{value: 14, name: 'Component Group Tasks'},
	{value: 15, name: 'Build Work Plan Flow'},
	{value: 16, name: 'Accounts Flow'},
	{value: 17, name: 'Perform Review Procedures'},
	{value: 18, name: 'Complete preliminary engagement activities'},
	{value: 19, name: 'Engagement Planning'},
	{value: 20, name: 'Enable the engagement with data'},
	{value: 21, name: 'Analyze the data to inform our risk assessments'},
	{value: 22, name: 'Identify significant accounts'},
	{value: 23, name: 'Additional procedures to inform our risk assessments'},
	{value: 24, name: 'Identify sources'},
	{value: 25, name: 'Identify significant accounts'},
	{value: 26, name: 'Identify and understand SCOTs'},
	{
		value: 27,
		name: 'Identify and understand IT processes and service organizations'
	},
	{value: 28, name: 'Confirm strategy and CRA'},
	{
		value: 29,
		name: 'Perform additional required risk identification procedures'
	},
	{value: 30, name: 'Consider the use of internal audit'},
	{value: 31, name: 'Respond to risk assessments'},
	{value: 32, name: 'Finalize strategy'},
	{value: 33, name: 'EQR procedures'},
	{value: 34, name: 'Design procedures'},
	{value: 35, name: 'Evaluate and conclude on audit evidence'},
	{value: 36, name: 'Issue communications and deliverables'},
	{value: 37, name: 'EQR procedures'},
	{value: 38, name: 'Prepare and issue the audit report'},
	{value: 39, name: 'Engagement conclusion'},
	{value: 40, name: 'Test entity-level controls'},
	{value: 41, name: 'Assess data used in automated techniques'},
	{value: 42, name: 'Execute required fraud procedures'},
	{value: 43, name: 'Execute internal audit and specialist procedures'},
	{value: 44, name: 'Evaluate IT processes'},
	{value: 45, name: 'Minutes, contracts and legal review'},
	{value: 46, name: 'Financial statement procedures'},
	{
		value: 47,
		name: 'Execute RPTs, going concern and laws and regulations procedures'
	},
	{value: 48, name: 'Discuss audit strategy revisions'},
	{value: 49, name: 'Execution Conclusion'},
	{value: 50, name: 'EQR procedures'},
	{value: 54, name: 'Identify service organizations'}
];

// Task Report Header Labels
export const TaskReportHeaders = [
	{
		id: 1,
		title: 'Tasktitle',
		datatype: 'longstring',
		customCellRenderName: 'taskTitle',
		displayType: 1
	},
	{
		id: 2,
		title: 'Taskdescription',
		datatype: 'longstring',
		customCellRenderName: 'taskDesc',
		displayType: 1
	},
	{
		id: 3,
		title: 'Tasktypeid',
		datatype: 'integer',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 4,
		title: 'Tasktype',
		datatype: 'shortstring',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 5,
		title: 'Tasksourceid',
		datatype: 'integer',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 6,
		title: 'Tasksource',
		datatype: 'string',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 7,
		title: 'Tasknatureid',
		datatype: 'integer',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 8,
		title: 'Tasknature',
		datatype: 'string',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 9,
		title: 'Taskstatusid',
		datatype: 'integer',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 10,
		title: 'Taskstatus',
		datatype: 'string',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 11,
		title: 'Taggroup',
		datatype: 'string',
		customCellRenderName: 'tagGroup',
		displayType: 1
	},
	{
		id: 12,
		title: 'Tags',
		datatype: 'string',
		customCellRenderName: 'tag',
		displayType: 1
	},
	{
		id: 13,
		title: 'Lasttaskstatuschangedate',
		datatype: 'date',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 14,
		title: 'Rationalforrejection',
		datatype: 'string',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 15,
		title: 'Knowledgetasktitle',
		datatype: 'longstring',
		customCellRenderName: 'knowledgeTaskTitle',
		displayType: 1
	},
	{
		id: 16,
		title: 'Knowledgetaskdescription',
		datatype: 'longstring',
		customCellRenderName: 'knowledgeTaskDesc',
		displayType: 1
	},
	{
		id: 17,
		title: 'Taskassignedto',
		datatype: 'string',
		customCellRenderName: 'taskAssignedTo',
		displayType: 1
	},
	{
		id: 18,
		title: 'Priority',
		datatype: 'shortstring',
		customCellRenderName: null,
		displayType: 4
	},
	{
		id: 19,
		title: 'Auditphaseid',
		datatype: 'interger',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 20,
		title: 'Auditphase',
		datatype: 'string',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 21,
		title: 'Timephasetypeid',
		datatype: 'interger',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 22,
		title: 'Timephasetype',
		datatype: 'string',
		customCellRenderName: 'mileStone',
		displayType: 1
	},
	{
		id: 23,
		title: 'Timephase',
		datatype: 'string',
		customCellRenderName: 'timePhase',
		displayType: 1
	},
	{
		id: 24,
		title: 'Timephasestartdate',
		datatype: 'date',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 25,
		title: 'Timephaseduedate',
		datatype: 'date',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 26,
		title: 'RelatedMESTentities',
		datatype: 'string',
		customCellRenderName: 'relatedMestEntity',
		displayType: 1
	},
	{
		id: 27,
		title: 'Taskid',
		datatype: 'longstring',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 28,
		title: 'Oldtaskname',
		datatype: 'longstring',
		customCellRenderName: null,
		displayType: 4
	},
	{
		id: 29,
		title: 'Oldtaskdetail',
		datatype: 'longstring',
		customCellRenderName: null,
		displayType: 4
	},
	{
		id: 30,
		title: 'Schedulednextwaveservices',
		datatype: 'longstring',
		customCellRenderName: null,
		displayType: 4
	},
	{
		id: 31,
		title: 'Tasktitleprefix',
		datatype: 'string',
		customCellRenderName: null,
		displayType: 3
	},
	{
		id: 32,
		title: 'Tasktitlesuffix',
		datatype: 'string',
		customCellRenderName: null,
		displayType: 3
	},
	{
		id: 33,
		title: 'Keyevent',
		datatype: 'shortstring',
		customCellRenderName: null,
		displayType: 3
	},
	{
		id: 34,
		title: 'Rejected',
		datatype: 'shortstring',
		customCellRenderName: null,
		displayType: 1
	},
	{
		id: 35,
		title: 'Roleid',
		datatype: 'interger',
		customCellRenderName: null,
		displayType: 4
	}
];

export function GetTaskGroup(groupId) {
	return !groupId ? '' : TaskGroup[groupId - 1] ? TaskGroup[groupId - 1].name : undefined;
}

export const TaskStatus = [
	{id: 1, className: 'Open'},
	{id: 2, className: 'Progress'},
	{id: 3, className: 'Review'},
	{id: 4, className: 'Complete'},
	{id: 5, className: 'Removed'},
	{id: 6, className: 'Completed'}
];

export function GetTaskStatus(statusId, isEPEQRSignOffComplete) {
	return !statusId
		? {id: 0, className: ''}
		: statusId === 4 && isEPEQRSignOffComplete
		? TaskStatus[5]
		: TaskStatus[statusId - 1];
}

export const RelatedItemStatus = [
	{value: 1, label: 'Draft'},
	{value: 2, label: 'No Client Contact'},
	{value: 3, label: 'Sent'},
	{value: 4, label: 'System Error'},
	{value: 5, label: 'Invalid Client Contact'},
	{value: 6, label: 'Pending Response'},
	{value: 7, label: 'Received'},
	{value: 8, label: 'Accepted'},
	{value: 9, label: 'Returned'},
	{value: 10, label: 'Withdrawn'},
	{value: 11, label: 'Send In Progress'},
	{value: 12, label: 'Accept In Progress'},
	{value: 13, label: 'Withdraw In Progress'},
	{value: 14, label: 'Delete In Progress'},
	{value: 15, label: 'Return In Progress'},
	{value: 16, label: 'Response In Progress'},
	{value: 17, label: 'Deleted'},
	{value: 18, label: 'Invalid Client Contact Returned'},
	{value: 19, label: 'Recall In Progress'},
	{value: 20, label: 'Recalled'},
	{value: 21, label: 'Completion In Progress'},
	{value: 22, label: 'Recall In Progress'}
];

export function GetRelatedItemStatus(statusId, isProcesingError) {
	return isProcesingError ? 'Processing Error' : !statusId ? '' : RelatedItemStatus[statusId - 1].label;
}

export const TaskCategories = {
	MyTasks: 1,
	AllTasks: 2,
	ScopeStrategy: 3,
	ExecutionSCOTs: 4,
	ExecutionITSOs: 5,
	ExecutionAccounts: 6,
	ExecutionGeneral: 7,
	Conclusion: 8,
	TeamSummary: 9,
	Risks: 10,
	TaskSection: 11,
	BasicTaskAttributes: 12,
	UnassignedAssignment: 13,
	Entities: 14,
	UnrelatedRequests: 15
};

export const GroupByTaskCategories = {
	AllTasks: '2',
	ScopeStrategy: '3',
	ExecutionSCOTs: '4',
	ExecutionITSOs: '5',
	ExecutionAccounts: '6',
	ExecutionGeneral: '7',
	Conclusion: '8',
	Risks: '10'
};

export const TaskCategoriesDisplayOrder = {
	MyTasks: 2,
	AllTasks: 1,
	ScopeStrategy: 3,
	ExecutionSCOTs: 4,
	ExecutionITSOs: 5,
	ExecutionAccounts: 6,
	ExecutionGeneral: 7,
	Conclusion: 8,
	TeamSummary: 9,
	Risks: 10
};

export const addRelateMenuOptions = {
	buttonLabel: 'Add/Relate',
	dropDownButtondisplay: true,
	dropDownOptions: [
		{
			Name: 'Document',
			Label: 'Document',
			pathname: ``,
			search: ``,
			hash: ''
		},
		{
			Name: 'AutomationRequest',
			Label: 'Automation request',
			pathname: ``,
			search: ``,
			hash: ''
		},
		{
			Name: 'ExternalTask',
			Label: 'External task',
			pathname: ``,
			search: ``,
			hash: ''
		},
		{
			Name: 'Finding',
			Label: 'Finding',
			pathname: ``,
			search: ``,
			hash: ''
		},
		{
			Name: 'Request',
			Label: 'Request',
			pathname: ``,
			search: ``,
			hash: ''
		},
		{
			Name: 'Notes',
			Label: 'Notes',
			pathname: ``,
			search: ``,
			hash: ''
		},
		{
			Name: 'RelatedTask',
			Label: 'Related task',
			pathname: ``,
			search: ``,
			hash: ''
		}
	]
};

//Maybe here add more options?
export const cogMenuOptionsEvidience = {
	buttonLabel: 'Option 1',
	iconClass: 'cog-menu',
	buttonIconDisplay: true
};

export const cogMenuDocumentOptionsList = {
	Open: 'Open',
	OpenReadOnly: 'Open read-only',
	ViewHistory: 'View history',
	CopyLink: 'CopyLink',
	Rename: 'Rename',
	RelateTasks: 'RelateTasks',
	RelateEntities: 'RelateEntities',
	SignoffRequirements: 'SignoffRequirements',
	Confidentiality: 'Confidentiality',
	Delete: 'Delete'
};

export const cogMenuDaaSDocumentOptionsList = {
	Open: cogMenuDocumentOptionsList.Open,
	OpenReadOnly: cogMenuDocumentOptionsList.OpenReadOnly,
	StartCoeditMode: 'Start Co-edit mode',
	EndCoeditMode: 'End Co-edit mode',
	ViewHistory: cogMenuDocumentOptionsList.ViewHistory,
	CopyLink: cogMenuDocumentOptionsList.CopyLink,
	Rename: cogMenuDocumentOptionsList.Rename,
	RelateTasks: cogMenuDocumentOptionsList.RelateTasks,
	RelateEntities: cogMenuDocumentOptionsList.RelateEntities,
	SignoffRequirements: cogMenuDocumentOptionsList.SignoffRequirements,
	Confidentiality: cogMenuDocumentOptionsList.Confidentiality,
	Delete: cogMenuDocumentOptionsList.Delete
};

export const documentOperationType = {update: 'Update', restore: 'Restore', bookmarkUpdate: 'BookmarkUpdate'};

export const cogMenuOfflineDocumentOptionsList = {Open: 'Open'};

export const allRelatedItemsMenuOptions = {
	buttonLabel: 'All related objects',
	dropDownButtondisplay: true,
	dropDownOptions: []
};

//TODO: These names are currently mapped to api response.
// Should be taken from api rather than placing them in constants
export const documentTabLayoutTabs = {
	evidenceName: 'evidences',
	temporaryName: 'temporaryfiles',
	priorPeriodName: 'prioryearevidences',
	externalDocsName: 'externaldocuments',
	groupDocsName: 'groupdocuments',
	conflictsName: 'conflicts',
	recentlyDeletedName: 'recentlydeleted',
	regionComponentName: 'regionComponent', //For the doc list of GA tasks.
	activityFeed: 'activityFeed',
	activityFeedComponent: 'activityFeedComponent',
	compareVersionsGroupSummary: 'compareVersionsGroupSummary',
	myPinnedDocuments: 'mypinneddocuments',
	teamPinnedDocuments: 'teampinneddocuments',
	glAccountDocUpload: 'glAccountDocUpload'
};

export const referenceDocsAddDocTabs = {
	evidence: 'evidence',
	temporary: 'temporary'
};

export const referenceDocumentTabs = {
	all: 'engagementReferenceDocument',
	my: 'myReferenceDocument'
};

export const documentCategoryNames = {
	evidence: 'evidence',
	temporary: 'temporary',
	priorPeriod: 'prioryear',
	external: 'external',
	groupDocument: 'ComponentGroup',
	componentSent: 'componentSent',
	componentReturned: 'componentReturned',
	componentResolved: 'componentResolved',
	evidenceAndTemporary: 'evidenceAndTemporary',
	afterRrd: 'afterRrd',
	clientRequestEvidence: 'clientRequestEvidence',
	clientRequestTemporary: 'clientRequestTemporary',
	clientRequestPriorYear: 'clientRequestPriorYear',
	clientRequestExternal: 'clientRequestExternal',
	componentEvidenceAndGroup: 'componentEvidenceAndGroup',
	componentSentDocumentToPrimary: 'componentSentDocumentToPrimary',
	workspace: 'Workspace',
	sharedEvidence: 'sharedevidence',
	canvasForm: 'canvasFormReport',
	systemDiagnostic: 'systemDiagnostic',
	ClientRequestClientAnalytics: 'ClientRequestClientAnalytics',
	ScopeStrategySuggested: 'ScopeStrategySuggested',
	ExecutionSuggested: 'ExecutionSuggested',
	ConclusionSuggested: 'ConclusionSuggested',
	AccountSuggested: 'AccountSuggested',
	SCOTSuggested: 'SCOTSuggested',
	ITProcessSuggested: 'ITProcessSuggested',
	RiskSuggested: 'RiskSuggested'
};

export const documentSearchTypes = {
	engagement: 'engagement',
	task: 'task',
	canvasForm: 'canvasform',
	canvasFormbody: 'canvasformbody',
	engagementReferenceDocument: 'engagementReferenceDocument',
	myReferenceDocument: 'myReferenceDocument',
	afterRrd: 'afterRrd',
	gaInstruction: 'GAInstruction',
	glAccount: 'GLAccount',
	misstatement: 'misstatement'
};

export const documentGetAllParamNames = {
	filteredEntityType: 'filteredEntityType',
	contains: 'contains',
	startsWith: 'startswith',
	searchType: 'searchtype',
	documentCategoryName: 'documentCategoryName',
	filteredEntityIdGuid: 'filteredEntityIdGuid',
	includeReviewNotes: 'includeReviewNotes',
	includeApprovals: 'includeApprovals',
	includeFindings: 'includeFindings',
	includeRelatedTasks: 'includeRelatedTasks',
	includeGroupDocuments: 'includeGroupDocuments',
	filterGroupDocuments: 'filterGroupDocuments',
	pageSize: 'pageSize',
	page: 'page',
	searchString: 'searchString',
	filterDocumentId: 'filterDocumentId'
};

export const documentFilter = {
	filterSharedEvidence: 3
};

export const taskSearchTypes = {
	document: 'RelatedDocument',
	ITProcess: 'ITProcess'
};

export const tabsUniqueConstants = {
	documentReviewNotes: 'documentReviewNotes',
	taskReviewNotes: 'taskReviewNotes',
	allNotes: 'allNotes',
	myNotes: 'myNotes',
	relateEvidence: 'relateEvidence',
	createPaperProfile: 'createPaperProfile',
	internalMember: 'internalMember',
	externalMember: 'externalMember',
	otherEngagementNotes: 'otherEngagementNotes',
	addCanvasRelatedTask: 'ManageTasks',
	addCanvasRelatedObject: 'ManageObjects',
	contentUpdates: 'contentUpdates',
	canvasFormUpdates: 'canvasFormUpdates',
	syncFormProfile: 'syncFormProfile',
	pspAccountsUpdate: 'pspAccountsUpdate',
	guidance: 'guidance',
	helixAnalyzers: 'helixAnalyzers',
	smartAutomationLinks: 'smartAutomationLinks',
	nextWaveServices: 'nextWaveServices',
	sentRequests: 'Sent',
	receivedRequests: 'Received',
	generalInformation: 'General Information',
	copyhubPackageDetailsSecondTab: 'Second Tab',
	canvasformlist: 'CanvasForm',
	canvasformResponse: 'CanvasFormResponse',
	canvasFormsIncomplete: 'CanvasFormsIncomplete',
	canvasFormsRelatedObjects: 'CanvasFormsRelatedObjects',
	controlformlist: 'ControlForm',
	controlformResponse: 'ControlFormResponse',
	canvasFormRelatedComments: 'CanvasFormsRelatedComments',
	members: 'Members',
	independenceOnlyMembers: 'IndependenceOnlyMembers'
};

export const contentUpdatePathNames = {
	contentUpdates: '/contentupdates',
	canvasFormUpdates: '/contentupdates/forms',
	syncFormProfile: '/contentupdates/sync',
	pspAccountsUpdate: '/contentupdates/pspaccounts'
};

export const herculesHashRouteSegments = {
	reviewNotes: 'reviewnotes'
};

export const reviewNotesType = {
	task: 1,
	document: 2,
	canvasFormComment: 3
};

export const reviewNoteStatus = {
	Open: {id: 1, value: 'open'},
	Cleared: {id: 2, value: 'cleared'},
	Closed: {id: 3, value: 'closed'}
};

export const reviewNoteStatusReport = {
	cleared: 'Cleared',
	closed: 'Closed',
	deleted: 'Deleted'
};

export const engagementCommentStatus = {
	Open: {id: 1, value: 'open'},
	Closed: {id: 3, value: 'closed'},
	Cleared: {id: 2, value: 'cleared'}
};

export const taskAssignmentStatusClass = {
	NotStarted: 'open',
	InProgress: 'inProgress',
	Done: 'done'
};
export const countZero = 0;

export const filterStatus = {
	taskStatusFilterAll: [1, 2, 3, 4],
	assignmentStatusFilterAll: [1, 2, 3, 4],
	assignmentStatusDone: [3],
	assignmentStatusInProgress: [2],
	assignmentStatusOpen: [1]
};

export const canvasWebRoutes = {
	addTask: '&hashRoute=addTask',
	addRequest: '&hashRoute=addClientRequest',
	addExternalTask: '&hashRoute=addExternalTask',
	clientRequestId: '&hashRoute=request',
	addCanvasForm: '&hashRoute=addCanvasForm',
	task: '#task',
	reviewerAssignments: '&hashRoute=reviewerAssignments',
	relateObject: '&hashRoute=relateObject',
	addFinding: '&hashRoute=addFinding',
	finding: '&hashRoute=finding',
	collaboration: '&hashRoute=clientRequests',
	manageGroup: '&hashRoute=managegroupaudit'
};

export const canvasUrlParams = {
	inCountryBaseUrl: 'inCountryBaseUrl',
	countryid: 'countryid',
	engagementid: 'engagementid',
	engagementdesc: 'engagementdesc',
	workspacedesc: 'workspacedesc',
	workspaceid: 'workspaceid',
	engagementversion: 'engagementversion',
	addTask: 'addTask',
	addRequest: 'addRequest',
	addExternalTask: 'addExternalTask',
	addFinding: 'addFinding',
	clientRequestId: 'clientRequestId',
	clientRequestGuid: 'clientRequestGuid',
	clientRequestStatusId: 'clientRequestStatusId',
	isRetry: 'isRetry',
	isClientRequest: 'isClientRequest',
	clientRequestTypeId: 'clientRequestTypeId',
	findingId: 'findingId',
	returnUrl: 'returnUrl',
	addCanvasForm: 'addCanvasForm',
	type: 'type',
	taskDetails: 'task',
	relateObject: 'relateObject',
	reviewerAssignments: 'reviewerAssignments',
	taskType: 'tasktype',
	deficiencyId: 'deficiencyid',
	misstatementId: 'misstatementid',
	finding: 'finding',
	standardId: 'standardid',
	languageId: 'languageid',
	formTypeId: 'formtypeid',
	isInterim: 'isinterim',
	mode: 'mode'
};

export const reviewNoteCategoryType = {
	All: 0,
	My: 1,
	OtherEngagementReviewNote: 2
};

export const reviewNoteStatusFilter = {
	All: 0,
	Open: 1,
	Cleared: 2,
	Closed: 3
};

export const ReviewNoteStatusFilterParameter = {
	All: {value: 0},
	Open: {value: 1},
	OpenAndClosed: {value: 2},
	OpenAndCleared: {value: 3}
};

export const entityTypes = {
	Engagement: 'engagement',
	Task: 'task',
	Document: 'document',
	ClientRequest: 'clientrequest',
	openReviewNoteCount: 'opennotescount',
	instruction: 'instruction',
	GLAccount: 'glaccount'
};

export const entityEnum = {
	Document: 1
};

export const timephaseTypes = {
	NotApplicable: 10
};

export const timePhaseTypes = [
	{
		value: 1,
		label: 'Scope',
		uidisplayorder: 1,
		isactive: 0
	},
	{
		value: 2,
		label: 'Strategy',
		uidisplayorder: 2,
		isactive: 0
	},
	{
		value: 3,
		label: 'Walkthroughs',
		uidisplayorder: 7,
		isactive: 1
	},
	{
		value: 4,
		label: 'Interim Control Testing',
		uidisplayorder: 8,
		isactive: 1
	},
	{
		value: 5,
		label: 'Interim Substantive Testing',
		uidisplayorder: 9,
		isactive: 1
	},
	{
		value: 6,
		label: 'Walkthroughs (year-end processes)',
		uidisplayorder: 10,
		isactive: 1
	},
	{
		value: 7,
		label: 'Year-end Control Testing',
		uidisplayorder: 11,
		isactive: 1
	},
	{
		value: 8,
		label: 'Year-end Substantive Testing',
		uidisplayorder: 12,
		isactive: 1
	},
	{
		value: 9,
		label: 'Conclusion',
		uidisplayorder: 14,
		isactive: 1
	},
	{
		value: 10,
		label: 'N/A',
		uidisplayorder: 15,
		isactive: 1
	},
	{
		value: 11,
		label: 'Execution',
		uidisplayorder: 13,
		isactive: 1
	},
	{
		value: 12,
		label: 'Scope and strategy quality activities',
		uidisplayorder: 1,
		isactive: 1
	},
	{
		value: 13,
		label: 'Other scope and strategy',
		uidisplayorder: 2,
		isactive: 1
	},
	{
		value: 14,
		label: 'CRA',
		uidisplayorder: 3,
		isactive: 1
	},
	{
		value: 15,
		label: 'Risk Assessment and Materiality',
		uidisplayorder: 4,
		isactive: 1
	},
	{
		value: 16,
		label: 'Finalize scope and strategy',
		uidisplayorder: 5,
		isactive: 1
	},
	{
		value: 17,
		label: 'Post-interim project management',
		uidisplayorder: 6,
		isactive: 1
	}
];
export const manageAssignmentType = {
	None: 'None',
	Create: 'Create',
	Edit: 'Edit',
	Remove: 'Remove'
};

export const actionTypes = {
	none: 0,
	create: 1,
	edit: 2,
	delete: 3
};

export const actionTypesEnum = {
	Open: 1
};

export const screenModeEnum = {
	New: 0,
	Edit: 1
};

export const toastVariant = {
	success: 'success',
	error: 'error',
	warning: 'warning',
	info: 'info'
};

export const toastPositions = {
	top: 'top',
	bottom: 'bottom'
};

export const dateFormats = [
	{
		// 07/22/2014
		id: 0,
		label: 'MM/DD/YYYY',
		format: 'MM/dd/yyyy',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	},
	{
		// 22/07/2014
		id: 1,
		label: 'DD/MM/YYYY',
		format: 'dd/MM/yyyy',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	},
	{
		// 2014/07/22
		id: 2,
		label: 'YYYY/MM/DD',
		format: 'yyyy/MM/dd',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	}
];

export const dateTimeFormats = [
	{
		// 07/22/2014 06:30:48
		id: 0,
		label: 'MM/DD/YYYY hh:mm:ss',
		format: 'MM/dd/yyyy hh:mm:ss',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	},
	{
		// 22/07/2014 06:30:48
		id: 1,
		label: 'DD/MM/YYYY hh:mm:ss',
		format: 'dd/MM/yyyy hh:mm:ss',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	},
	{
		// 2014/07/22 06:30:48
		id: 2,
		label: 'YYYY/MM/DD hh:mm:ss',
		format: 'yyyy/MM/dd hh:mm:ss',
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	}
];

export const fileExtensionMapping = {
	// Need to mentioned keys in upper case becase same will be use for comparison.

	mapping: [
		{
			keys: ['XLS', 'XLSX', 'XLSM', 'CSV', 'XLTX', 'XLAM', 'XLSB'],
			mapIconName: 'excel'
		},
		{
			keys: ['DOCX', 'DOC', 'DOCM'],
			mapIconName: 'word'
		},
		{
			keys: ['PDF'],
			mapIconName: 'pdf'
		},
		{
			keys: ['JPG', 'JPEG', 'GIF', 'PNG'],
			mapIconName: 'jpg'
		},
		{
			keys: ['PPT', 'PPTX'],
			mapIconName: 'powerpoint'
		},
		{
			keys: ['PST', 'MSG'],
			mapIconName: 'outlook'
		},
		{
			keys: [''],
			mapIconName: 'paper-profile'
		},
		{
			keys: ['SMART', 'SMT', 'LS'],
			mapIconName: 'smart-evidence'
		},
		{
			keys: ['SMTA'],
			mapIconName: 'smt-icon'
		},
		{
			keys: ['ZIP'],
			mapIconName: 'zip'
		},
		{
			keys: ['FORM'],
			mapIconName: 'form'
		}
	]
};
export const fileExtension = {
	pdf: 'pdf'
};

export const relateRequestType = {
	Request: 'REQ',
	ET: 'ET'
};

export const pagingOptions = {
	defaultOption: 20,
	options: [20, 50, 100]
};

export const paginationConstants = {
	page: 1,
	pageSize: 100
};

export const taskListPagingOptions = {
	options: [20, 50, 100, 200]
};

export const AccountsPagingOptions = {
	options: [10, 20, 50, 100]
};

export const MultiEntityPaginationOptions = {
	options: [12, 24, 36]
};
export const pagingOptions200 = [20, 50, 100, 200];

export const classViewPagingOptions = [25, 50];

export const financialStatementsPagingOptions = [50, 100];

export const pageSize = {
	pageSize200: 200
};

export const multiEntityDeliveryTypes = {
	DefaultDelivery: 1,
	EngagementDelivery: 2,
	PerEntityDelivery: 3
};

export const HttpStatusCodes = {
	Ok: 200,
	Created: 201,
	NoContent: 204,
	Unauthorized: 401,
	Forbidden: 403,
	NotFound: 404,
	NotAcceptable: 406,
	Conflict: 409,
	Gone: 410,
	PreConditionFailed: 412,
	RequestEntityTooLarge: 413,
	RequestUriTooLong: 414,
	BadRequest: 400,
	InternalServerError: 500,
	LengthRequired: 411
};

export const multiEntityTypes = {
	tasksByEntity: 1,
	tasksByEngagement: 2,
	perEntity: 3
};

export const fileTypesUpload = {
	options: ['pdf', 'docx', 'txt', 'log']
};

export const DocumentHubStatus = {
	UPLOADSTART: 'UPLOADSTART',
	ERROR: 'ERROR',
	UPLOADINGPROGRESS: 'UPLOADINGPROGRESS',
	UPLOADCOMPLETE: 'UPLOADCOMPLETE',
	DOWNLOADSTART: 'DOWNLOADSTART',
	DOWNLOADPROGRESS: 'DOWNLOADPROGRESS',
	DOWNLOADCOMPLETE: 'DOWNLOADCOMPLETE'
};

export const DocumentHubErrorCode = {
	ResourceDuplicate: 412
};

// Enum for Client Request Status
export const ClientRequestStatus = {
	//SENDINTRANSIT: 11,
	Draft: 1,
	NoClientContact: 2,
	Sent: 3,
	SystemError: 4,
	InvalidClientContact: 5,
	PendingResponse: 6,
	Received: 7,
	Accepted: 8,
	Returned: 9,
	Withdrawn: 10,
	SendInTransit: 11,
	AcceptInTransit: 12,
	WithdrawInTransit: 13,
	DeleteInTransit: 14,
	ReturnInTransit: 15,
	ResponseInTransit: 16,
	Deleted: 17,
	InvalidClientContactReturned: 18,
	RecallInTransit: 19,
	Recalled: 20,
	CompletionInTransit: 21,
	RecallInProgress: 22,
	RecalledFromAccepted: 27,
	RecallInTransitfromAccepted: 28
};

export const CopyDocumentNameBehaviorType = {
	SameAsSource: 0,
	Timestamp: 1,
	CustomDocumentName: 2
};

export const DocumentSource = {
	None: 0,
	UserGenerated: 1,
	LeadScheduleSmartEvidence: 2,
	FromKnowledge: 3,
	SystemGenerated: 4,
	FromGamxMigration: 5,
	OarInterim: 6,
	OarCurrentYear: 7,
	ClientGenerated: 8,
	LogFiles: 9,
	Restore: 10,
	RollForward: 11,
	ContentUpdate: 12,
	CopyEngagement: 13,
	UnlinkSharedEvidenceFromArchiveTimeline: 14,
	SubmitProfile: 15,
	CaptureEvidenceMobile: 16,
	DocHelper: 17,
	SupportPaneFormAndTemplate: 18,
	SupportPaneExternalDocument: 19,
	SupportPanePriorYearEvidence: 20,
	AcceptInstructions: 21,
	SentFromExternalApplication: 22,
	IndividualUnlink: 23,
	PgtToCgt: 24,
	CgtToPgt: 25,
	CopyScot: 26,
	ManuallyInserted: 27,
	Tieout: 28,
	EySentToClient: 29,
	SupportPaneGroupDocuments: 30,
	BulkExport: 31,
	OwnershipChangeSharedEvidence: 32,
	ConflictResolved: 33,
	UnassociatedFromKnowledge: 34,
	CanvasFormFromCgSubmitProfile: 35,
	CanvasFormFromCgUserAdded: 36,
	AutomationHub: 37,
	IndependenceTemplate: 38,
	CanvasFormFromCgMobileAdded: 39,
	AutomationHubClientFilesReceived: 40,
	CopyCanvasForm: 41,
	CgtToPgtDraft: 42,
	CgtToPgtFinal: 43,
	ImportFromHelix: 44,
	MobileDocUpload: 45
};

// Enum for Document Type complete list
export const documentTypes = {
	UNDEFINED: 0,
	EVIDENCEDOCUMENT: 1,
	CRASHDOCUMENT: 2,
	PRIORYEAREVIDENCEDOCUMENT: 3,
	CLIENTFILESDOCUMENT: 4,
	SNAPSHOTDOCUMENT: 5,
	SMARTFORMDOCUMENT: 6,
	EVIDENCE: 7,
	CRASH: 8,
	PRIORYEAREVIDENCE: 9,
	CLIENTFILES: 10,
	SNAPSHOT: 11,
	PROFILE: 12,
	KEYRISKIDENTIFICATION: 13,
	KEYRISKIDENTIFICATIONUBT: 14,
	ENTITYLEVELCONTROLSSUMMARY: 15,
	MANAGEMENTPROCEDURESSUMMARY: 16,
	DETERMINEPMTESAD: 17,
	ACCOUNTSSUMMARY: 18,
	SCOTSSUMMARY: 19,
	ITSOSUMMARY: 20,
	CRASUMMARY: 21,
	AUDITPLAN: 22,
	EVALUATEAUDITRESULTS: 23,
	CONFIRMFINALMATERIALITY: 24,
	SUMMARYOFAUDITDIFFERENCES: 25,
	ACCOUNTCONCLUSIONCLASSIC: 26,
	LEADSCHEDULE: 27,
	ARCHIVE: 28,
	PAPERPROFILEDOCUMENT: 29,
	PAPERPROFILE: 30,
	GROUPAUDITSTRUCTURESUMMARY: 31,
	GROUPAUDITINSTRUCTIONSUMMARY: 32,
	GROUPCOMPONENTINSTRUCTIONDOCUMENT: 33,
	OARINTERIMCOMPARISON: 34,
	OARCURRENTYEARCOMPARISON: 35,
	GROUPCOMPONENTSUMMARYDOCUMENT: 36,
	RETURNEDDOCUMENT: 37,
	WORKPLANSUMMARY: 38,
	TIEOUT: 39,
	LEADSCHEDULETEMPORARYSMARTFORM: 40,
	OARINTERIMCOMPARISONTEMPORARYSMARTFORM: 41,
	OARCURRENTYEARCOMPARISONTEMPORARYSMARTFORM: 42,
	TIEOUTTEMPORARYSMARTFORM: 43,
	EYSENTTOCLIENTFILES: 44,
	ITEVALUATIONSMARTFORM: 45,
	ITEVALUATIONTEMPORARYSMARTFORM: 46,
	BULKDOCUMENTEXPORT: 47,
	CANVASFORM: 48,
	CANVASFORMEVIDENCE: 49,
	CANVASFORMTEMPORARY: 50,
	AUTOMATIONPARENT: 51,
	AUTOMATIONHUBINPUT: 52,
	AUTOMATIONHUBOUTPUT: 53,
	CONTROLFORM: 54,
	INDEPENDENCEFORMTEMPLATE: 56,
	EVIDENCENOTDISPLAYED: 57,
	INDEPENDENCEFORMINDIVIDUAL: 58,
	AUTOMATIONHUBOUTPUTTEMPORARY: 63,
	AUTOMATIONHUBCLIENTOUTPUT: 65,
	CONTENT_UPDATE_IN_PROGRESS_CANVAS_FORM: 68,
	SEM: 69,
	ACCOUNT_CONCLUSION: 70,
	FOUR_FORTY_GL: 71,
	SMARTWORKINGPAPER_PARENT: 72,
	SMARTWORKINGPAPER: 73,
	PAPERPROFILETEMPORARY: 74,
	PROFILEV2: 76,
	LEGACYBITMAPREFERENCE: 77,
	CANVASFORM_BODYIMAGE: 78,
	GUIDEDWORKFLOWTEMPORARY: 79,
	GUIDEDWORKFLOW: 80,
	LIMITEDRISKDOCUMENTATION: 81,
	GUIDEDWORKFLOWV2: 82,
	COPY_CANVASFORMINPROGRESS: 83,
	HELIXSCREENSHOT: 84,
	COPY_DOCUMENT_IN_PROGRESS: 85,
	IT_FLOW_ISA315: 86,
	BULKEXPORTCANVASFORM_NOTDISPLAYED: 87,
	EVIDENCE_NOTDISPLAYED_REQUIRESAPPROVAL: 88,
	MANAGE_TEAM: 89,
	EVIDENCE_NOTARCHIVED: 90,
	SMARTAUTOMATIONEVIDENCE: 91,
	SMARTAUTOMATIONEVIDENCETEMPORARY: 92,
	ESTIMATESDOCUMENT: 93,
	ANALYTICSDOCUMENT: 94,
	MULTIENTITYSUBPROFILE: 95,
	MULTIENTITYINDIVIDUALPROFILE: 96,
	RECORDING: 97,
	VOICE_RECORDING: 98,
	SYSTEMDIAGNOSTIC: 99,
	HELIXIMPORT: 100,
	COPYKNOWLEDGEDELIVEREDEVIDENCE: 101,
	SCREEN_RECORD: 102,
	ACCOUNTLEVELRISKASSESSMENT: 103,
	PIC_CHECKLIST: 104,
	EQR_CHECKLIST: 105,
	GROUPSTRUCTUREGUIDEDWORKFLOW: 106,
	GROUPINSTRUCTIONGUIDEDWORKFLOW: 107,
	GUIDEDWORKFLOWV2_TEMPORARY: 108,
	CANVASFORMSNAPSHOT: 109,
	ALRA_INDIVIDUAL: 110,
	CLIENT_SHARED_HELIX_ANALYTIC: 111,
	GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT: 112,
	GROUP_INVOLVEMENT_SUMMARY: 113,
	ACCOUNT_STANDARD_WORKING_PAPER: 114,
	ACCOUNT_STANDARD_WORKING_PAPER_TEMPORARY: 115,
	PRIOR_PERIOD_CLIENT_FILES: 117,
	PRIOR_PERIOD_AUTOMATION_HUB_OUTPUT: 118,
	PRIOR_PERIOD_EY_SENT_TO_CLIENT_FILES: 119,
	ALRA_INDIVIDUAL_TEMPORARY: 120,
	CONTROL_UNDERSTAND_CONTROLS: 121,
	CONTROL_UNDERSTAND_CONTROLS_TEMPORARY: 122,
	CONTROL_TEST_CONTROL_ATTRIBUTES: 123,
	CONTROL_TEST_CONTROL_ATTRIBUTES_TEMPORARY: 124,
	ADJUSTMENT_MODULE: 125,
	SCOT_WALKTHROUGH: 126,
	SCOT_WALKTHROUGH_TEMPORARY: 127,
	Estimate_Individual_Estimate_Temporary: 128
};

export const documentTypesForValidationsForScopeAndStrategy = [
	documentTypes.GUIDEDWORKFLOW,
	documentTypes.GUIDEDWORKFLOWV2,
	documentTypes.IT_FLOW_ISA315,
	documentTypes.ANALYTICSDOCUMENT,
	documentTypes.MULTIENTITYSUBPROFILE,
	documentTypes.MULTIENTITYINDIVIDUALPROFILE,
	documentTypes.ACCOUNTLEVELRISKASSESSMENT,
	documentTypes.GROUPSTRUCTUREGUIDEDWORKFLOW,
	documentTypes.GROUPINSTRUCTIONGUIDEDWORKFLOW,
	documentTypes.ALRA_INDIVIDUAL,
	documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT,
	documentTypes.GROUP_INVOLVEMENT_SUMMARY,
	documentTypes.ALRA_INDIVIDUAL_TEMPORARY
];

export const documentTypesForValidationsForExecution = [documentTypes.ACCOUNT_STANDARD_WORKING_PAPER];

export const DocumentStatus = {
	ContentInProgress: 1,
	ContentComplete: 2,
	ContentError: 3,
	ContentFullReload: 4,
	ContentUpdateInprogress: 5,
	ContentErrorFullReload: 6,
	UnlinkInProgress: 7,
	UnlinkComplete: 8,
	UnlinkError: 9,
	CanvasFormManualCreation: 10,
	FinalizeNotStarted: 11,
	FinalizeCompleted: 12,
	FinalizeDeleted: 13,
	LinkInProgress: 14,
	LinkComplete: 15,
	LinkError: 16,
	CopyInProgress: 17,
	DaaSCheckoutInProgress: 18,
	DaaSCheckoutComplete: 19,
	DaaSCheckoutError: 20,
	DaaSCheckinInProgress: 21,
	DaaSCheckinComplete: 22,
	DaaSCheckinError: 23,
	DaaSDiscardInProgress: 24,
	DaaSDiscardComplete: 25,
	DaaSDiscardError: 26
};

export const ContentContract = {
	SqlFileStreamBlob: 1,
	AzureBlob: 2,
	CanvasCustomBlob: 3,
	FileSystemBlob: 4,
	DaaS: 5
};

export const OpenInCanvasDocumentTypeIDs = [
	documentTypes.PROFILE,
	documentTypes.ACCOUNTSSUMMARY,
	documentTypes.SCOTSSUMMARY,
	documentTypes.ITSOSUMMARY,
	documentTypes.CRASUMMARY,
	documentTypes.AUDITPLAN,
	documentTypes.GROUPAUDITSTRUCTURESUMMARY,
	documentTypes.GROUPAUDITINSTRUCTIONSUMMARY,
	documentTypes.GROUPCOMPONENTSUMMARYDOCUMENT,
	documentTypes.WORKPLANSUMMARY,
	documentTypes.ITEVALUATIONSMARTFORM,
	documentTypes.ITEVALUATIONTEMPORARYSMARTFORM,
	documentTypes.CANVASFORMEVIDENCE,
	documentTypes.CANVASFORMTEMPORARY,
	documentTypes.INDEPENDENCEFORMTEMPLATE,
	documentTypes.SEM,
	documentTypes.ACCOUNT_CONCLUSION,
	documentTypes.FOUR_FORTY_GL,
	documentTypes.ARCHIVE,
	documentTypes.ACCOUNTCONCLUSIONCLASSIC,
	documentTypes.DETERMINEPMTESAD,
	documentTypes.GUIDEDWORKFLOWTEMPORARY,
	documentTypes.GUIDEDWORKFLOW,
	documentTypes.SMARTAUTOMATIONEVIDENCE,
	documentTypes.SMARTAUTOMATIONEVIDENCETEMPORARY,
	documentTypes.IT_FLOW_ISA315,
	documentTypes.PROFILEV2,
	documentTypes.LIMITEDRISKDOCUMENTATION,
	documentTypes.GUIDEDWORKFLOWV2,
	documentTypes.ESTIMATESDOCUMENT,
	documentTypes.ANALYTICSDOCUMENT,
	documentTypes.MULTIENTITYENGAGEMENTPROFILE,
	documentTypes.MULTIENTITYSUBPROFILE,
	documentTypes.MULTIENTITYINDIVIDUALPROFILE,
	documentTypes.ACCOUNTLEVELRISKASSESSMENT,
	documentTypes.PIC_CHECKLIST,
	documentTypes.EQR_CHECKLIST,
	documentTypes.GROUPSTRUCTUREGUIDEDWORKFLOW,
	documentTypes.GROUPINSTRUCTIONGUIDEDWORKFLOW,
	documentTypes.ALRA_INDIVIDUAL,
	documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT,
	documentTypes.GROUP_INVOLVEMENT_SUMMARY,
	documentTypes.ACCOUNT_STANDARD_WORKING_PAPER,
	documentTypes.ACCOUNT_STANDARD_WORKING_PAPER_TEMPORARY,
	documentTypes.ALRA_INDIVIDUAL_TEMPORARY,
	documentTypes.GUIDEDWORKFLOWV2_TEMPORARY,
	documentTypes.CONTROL_UNDERSTAND_CONTROLS,
	documentTypes.CONTROL_UNDERSTAND_CONTROLS_TEMPORARY,
	documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES,
	documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES_TEMPORARY,
	documentTypes.SCOT_WALKTHROUGH,
	documentTypes.SCOT_WALKTHROUGH_TEMPORARY,
	documentTypes.Estimate_Individual_Estimate_Temporary
];

export const DisabledDocumentTypeIDs = [
	documentTypes.KEYRISKIDENTIFICATION,
	documentTypes.MANAGEMENTPROCEDURESSUMMARY,
	documentTypes.ACCOUNTCONCLUSIONCLASSIC,
	documentTypes.LEADSCHEDULE,
	documentTypes.PAPERPROFILE,
	documentTypes.OARINTERIMCOMPARISON,
	documentTypes.OARCURRENTYEARCOMPARISON,
	documentTypes.TIEOUT,
	documentTypes.LEADSCHEDULETEMPORARYSMARTFORM,
	documentTypes.OARINTERIMCOMPARISONTEMPORARYSMARTFORM
];

export const RestrictedDocumentFileExt = [
	'png',
	'jpeg',
	'jpg',
	'gif',
	'op2',
	'ran',
	'op2',
	'tv5',
	'xltx',
	'xlam',
	'csv',
	'ms6',
	'msg',
	'one',
	'txt',
	'vsd',
	'vsdx',
	'xml',
	'zip',
	'zipx'
];

export const ReadOnlyDocumentTypeIds = [
	documentTypes.PRIORYEAREVIDENCE,
	documentTypes.CLIENTFILES,
	documentTypes.GROUPCOMPONENTINSTRUCTIONDOCUMENT,
	documentTypes.RETURNEDDOCUMENT,
	documentTypes.EYSENTTOCLIENTFILES,
	documentTypes.AUTOMATIONPARENT,
	documentTypes.AUTOMATIONHUBINPUT,
	documentTypes.AUTOMATIONHUBOUTPUT,
	documentTypes.AUTOMATIONHUBCLIENTOUTPUT,
	documentTypes.AUTOMATIONHUBOUTPUTTEMPORARY
];

export const AlwaysRenamableDocumentTypeIds = [
	documentTypes.PAPERPROFILE,
	documentTypes.GUIDEDWORKFLOWTEMPORARY,
	documentTypes.GUIDEDWORKFLOW,
	documentTypes.SMARTAUTOMATIONEVIDENCE,
	documentTypes.SMARTAUTOMATIONEVIDENCETEMPORARY
];

export const PaperProfileIds = [documentTypes.PAPERPROFILE, documentTypes.PAPERPROFILETEMPORARY];

export const GuidedWorkFlowIds = [documentTypes.GUIDEDWORKFLOWTEMPORARY, documentTypes.GUIDEDWORKFLOW];

export const SmartAutomationEvidenceIds = [
	documentTypes.SMARTAUTOMATIONEVIDENCE,
	documentTypes.SMARTAUTOMATIONEVIDENCETEMPORARY
];

export const SmartFormIds = [
	documentTypes.PROFILE,
	documentTypes.KEYRISKIDENTIFICATION,
	documentTypes.KEYRISKIDENTIFICATIONUBT,
	documentTypes.ENTITYLEVELCONTROLSSUMMARY,
	documentTypes.MANAGEMENTPROCEDURESSUMMARY,
	documentTypes.DETERMINEPMTESAD,
	documentTypes.ACCOUNTSSUMMARY,
	documentTypes.SCOTSSUMMARY,
	documentTypes.ITSOSUMMARY,
	documentTypes.CRASUMMARY,
	documentTypes.AUDITPLAN,
	documentTypes.EVALUATEAUDITRESULTS,
	documentTypes.CONFIRMFINALMATERIALITY,
	documentTypes.SUMMARYOFAUDITDIFFERENCES,
	documentTypes.ACCOUNTCONCLUSIONCLASSIC,
	documentTypes.LEADSCHEDULE,
	documentTypes.ARCHIVE,
	documentTypes.GROUPAUDITSTRUCTURESUMMARY,
	documentTypes.GROUPAUDITINSTRUCTIONSUMMARY,
	documentTypes.OARINTERIMCOMPARISON,
	documentTypes.OARCURRENTYEARCOMPARISON,
	documentTypes.GROUPCOMPONENTSUMMARYDOCUMENT,
	documentTypes.TIEOUT,
	documentTypes.WORKPLANSUMMARY,
	documentTypes.TIEOUTTEMPORARYSMARTFORM,
	documentTypes.LEADSCHEDULETEMPORARYSMARTFORM,
	documentTypes.OARINTERIMCOMPARISONTEMPORARYSMARTFORM,
	documentTypes.OARCURRENTYEARCOMPARISONTEMPORARYSMARTFORM
];

export const CanvasFormsIds = [
	documentTypes.DETERMINEPMTESAD,
	documentTypes.CANVASFORMEVIDENCE,
	documentTypes.ACCOUNT_CONCLUSION,
	documentTypes.CANVASFORMTEMPORARY,
	documentTypes.GUIDEDWORKFLOWTEMPORARY,
	documentTypes.GUIDEDWORKFLOW,
	documentTypes.LIMITEDRISKDOCUMENTATION,
	documentTypes.GUIDEDWORKFLOWV2,
	documentTypes.ESTIMATESDOCUMENT,
	documentTypes.ANALYTICSDOCUMENT,
	documentTypes.MULTIENTITYENGAGEMENTPROFILE,
	documentTypes.MULTIENTITYSUBPROFILE,
	documentTypes.MULTIENTITYINDIVIDUALPROFILE,
	documentTypes.ACCOUNTLEVELRISKASSESSMENT,
	documentTypes.PIC_CHECKLIST,
	documentTypes.EQR_CHECKLIST,
	documentTypes.GROUPSTRUCTUREGUIDEDWORKFLOW,
	documentTypes.GROUPINSTRUCTIONGUIDEDWORKFLOW,
	documentTypes.GUIDEDWORKFLOWV2_TEMPORARY,
	documentTypes.ALRA_INDIVIDUAL,
	documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT,
	documentTypes.GROUP_INVOLVEMENT_SUMMARY,
	documentTypes.ACCOUNT_STANDARD_WORKING_PAPER,
	documentTypes.ACCOUNT_STANDARD_WORKING_PAPER_TEMPORARY,
	documentTypes.ALRA_INDIVIDUAL_TEMPORARY,
	documentTypes.IT_FLOW_ISA315,
	documentTypes.CONTROL_UNDERSTAND_CONTROLS,
	documentTypes.CONTROL_UNDERSTAND_CONTROLS_TEMPORARY,
	documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES,
	documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES_TEMPORARY,
	documentTypes.SCOT_WALKTHROUGH,
	documentTypes.SCOT_WALKTHROUGH_TEMPORARY,
	documentTypes.Estimate_Individual_Estimate_Temporary
];

export const relateObjectEnableForTaskType = [2, 3, 4, 5, 6, 16, 17, 19, 20, 26];

export const taskBuildMilestoneIds = {
	ACCOUNT_BUILD_1: 1,
	RiskAssertion: 2,
	ACCOUNT_BUILD_3: 3,
	SCOT_BUILD_1: 5,
	SCOT_BUILD_2: 6,
	SCOTWCGWControls: 7,
	SCOT_BUILD_4: 8,
	WCGWAssertion: 15,
	DUE_DATE_OF_TASK: 17,
	AUDIT_PLAN_BUILD_2: 18,
	TOC: 19,
	AUDIT_PLAN_BUILD_4: 20,
	AUDIT_PLAN_BUILD_5: 21,
	PSP: 25,
	OSP: 26,
	AUDIT_PLAN_BUILD_11: 27,
	WCGWTask: 29,
	RiskWCGW: 30,
	CreateAccountWithEstimates: 31,
	CreateSCOTWithEstimates: 32,
	GROUP_BUILD_1: 33,
	GROUP_BUILD_2: 34,
	GROUP_BUILD_3: 35,
	GROUP_BUILD_4: 36,
	GROUP_BUILD_5: 37,
	IdentifyWCGWAndControls: 38,
	AssociateRiskToTaskWithWCGWTaskValidation: 39,
	GA_STRUCTURE_BUILD_1: 42,
	GA_STRUCTURE_BUILD_2: 43,
	GA_INSTRUCTIONS_BUILD_1: 45,
	GA_INSTRUCTIONS_BUILD_2: 46,
	REVIEW_BUILD_1: 49,
	REVIEW_BUILD_2: 50,
	GuidedWorkflow: 55,
	RespondToSignificantFraudRisks: 56,
	RelateSCOTWithAccountsValidationV2: 57
};

export const documentNameMaxLength = 115;

export const TaskTypeEnum = {
	CONTROL_TASK: 1,
	CONTROL_TASK_CONTROL: 2,
	CONTROL_TASK_ELC: 3,
	CONTROL_TASK_ITSO: 4,
	CONTROL_TASK_MP: 5,
	CONTROL_TASK_SO: 6,
	RESPONSE_TASK: 7,
	CASHFLOW_MISSTATEMENT_RESPONSE_TASK: 8,
	DEFICIENCY_RESPONSE_TASK: 9,
	DISCLOSURE_MISSTATEMENT_RESPONSE_TASK: 10,
	MISSTATEMENT_RESPONSE_TASK: 11,
	STANDARD_TASK: 12,
	OTHER_STANDARD_TASK: 13,
	PRIMARY_STANDARD_TASK: 14,
	SUBSTANTIVE_TASK: 15,
	OTHER_SUBSTANTIVE_PROCEDURE_TASK: 16,
	PRIMARY_SUBSTANTIVE_PROCEDURE_TASK: 17,
	WALKTHROUGH_TASK: 18,
	WALKTHROUGH_TASK_ITSO: 19,
	WALKTHROUGH_TASK_SCOT: 20,
	TODO: 21,
	ACCOUNT_CONCLUSION_TASK: 22,
	GROUP_TASK: 23,
	PRIMARY_GROUP_TASK: 24,
	COMPONENT_GROUP_TASK: 25,
	ITSO_OTHER_SUBSTANTIVE_PROCEDURE_TASK: 26,
	COMPONENT_GROUP_TASK_UNLINKED: 27
};

export const TaskTypeEnumForAddTask = {
	ImportedFromKnowledge: 14,
	Custom: 13,
	Account: 16,
	ITSubstantive: 26,
	WalkthroughTask: 20,
	ControlTask: 2,
	ITWalkthroughTask: 19,
	ITControlTask: 4
};

export const RelatedObjectTypeEnum = {
	Account: 1,
	Assertion: 2,
	Control: 3,
	ITControl: 4,
	ITProcess: 5,
	SCOT: 6
};

export const StrategyTypeIds = {
	Controls: 1,
	Substantive: 2,
	Rely: 3,
	NotRely: 4
};
export const ITApproachTypeIds = {
	Controls: 1,
	Substantive: 2
};

export const ITApproachTypeEnum = {
	1: 'ITGC',
	2: 'ITSP'
};

export const StatementTypeIds = {
	IncomeStatement: 1,
	BalanceSheet: 2,
	Both: 3
};

export const EditAssociationTabVal = {
	RISK_WCGW: 'riskwcgw',
	WCGW_TASK: 'wcgwtask'
};

export const tabsIdReviewNotes = {
	taskReviewNote: 1,
	documentReviewNote: 2
};

export const ContolRiskTypeName = {
	Rely: 1,
	NotRely: 2
};

export const AccountType = {
	Significant: 1,
	LimitedRisk: 2,
	InSignificant: 3,
	Others: 4,
	SignificantDiscloure: 5
};

export const ScotType = {
	Routine: 1,
	NonRoutine: 2,
	Estimation: 3,
	FinancialStatementCloseProcess: 4
};

export const StatementType = {
	Income: 1,
	BalanceSheet: 2,
	Both: 3
};

export const pspIndexesCount = {
	MIN_SELECTED_PSP_INDEXES: 1,
	MAX_PSP_INDEXES_SELECTED: 5
};

export const DisplayedAccountTypes = [
	{
		accountTypeName: 'Significant',
		accountTypeId: 1
	},
	{
		accountTypeName: 'Limited Risk',
		accountTypeId: 2
	}
];

export const findingType = {
	Deficiency: 1,
	Misstatement: 2
};

export const taskSourceType = {
	Internal: 1,
	External: 2
};

export const taskNatureType = {
	TestOfDetail: 1,
	SubstantiveAnalyticalProcedure: 2,
	TestOfControl: 3
};

export const TaskStatusIds = {
	Open: 1,
	InProgress: 2,
	InReview: 3,
	Complete: 4,
	Removed: 5
};

export const AssignmentStatusIds = {
	Open: 1,
	InProgress: 2,
	Closed: 3,
	Unassigned: 4
};

export const TaskRequestStatusIds = {
	Accepted: 1,
	Pending: 2,
	Rejected: 3,
	Completed: 4
};

export const GARoleTypeId = {
	Primary: 1,
	Region: 2,
	Component: 3
};

export const GAComponentDocumentStatus = {
	Open: 1,
	InProgress: 2,
	Submitted: 3,
	Returned: 4,
	InReview: 5,
	Complete: 6,
	Dismissed: 7,
	RejectInTransit: 8,
	ReturnError: 9,
	ComponentSendComplete: 9,
	ComponentDocumentReturnedfromPrimary: 10
};

export const GADocumentAssociationType = {
	Associate: 1,
	Unassociate: 2,
	Return: 3,
	Clear: 4
};

export const GroupTaskTeamType = {
	Primary: 'primary',
	Component: 'component'
};

export const OfflineTaskListFilters = {
	categoryId: 2,
	subcategoryId: 1
};

export const TaskCategory = {
	my: 1,
	all: 2,
	sas: 3,
	scot: 4,
	itso: 5,
	account: 6,
	execution: 7,
	conclusion: 8,
	teamsummary: 9,
	controls: 14,
	itcontrols: 15
};

export const ParentViewTypes = {
	MyProgress: 1,
	EngagementOverview: 2,
	AllItemView: 3,
	ReviewNotesNew: 4,
	PICProgress: 5
};

export const FilterRelatedTask = {
	related: 1,
	unrelated: 2
};

export const TaskSubCategory = {
	all: 1,
	preparer: 2,
	reviewer: 3
};

export const TeamSummaryPreparerStatus = {
	open: 1,
	inProgress: 2,
	closed: 3
};

export const TeamSummaryReviewerStatus = {
	open: 1,
	inProgress: 2,
	closed: 3
};
export const MaxFilterChipsCount = 25;
export const EnterKeyCode = 13;

export const GuidanceLinkType = {
	None: 'none',
	LegacyAtlasLink: 'legacyAtlasLink',
	ExternalLinks: 'externalLinks',
	AtlasDocument: 'atlasDocument',
	SmartAutomation: 'automationService',
	HelixAnalyzer: 'helixAnalyzer',
	ServiceDeliveryModel: 'serviceDeliveryModel'
};

export const GuidanceDocumentType = {
	None: 'none',
	GuidanceDocument: 'guidanceDocument',
	KnowledgeDocument: 'knowledgeDocument',
	GuidanceAttachment: 'guidanceAttachment'
};

export const TaskListSortFields = {
	DueDate: 'duedate',
	TaskName: 'taskname',
	Knowledge: 'knowledge'
};

export const IndependenceStatus = {
	Incomplete: 1,
	NoMattersIdentified: 2,
	MatterIdentifiedPendingAction: 3,
	MatterResolvedDeniedAccess: 4,
	MatterResolvedGrantedAccess: 5,
	NotApplicable: 6,
	Restored: 7,
	Override: 8,
	PriorMattersIdentified: 9,
	PriorPendingAction: 10,
	PriorGrantedAccess: 11,
	PriorDeniedAccess: 12
};

export const independenceActionIds = {
	createIndependenceForm: 0,
	removeTeamMember: 1,
	removeOverride: 2
};

export const activeStatus = {
	Active: 1,
	InActive: 0
};

export const EngagementStatus = {
	Active: 1,
	Suspended: 2,
	Archived: 3,
	Deleted: 4,
	ArchiveInProgress: 5,
	Reactivated: 6,
	Restored: 7,
	MarkedForDeletion: 8,
	ArchiveError: 9,
	RollForwardError: 10,
	ReactivateError: 11,
	RestoreError: 12,
	RollForwardInProgress: 13,
	ReactivateInProgress: 14,
	RestoreInProgress: 15,
	GAMXMigrationInProgress: 16,
	GAMXMigrationError: 17,
	CreateTransactionPending: 18,
	CreateTransactionFailed: 19,
	UpdateTransactionPending: 20,
	UpdateTransactionFailed: 21,
	CopyInProgress: 22,
	CopyError: 23,
	CopyTemplateError: 24,
	ExternalReviewEngagementInProgress: 25,
	ExternalReviewEngagementError: 26,
	ExternalReviewEngagement: 27,
	LocalizedToIsolatedUniversal: 28,
	LocalizedToIsolatedUniversalArchived: 29,
	ContentDeliveryInProgress: 30,
	ContentDeliveryError: 31,
	ContentDeliveryFail: 32,
	CanvasExternalAccessPortalV2: 33,
	DatacenterSplit: 100
};

export const formBodyType = {
	KnowledgeOnly: 1,
	TextResponse: 2,
	ToggleTwoButton: 3,
	ToggleThreeButton: 4,
	DropDownList: 5,
	RadioButton: 6,
	CheckBox: 7,
	RelatedWCGWsSCOTs: 8,
	NumericTextBox: 9,
	RelatedRisks: 10,
	DatePicker: 11,
	RelatedITRiskITProcess: 12,
	RelatedITApps: 13,
	WCGWTasks: 14
};

export const controlTypeIds = [
	{
		id: 1,
		label: 'itApplication'
	},
	{
		id: 2,
		label: 'itDependentManual'
	},
	{
		id: 3,
		label: 'manualPrevent'
	},
	{
		id: 4,
		label: 'manualDetect'
	}
];

export const controlFrequencyTypeIds = [
	{
		id: 1,
		label: 'manyTimesPerDay'
	},
	{
		id: 2,
		label: 'daily'
	},
	{
		id: 3,
		label: 'weekly'
	},
	{
		id: 4,
		label: 'monthly'
	},
	{
		id: 5,
		label: 'quarterly'
	},
	{
		id: 6,
		label: 'annually'
	},
	{
		id: 7,
		label: 'iTApplicationControl'
	},
	{
		id: 8,
		label: 'other'
	}
];

export const controlDesignEffectivenessTypeIds = [
	{
		id: 1,
		label: 'true'
	},
	{
		id: 2,
		label: 'false'
	}
];

export const controlDesignEffectivenessValues = {
	effective: 1,
	inEffective: 2,
	none: 0
};

export const controlDesignEffectivenessLables = {
	0: 'None',
	1: 'Effective',
	2: 'InEffective'
};

export const hasControlDesignEffectiveness = {
	true: 'true',
	false: 'false'
};

export const formAction = {
	overwriteForm: 1
};

export const controlFilters = {
	scotsFilter: 'scotsfilter',
	designEffectivenessFilter: 'designeffectivenessfilter',
	testingFilter: 'testingfilter'
};

export const numericValueRegex = /(^[0-9]+$|^$)/;

export const minPages = 1;

export const stringNull = 'null';

//RNH Constants
export const rnhQuickFilter = {
	all: 0,
	assigned: 1,
	authored: 2
};

// TODO: remove this, use reviewNoteStatusFilter
export const rnhNoteType = {
	open: '1',
	cleared: '2',
	closed: '3'
};

export const commentPriorityId = {
	low: 1,
	medium: 2,
	high: 3,
	critical: 4
};

export const rnhNotePriority = [
	{id: commentPriorityId.low, name: 'low', label: 'L'},
	{id: commentPriorityId.medium, name: 'medium', label: 'M'},
	{id: commentPriorityId.high, name: 'high', label: 'H'},
	{id: commentPriorityId.critical, name: 'critical', label: 'C'}
];

export const maxLengthTextAreaNotes = 4000;
export const ReportTypeNotSelected = 102;

export const maxLengthText = {
	maxLength100: 100,
	maxLength200: 200,
	maxLength400: 400,
	maxLength500: 500,
	maxLength4000: 4000
};

//Error codes from API
export const apiErrorCodes = {
	DuplicateDocumentName: 5082
};

export const SEMViewBy = ['task', 'romm'];

/* RNH Pagination Options */
export const reviewNotePagingOptions = {
	options: [20, 50, 100, 200]
};

export const rnhEngagementSources = {
	currentEngagement: 1,
	otherEngagement: 2,
	allEngagements: 3
};

export const KeyCode = {
	CANCEL: 3,
	HELP: 6,
	BACK_SPACE: 8,
	TAB: 9,
	CLEAR: 12,
	RETURN: 13,
	ENTER: 13,
	SHIFT: 16,
	CONTROL: 17,
	ALT: 18,
	PAUSE: 19,
	CAPS_LOCK: 20,
	ESCAPE: 27,
	SPACE: 32,
	PAGE_UP: 33,
	PAGE_DOWN: 34,
	END: 35,
	HOME: 36,
	ARROWLEFT: 37,
	ARROWUP: 38,
	ARROWRIGHT: 39,
	ARROWDOWN: 40,
	PRINTSCREEN: 44,
	INSERT: 45,
	DELETE: 46,
	KEY_0: 48,
	KEY_1: 49,
	KEY_2: 50,
	KEY_3: 51,
	KEY_4: 52,
	KEY_5: 53,
	KEY_6: 54,
	KEY_7: 55,
	KEY_8: 56,
	KEY_9: 57,
	SEMICOLON: 59,
	EQUALS: 61,
	KEY_A: 65,
	KEY_B: 66,
	KEY_C: 67,
	KEY_D: 68,
	KEY_E: 69,
	KEY_F: 70,
	KEY_G: 71,
	KEY_H: 72,
	KEY_I: 73,
	KEY_J: 74,
	KEY_K: 75,
	KEY_L: 76,
	KEY_M: 77,
	KEY_N: 78,
	KEY_O: 79,
	KEY_P: 80,
	KEY_Q: 81,
	KEY_R: 82,
	KEY_S: 83,
	KEY_T: 84,
	KEY_U: 85,
	KEY_V: 86,
	KEY_W: 87,
	KEY_X: 88,
	KEY_Y: 89,
	KEY_Z: 90,
	CONTEXT_MENU: 93,
	NUMPAD0: 96,
	NUMPAD1: 97,
	NUMPAD2: 98,
	NUMPAD3: 99,
	NUMPAD4: 100,
	NUMPAD5: 101,
	NUMPAD6: 102,
	NUMPAD7: 103,
	NUMPAD8: 104,
	NUMPAD9: 105,
	MULTIPLY: 106,
	ADD: 107,
	SEPARATOR: 108,
	SUBTRACT: 109,
	DECIMAL: 110,
	DIVIDE: 111,
	F1: 112,
	F2: 113,
	F3: 114,
	F4: 115,
	F5: 116,
	F6: 117,
	F7: 118,
	F8: 119,
	F9: 120,
	F10: 121,
	F11: 122,
	F12: 123,
	F13: 124,
	F14: 125,
	F15: 126,
	F16: 127,
	F17: 128,
	F18: 129,
	F19: 130,
	F20: 131,
	F21: 132,
	F22: 133,
	F23: 134,
	F24: 135,
	NUM_LOCK: 144,
	SCROLL_LOCK: 145,
	COMMA: 188,
	PERIOD: 190,
	SLASH: 191,
	BACK_QUOTE: 192,
	OPEN_BRACKET: 219,
	BACK_SLASH: 220,
	CLOSE_BRACKET: 221,
	QUOTE: 222,
	META: 224
};

export const annotationType = {
	note: 1,
	issue: 2,
	comment: 3,
	clientRequestComment: 4,
	systemGenerated: 5
};

export const GALinkStatus = {
	NoPointOfContact: 1,
	NotSent: 2,
	Pending: 3,
	Accepted: 4,
	Rejected: 5,
	Expired: 6,
	Unlinked: 7,
	Delegated: 8,
	SystemError: 9,
	Sent: 10,
	InvalidPointOfContact: 11,
	ComponentNotUsingCanvas: 12,
	ComponentReferenceOnly: 13
};

export const quickLinks = [
	{
		validator: (eng) => eng.hasAccountSummary,
		labelProp: 'linkAccountSummary',
		hashPath: '#accountsummary',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasScotSummary,
		labelProp: 'linkScotSummary',
		hashPath: '#scotsummary',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasItSummary,
		labelProp: 'linkITSummary',
		hashPath: '#itsummary',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasCRASummary,
		labelProp: 'linkCRASummary',
		hashPath: '#crasummary',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasGroupStructureSummary,
		labelProp: 'linkGAStructureSummary',
		hashPath: '#groupauditstructuresummary',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasGroupInstructionSummary,
		labelProp: 'linkGAInstrcutionSummary',
		hashPath: '#groupauditinstructionsummary',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasSubstantiveEvaluationMatrix,
		labelProp: 'linkSEM',
		customPath: (eng) => `/smartscreens/sem?engagementId=${eng.engagementId}&documentid=${eng.semDocumentId}`,
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasAuditPlanSummary,
		labelProp: 'linkAuditPlan',
		hashPath: '#plan',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: (eng) => eng.hasWorkPlanSummary,
		labelProp: 'linkWorkPlan',
		hashPath: '#plan',
		auditPhaseId: AuditPhases.ScopeAndStrategy
	},
	{
		validator: () => true,
		labelProp: 'linkGeneral',
		taskCategoryId: TaskCategories.ExecutionGeneral,
		auditPhaseId: AuditPhases.Execution
	},
	{
		validator: (eng) => eng.hasScotSummary,
		labelProp: 'linkScots',
		taskCategoryId: TaskCategories.ExecutionSCOTs,
		auditPhaseId: AuditPhases.Execution
	},
	{
		validator: (eng) => eng.hasItSummary,
		labelProp: 'linkITSO',
		taskCategoryId: TaskCategories.ExecutionITSOs,
		auditPhaseId: AuditPhases.Execution
	},
	{
		validator: (eng) => eng.hasITProcessEvaluation,
		labelProp: 'linkITProcessEvaluation',
		hashPath: ({itEvaluationDocumentId}) => `#itevaluation/${itEvaluationDocumentId}`,
		auditPhaseId: AuditPhases.Execution
	},
	{
		validator: (eng) => eng.hasAccountSummary,
		labelProp: 'linkAccounts',
		taskCategoryId: TaskCategories.ExecutionAccounts,
		auditPhaseId: AuditPhases.Execution
	},

	{
		validator: () => true,
		labelProp: 'linkWrapupEngagement',
		taskCategoryId: TaskCategories.Conclusion,
		auditPhaseId: AuditPhases.ConclusionAndWrapup
	},
	{
		validator: () => true,
		labelProp: 'linkArchive',
		customPath: ({engagementId}) => `/archivetimeline?engagementid=${engagementId}`,
		auditPhaseId: AuditPhases.ConclusionAndWrapup
	}
];

export const rnhFilterTypeQuery = {
	dueBefore: 'duedateend',
	dueAfter: 'duedatestart',
	authoredBy: 'reviewnotesauthoredby',
	assignedTo: 'reviewnotesassignedto',
	priority: 'prioritytype',
	annotationStatusIds: 'annotationStatusIds'
};

export const ReviewNoteSubViewTypes = {
	assignedToMe: 'assignedToMe',
	authoredByMe: 'authoredByMe',
	showAll: 'showAll'
};
export const clientRequestsFilterTypeQuery = {
	timephases: 'TimePhases',
	tags: 'tags',
	assignedTo: 'assignedTo'
};

export const rnParentTypes = {
	calledFromMest: 1,
	calledFromMyProgress: 2,
	calledFromPicProgress: 3,
	calledFromNewReviewNoteView: 4
};

export const reviewNoteDueDateRange = {
	overDueGreaterThan90: '0',
	overDue31To90: '1',
	overDue10To30: '2',
	overDueLessThan10: '3',
	future10: '4',
	future10To30: '5',
	future31To90: '6',
	futureMoreThan90: '7'
};

export const numberFormatsListItems = [
	{
		id: 0,
		locale: 'en-au',
		label: '1,234,567,890'
	},
	{
		id: 1,
		locale: 'en-in',
		label: '1,23,45,67,890'
	},
	{
		id: 2,
		locale: 'en-za',
		label: '1 234 567 890'
	},
	{
		id: 3,
		locale: 'pt-br',
		label: '1.234.567.890'
	}
];

export const daysUntilPermanentDeletion = 90;

export const defaultDateFormat = 0;
export const defaultDateFormat2 = 2;

export const queryFilterUser = {
	createdBy: 7,
	assignedTo: 8
};

export const TimephaseTypesEnum = {
	Scope: 1,
	Strategy: 2,
	Walkthroughs: 3,
	InterimControlTesting: 4,
	InterimSubstantiveTesting: 5,
	Walkthroughs_YearEndProcesses: 6,
	Year_end_ControlTesting: 7,
	Year_end_SubstantiveTesting: 8,
	Conclusion: 9,
	NA: 10,
	Execution: 11,
	ScopeAndStrategyProjectManagement: 12,
	OtherScopeAndStrategy: 13,
	CRA: 14,
	RiskAssessmentAndMateriality: 15,
	FinalizeScopeAndStrategy: 16,
	Post_InterimProjectManagement: 17
};

export const clientSideEventNames = {
	onRailChange: 'onRailChange',
	onFormChange: 'onFormChange',
	railSectionChange: 'railSectionChange',
	setSelectedAssertionName: 'setSelectedAssertionName',
	getScotsForAssertion: 'getScotsForAssertion',
	resize: 'resize',
	updateHeaderValidations: 'updateHeaderValidations',
	updateSectionValidations: 'updateSectionValidations',
	updateBodyValidations: 'updateBodyValidations',
	getContentUpdateHistoryFromAPI: 'getContentUpdateHistoryFromAPI',
	closeDraggableModal: 'closeDraggableModal'
};

export const updateAnnotationAction = {
	bulkUpdate: 0,
	editNote: 1,
	editReply: 2,
	replyNote: 3,
	bulkStatusUpdate: 4,
	deleteReply: 5
};

export const timeLineRanges = {
	lessThenTwo: {
		maxValue: 2
	},
	lessThenFive: {
		maxValue: 5
	},
	lessThenEleven: {
		maxValue: 11
	}
};

export const addTaskSteps = {
	TaskTypeSelection: 'TaskTypeSelection',
	RelateObject: 'RelateObject',
	TaskDetails: 'TaskDetails',
	TaskAssignments: 'TaskAssignments'
};

export const AddCustomTaskStepsIndex = {
	TaskTypeSelection: 0,
	TaskDetails: 1,
	TaskAssignments: 2
};

export const AddNonCustomTaskStepsIndex = {
	TaskTypeSelection: 0,
	RelateObject: 1,
	TaskDetails: 2,
	TaskAssignments: 3
};

export const AddNoteStepsIndex = {
	NoteTypeSelection: 0,
	DocumentOrTaskSelection: 1,
	NoteDetails: 2
};

export const addNoteSteps = {
	NoteTypeSelection: 'NoteTypeSelection',
	DocumentOrTaskSelection: 'DocumentOrTaskSelection',
	NoteDetails: 'NoteDetails',
	TaskAssignments: 'TaskAssignments'
};

export const dataSortingOrder = {
	knowledgeDisplayOrder: 'knowledgeDisplayOrder',
	name: 'name',
	label: 'label',
	customLabel: 'customLabel'
};

export const userType = {
	External: 1,
	Internal: 2,
	Reviewers: 3,
	Preparers: 4,
	Handoff: 5,
	UserSummary: 6,
	IndependenceConfirmations: 9,
	AssignedResources: 1,
	EYContacts: 2,
	ResourceManagers: 3,
	EngagementManagers: 4
};

export const EngagementRoles = {
	PartnerInCharge: 1,
	EngagementPartner: 2,
	ExecutiveDirector: 3,
	Principal: 4,
	SeniorManager: 5,
	Manager: 6,
	Senior: 7,
	Staff: 8,
	EngagementQualityReviewer: 10,
	OtherPartner: 11,
	GdsStaff: 12,
	GeneralCounsel: 16,
	AuditQualityReviewer: 17,
	GdsSenior: 30,
	GdsManager: 31
};

export const RoleForMember = [
	{
		value: EngagementRoles.Staff,
		label: 'Staff',
		type: 'role',
		order: 1
	},
	{
		value: EngagementRoles.Senior,
		label: 'Senior',
		type: 'role',
		order: 2
	},
	{
		value: EngagementRoles.Manager,
		label: 'Manager',
		type: 'role',
		order: 3
	},
	{
		value: EngagementRoles.SeniorManager,
		label: 'Senior Manager',
		type: 'role',
		order: 4
	},
	{
		value: EngagementRoles.ExecutiveDirector,
		label: 'Executive Director',
		type: 'role',
		order: 5
	},
	{
		value: EngagementRoles.Principal,
		label: 'Principal',
		type: 'role',
		order: 6
	},
	{
		value: EngagementRoles.OtherPartner,
		label: 'Other Partner',
		type: 'role',
		order: 7
	},
	{
		value: EngagementRoles.EngagementPartner,
		label: 'Engagement Partner',
		type: 'role',
		order: 8
	},
	{
		value: EngagementRoles.PartnerInCharge,
		label: 'Partner in Charge',
		type: 'role',
		order: 9
	},
	{
		value: EngagementRoles.EngagementQualityReviewer,
		label: 'Engagement Quality Reviewer',
		type: 'role',
		order: 10
	},
	{
		value: EngagementRoles.AuditQualityReviewer,
		label: 'Audit Quality Reviewer',
		type: 'role',
		order: 11
	},
	{
		value: EngagementRoles.GeneralCounsel,
		label: 'General Counsel',
		type: 'role',
		order: 12
	},
	{
		value: EngagementRoles.GdsStaff,
		label: 'GDS Staff',
		type: 'role',
		order: 13
	},
	{
		value: EngagementRoles.GdsSenior,
		label: 'GDS Senior',
		type: 'role',
		order: 14
	},
	{
		value: EngagementRoles.GdsManager,
		label: 'GDS Manager',
		type: 'role',
		order: 15
	}
];

export const promiseAreas = {
	MILESTONE_DETAILS_AREA: 'MILESTONE_DETAILS_AREA',
	QUICK_LINK_AREA: 'QUICK_LINK_AREA',
	REVIEWNOTE_SUMMARY_AREA: 'REVIEWNOTE_SUMMARY_AREA',
	USERROLE_SELECTION_AREA: 'USERROLE_SELECTION_AREA',
	TASK_LIST_AREA: 'TASK_LIST_AREA',
	ENGAGEMENT_METRICS_AREA: 'ENGAGEMENT_METRICS_AREA',
	TASK_DETAILS_AREA: 'TASK_DETAILS_AREA',
	GROUP_AUDIT_TASK_AREA: 'GROUP_AUDIT_TASK_AREA',
	BUILD_TASK_LIST: 'BUILD_TASK_LIST',
	TAG_ASSOCIATE_UNASSOCIATE_AREA: 'TAG_ASSOCIATE_UNASSOCIATE_AREA',
	SERVICE_REQUESTS_AREA: 'SERVICE_REQUESTS_AREA',
	SERVICE_REQUEST_DETAIL_AREA: 'SERVICE_REQUEST_DETAIL_AREA',
	SERVICE_REQUEST_SAVE_AREA: 'SERVICE_REQUEST_SAVE_AREA',
	SDM_SUMMARY_AREA: 'SDM_SUMMARY_AREA',
	TASK_DETAILS_EVIDENCE: 'TASK_DETAILS_EVIDENCE',
	TASK_GUIDANCE_CONTENT: 'TASK_GUIDANCE_CONTENT',
	GET_DOCUMENT_TASKDETAILS: 'GETDOCUMENTS',
	GET_ALL_DOCUMENTS: 'GET_ALL_DOCUMENTS',
	Apply_SignOff_And_ChangeTaskStatus: 'Apply_SignOff_And_ChangeTaskStatus',
	Handoff_CreateTaskAssignment: 'Handoff_CreateTaskAssignment',
	HandOff_DeleteTaskAssignment: 'HandOff_DeleteTaskAssignment',
	AddTask_CreateTask: 'AddTask_CreateTask',
	SEND_DOCUMENTS_FROM_CGT_TO_PGT: 'SEND_DOCUMENTS_FROM_CGT_TO_PGT',
	MANAGE_ASSIGNMENTS_AREA: 'MANAGE_ASSIGNMENTS_AREA',
	GET_VALIDATIONS_AREA: 'GET_VALIDATIONS_AREA',
	GET_GROUP_AUDIT_COMPONENTS_DASHBOARD: 'GET_GROUP_AUDIT_COMPONENTS_DASHBOARD',
	GET_DASHBOARD_DOCUMENT_LIST: 'GET_DASHBOARD_DOCUMENT_LIST',
	GET_CATEGORY_NEXT_PAGE: 'GET_CATEGORY_NEXT_PAGE',
	CHANGE_PAGE_CATEGORY_PAGE_SIZE: 'CHANGE_PAGE_CATEGORY_PAGE_SIZE',
	LOAD_COMPONENT_INSTRUCTIONS: 'LOAD_COMPONENT_INSTRUCTIONS',
	SERVICE_REQUEST_USERS_SAVE_AREA: 'SERVICE_REQUEST_USERS_SAVE_AREA',
	GET_SAVED_FILTERS: 'GET_SAVED_FILTERS',
	UPDATE_EP_EQR_SIGNOFF: 'UPDATE_EP_EQR_SIGNOFF',
	HO_TASK_DETAILS_EVIDENCE: 'TASK_DETAILS_EVIDENCE',
	HO_Apply_SignOff_And_ChangeTaskStatus: 'Apply_SignOff_And_ChangeTaskStatus',
	HO_MANAGE_ASSIGNMENTS_AREA: 'MANAGE_ASSIGNMENTS_AREA',
	HO_Handoff_CreateTaskAssignment: 'Handoff_CreateTaskAssignment',
	HO_GET_STATUS_ASSIGNMENTS: 'HO_GET_STATUS_ASSIGNMENTS',
	GET_MATERIALITY: 'GET_MATERIALITY',
	GET_KEY_DOCUMENTS: 'GET_KEY_DOCUMENTS',
	DRILLDOWN_ENTITY_AREA: 'DRILLDOWN_ENTITY_AREA',
	SUPER_MODAL_NAVIGATION_CALL: 'SUPER_MODAL_NAVIGATION_CALL',
	GET_ALL_STENTITIES_FOR_TASK: 'GET_ALL_STENTITIES_FOR_TASK',
	GET_TRIAL_BALANCE: 'GET_TRIAL_BALANCE',
	GET_TRIAL_BALANCE_BY_ID: 'GET_TRIAL_BALANCE_BY_ID'
};

export const engagementUserStatus = {
	Undefined: 0,
	Active: 1,
	Pending: 2,
	Rejected: 3,
	DeActivated: 4,
	RequestForArchiveAccess: 5,
	RejectArchiveAccess: 6,
	CopyEngagementInactive: 7,
	UnlinkedInactive: 8,
	TemplateInactive: 9,
	RollForwardInactive: 10,
	LocalizedToIsolatedUniversal: 11,
	InvitationInProgress: 12,
	ScheduledInactive: 13
};

export const UserLookupType = {
	NotSpecified: 0,
	Internal: 1,
	External: 2,
	ThirdPartyUser: 3
};

export const UserERPTypeId = {
	NotSpecified: 0,
	Internal: 1,
	External: 2,
	Both: 3,
	ThirdPartyUser: 4
};

export const rbacSections = {
	NotSpecified: 0,
	Confidentiality: 1,
	Permissions: 2,
	Restrictions: 3
};

export const rbacRoleKeys = {
	NotSpecified: 0,
	defaultRole: 1,
	adminRole: 4,
	ThirdPartyUserReadOnly: 14,
	LowConfidentialDocumentsRole: 10,
	ModerateConfidentialDocumentsRole: 12,
	HighConfidentialDocumentsRole: 11,
	StrictlyConfidentialDocumentsRole: 13,
	InternalReviewOnlyRole: 16,
	IndependenceOnlyRole: 37
};

export const DocumentChangeTypes = {
	NonAdministrativeChange: 1,
	AcceptingRevisions: 2,
	AdditionalCrossReferencing: 3,
	AddingOriginalConfirmation: 4,
	CosmeticChange: 5,
	CompletingFormAP: 6,
	DeletingDiscardingDocumentation: 7,
	PreparingManagementLetter: 8,
	SignOffCompletionChecklist: 9,
	SortingCollatingCrossRefDoc: 10
};

export const EngagementSource = {
	RollForward: 1,
	Restore: 2,
	CopyEngagement: 3,
	CreateNew: 4,
	EngagementTemplate: 5,
	ExternalReviewEngagement: 6,
	GCOEngagement: 7,
	RestoreException: 8,
	CEAPortalV2: 9,
	CanvasExternalAccessPortalV2: 10,
	CopyEngagementReviewOnly: 12
};

export const ReviewTypeSourceIds = [
	EngagementSource.RestoreException,
	EngagementSource.CEAPortalV2,
	EngagementSource.CopyEngagementReviewOnly
];

export const documentReviewsAuthorizedRoleIds = [1, 2, 3, 4, 5, 6, 10, 11];

// external user
export const externalUserDefaultValue = {
	preferredContactNo: '99999',
	datetimeFormat: 1,
	numberFormat: 1,
	roleId: 1,
	primaryOffice: 'USA'
};

export const internalErrorCodeForDisplayMessage = {
	alreadyActiveEngagementUser: '7012',
	alreadyActiveEngagementUserForPostArchive: '7075'
};

export const externalErrorCodeForDisplayMessage = {
	invalidGroups: '7015',
	activeMemberExistInGroup: '7016',
	invalidDomain: '7017',
	reactivateInvalidDomain: '7065',
	invalidGroupsForEdit: '7069',
	showWarningMessageForPatchall: '7062'
};

// internal users
export const internalUserDefaultValue = {
	preferredContactNo: '99999',
	datetimeFormat: 1,
	numberFormat: 1,
	primaryOffice: 'USA'
};

export const sendRequestDisplayMessageDuration = 2000;
export const successMessageDisplayDuration = 3000;

export const successMessageDisplayDurationV2 = 5000;
export const profileContentTypeId = '3';
export const contentUpdatePSPs = '5';
// Milestone default progress values

export const milestoneProgressValues = {
	progress0: 0,
	progress25: 25,
	progress100: 100
};

// We can use it to save proprty name or attribute name used in javascript object
export const objectAttributesNameValue = {
	viewByTimephase: 'viewbytimephase'
};

export const TaskTypesFilter = {
	epSignoffRequired: 999,
	eqrSignoffRequired: 1000,
	groupTask: 23
};

export const roleType = {
	preparer: 'Preparer',
	reviewers: 'Reviewers',
	rbacRoles: 'RbacRoles'
};

export const roleTypeFilter = {
	pic: 'Partner in Charge',
	eqr: 'Engagement Quality Reviewer'
};

export const extractSquareBracketFromString = /\[.*?\]/g;

export const replaceSqareBracketToBlankValue = /[\[\]']+/g;

export const engagementActivityStatus = {
	InProgress: 1,
	Error: 2,
	Completed: 3,
	ErrorAddingUsersInGDC: 4,
	InQueue: 5
};

//#region Master data

export const userStatus = {
	undefined: 0,
	active: 1,
	pending: 2,
	rejected: 3,
	deActivated: 4,
	requestForArchiveAccess: 5,
	rejectArchiveAccess: 6,
	copyEngagementInactive: 7,
	unlinkedInactive: 8,
	templateInactive: 9,
	rollForwardInactive: 10,
	localizedToIsolatedUniversal: 11,
	invitationinProgress: 12,
	scheduledInactive: 13
};

//#endregion

//#region Filter Values

export const filters = {
	reviewNoteStatus: {
		open: 1,
		closed: 3,
		cleared: 2
	},
	fileExtension: {
		canvasForm: 'canvasForm',
		email: 'email',
		excel: 'excel',
		paperProfile: 'paperprofile',
		pdf: 'pdf',
		powerPoint: 'powerpoint',
		smartAutomation: 'smartAutomation',
		visio: 'visio',
		word: 'word',
		zip: 'zip',
		other: 'others'
	},
	documentContent: {
		trackedChanges: 1,
		comments: 2,
		highlightsWordFilesOnly: 3,
		hiddenSheets: 4,
		formulaError: 5,
		embeddedFiles: 6,
		ProtectedFiles: 7,
		DocumentContentNotAvailable: 8,
		DocumentsInCollaborationMode: 9
	},
	sharedEvidence: {
		source: 1,
		target: 2
	},
	findings: {
		misstatement: 1,
		deficiency: 2
	},
	canvasForms: {
		incompleteResponses: 1,
		unresolvedComments: 2
	},
	signoffRequirements: {
		picMandatory: 1,
		picTeamAssigned: 2,
		eqrMandatory: 3,
		eqrTeamAssigned: 4
	},
	missingRelatedTask: {
		picSignoffRequired: 1,
		eqrSignoffRequired: 2
	},
	responsiveToRisk: {
		responsiveToSignificantRisk: 1,
		responsiveToFraudRisk: 2,
		responsiveToHigherInherentRisk: 100
	}
};

export const clientGroupUserStatus = {
	active: 1,
	deActivated: 2,
	removed: 3
};

export const ValidationGroup = {
	ArchiveTimelineFinalizeEvidence: 10001,
	ArchiveTimelineCompleteRemainingTasks: 10002,
	ArchiveTimelineResolveValidations: 10003,
	AccountConclusion: 10004,
	SubstantiveEvaluationMatrix: 10005,
	FourFortyGl: 10006,
	RiskWithNoRelatedSubstantiveTask: 10007,
	RiskWithNoRelatedWcgw: 10008,
	DashboardScopeAndStrategy: 10009,
	DashboardExecution: 10010,
	DashboardConclusion: 10011,
	IndependenceValidations: 10013,
	ManageTeamPersonResponsible: 10020
};
export const validationGroups = {AdjustmentModuleValidation: 'adjustmentModuleValidation'};

export const ValidationSubGroupsForDashboard = {
	IndependenceCompliance: 9008,
	AccoutSummary: 9001,
	ScotSummary: 9002,
	ItFlowCanvasForm: 9014,
	ItSummary: 9004,
	CraSummary: 9003,
	AuditPlan: 9005,
	SubstantiveEvaluationMatrix: 9011,
	ValidationsByCanvasForm: 9012,
	ITEvaluation: 9009,
	UnrelatedMisstatements: 49,
	UnrelatedDeficiencies: 50,
	DuplicateFileNames: 44,
	UnresolvedConflicts: 38,
	ModificationsAfterTheReportReleaseDate: 9013,
	GuidedWorkflowCanvasForm: 9015,
	CanvasFormsWithNoContent: 71,
	PersonInCharge: 95
};

//#endregion

//#region ArcTimeline
export const ArcTimelineTypeButton = {
	icon: 1,
	toggle: 2,
	none: 3
};

export const ArcTimelineGroupType = {
	validation: 1,
	checksList: 2
};

export const ArcTimelineGroups = {
	FinalizeEvidence: 10001,
	CompleteRemainingTasks: 10002,
	ResolveValidations: 10003,
	PrepareForArchive: 7,
	MiscValidations: 10022 // PersonInCharge validation group
};

export const ArcPrepareTypes = {
	EngagementDates: 20,
	EngagementCodes: 21,
	ConfirmAccuracy: 22,
	UnlinkEngagement: 24,
	ValidateReport: 25
};

export const ArcCheckLstTypes = {
	FinalizedHardEvidence: 7,
	UnlinkGroupEvidence: 10,
	UnlinkSharedEvidence: 9,
	AccuracyEngagementDates: 13,
	AccuracyEngagementCodes: 14,
	AccuracyClientCodes: 15,
	ReportType: 16,
	ReviewTemporaryFilesModifiedAfterRRD: 17,
	ReviewDeletedFilesModifiedAfterRRD: 18,
	EngagementProfileSubmit: 19,
	ReviewProtectedDocuments: 20,
	PersonInCharge: 95
};

export const FormStatus = {
	ContentInProgress: 1,
	ContentError: 3,
	ContentUpdateInprogress: 5,
	ContentErrorFullReload: 6
};

export const ArcCheckLstTypesObject = {
	[ArcCheckLstTypes.ReviewTemporaryFilesModifiedAfterRRD]: {
		url: `${documentRoutes.document}?category=documents?engagementid={ENGAGEMENTID}&view=temporaryFiles&filtermodifiedafter={MODIFIEDDATE}#engagementOverview`,
		display: true,
		type: 'ReviewTemporaryFilesModifiedAfterRRD',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.ReviewDeletedFilesModifiedAfterRRD]: {
		url: `${documentRoutes.document}?category=documents?engagementid={ENGAGEMENTID}&view=recentlyDeleted&filtermodifiedafter={MODIFIEDDATE}#engagementOverview`,
		display: true,
		type: 'ReviewDeletedFilesModifiedAfterRRD',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.FinalizedHardEvidence]: {
		url: `{CANVASURL}#archive/{DOCUMENTARCHIVEURL}`,
		isExternalUrl: true,
		display: true,
		type: 'FinalizedHardEvidence',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.ReviewProtectedDocuments]: {
		url: `${documentRoutes.document}?category=documents?filterdocumentcontent=${filters.documentContent.ProtectedFiles}&engagementid={ENGAGEMENTID}#engagementOverview`,
		isExternalUrl: true,
		display: true,
		type: 'ReviewProtectedDocuments',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.UnlinkGroupEvidence]: {
		url: '#',
		display: false,
		flag: 'isGroupAuditEngagement',
		type: 'UnlinkGroupEvidence',
		typeButton: ArcTimelineTypeButton.icon
	},
	[ArcCheckLstTypes.EngagementProfileSubmit]: {
		url: '{PROFILEURL}',
		isExternalUrl: true,
		display: true,
		flag: '',
		type: '',
		typeButton: ArcTimelineTypeButton.icon
	},
	[ArcCheckLstTypes.UnlinkSharedEvidence]: {
		url: '#',
		display: false,
		flag: '',
		type: '',
		typeButton: ArcTimelineTypeButton.icon
	},
	[ArcCheckLstTypes.AccuracyEngagementDates]: {
		url: `{ZEUSURL}/editengagement?workspaceid={WORKSPACEID}&engagementid={ENGAGEMENTID}`,
		isExternalUrl: true,
		display: true,
		type: 'AccuracyEngagementDates',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.AccuracyEngagementCodes]: {
		url: `{ZEUSURL}/editengagement?workspaceid={WORKSPACEID}&engagementid={ENGAGEMENTID}`,
		isExternalUrl: true,
		display: true,
		type: 'AccuracyEngagementCodes',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.AccuracyClientCodes]: {
		url: `{ZEUSURL}/editworkspace?workspaceid={WORKSPACEID}`,
		isExternalUrl: true,
		display: true,
		type: 'AccuracyClientCodes',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.ReportType]: {
		url: `{CANVASURL}#archive/{DOCUMENTARCHIVEURL}`,
		isExternalUrl: true,
		display: true,
		type: 'ReportType',
		typeButton: ArcTimelineTypeButton.toggle
	},
	[ArcCheckLstTypes.PersonInCharge]: {
		url: `manageteam?engagementid={ENGAGEMENTID}`,
		isExternalUrl: false,
		display: false,
		type: '',
		typeButton: ArcTimelineTypeButton.icon
	}
};

export const validationTypes = {
	IndependenceCompliance: 1,
	IndependenceFormversionNotCurrent: 2,
	UserAccessTobeReviewed: 3,
	OverrideByIneligibleRole: 4,
	UnrelatedSCOTs: 5,
	UnrelatedControls: 6,
	ControlsStrategySelectedWithNoRelatedWCGWs: 7,
	ControlSstrategySelectedWithNoRelatedControls: 8,
	ControlsStrategySelectedWithNoRelatedControlSelectedForTesting: 9,
	ControlsstrategyselectedandthereisaWCGWwithnorelatedControlsSelectedForTesting: 10 /*seriously*/,
	UnrelatedRisks: 11,
	CompleteCRAforThisAssertion: 12,
	UnrelatedWCGWs: 13,
	SignificantAccountHasNorelatedSCOTs: 14,
	RelystrategySelectedWithNoRelatedWCGWs: 15,
	RelystrategySelectedWithNoRelatedControls: 16,
	RelystrategySelectedWithNoRelatedControlsSelectedForTesting: 17,
	RelystrategySelectedAndThereisaWCGWwithnorelatedControlsSelectedForTesting: 18,
	ITSummary: 19,
	ConfirmAccuracyOfAuditorReport: 20,
	CompleteArchiveForm: 21,
	CompleteArchiveTask: 22,
	UnlinkGroupSharedEvidence: 23,
	NorelatedControlsITSubstantiveProceduresSelectedForTesting: 24,
	ThereisaRiskWithNorelatedControlsITSubstantiveProceduresSelectedForTesting: 25,
	AuditPlan: 26,
	NoSubstantiveTasksareRelatedtotheAssertion: 27,
	UnrelatedTOC: 28,
	UnrelatedWalkthrough: 29,
	NoWalkthroughTasksAreRelatedtotheSCOT: 30,
	NoControlTasksareRelatedtoaControlSelectedForTesting: 31,
	UnrelatedITSOWalkthrough: 32,
	UnrelatedITSOTOC: 33,
	UnrelatedITSOOSP: 34,
	TheITSOProcessDoesNotHaveaRelatedWalkthroughtask: 35,
	AControlDoesNotHaveaRelated: 36,
	AITSubstantiveProcedureDoesNotHaveaRelatedOSP: 37,
	RemainingDocumentConflicts: 38,
	SyncConflictSharedEvidenceNotDisplayedinCanvasValidationCount: 39,
	SignoffOnAllEvidence: 40,
	AddEvidenceToTaskWithoutEvidence: 41,
	InvalidEngagementCode: 42,
	InvalidClientCode: 43,
	DuplicateFileNames: 44,
	ITEvaluation: 45,
	InconsistentITEvaluations: 46,
	IncompleteAggregateITEvaluation: 47,
	ResponseIncomplete: 48,
	UnassociateFinding: 49,
	UnassociatedDeficiency: 50,
	SubstantiveEvaluationMatrix: 51,
	CRASummary: 52,
	AccountsSummary: 53,
	SCOTsSummary: 54,
	EstimateSCOTwithoutEstimateAccount: 55,
	AssertionwithcontrolriskofrelywithoutaresponsiveTOC: 56,
	AssertionWithControlRiskofrelyWithoutAtleastoneResponsive: 57,
	AssertionWithoutResponsiveSubstantiveTask: 58,
	AssertionWithoutaResponsiveControl: 59,
	CanvasFromComments: 60,
	FinalizeIncompleteCanvasFromResponses: 61,
	AddressOpenReviewNotes: 62,
	RemoveTrackChangesFromEvidence: 63,
	MarkTasksComplete: 64,
	UnlinkSharedEvidence: 65,
	DocumentsWithoutModificationType: 66,
	NonAdminChangesWithoutChangeReason: 67,
	UnapprovedModificationsForNonAdminChangesByAppropriateRole: 68,
	FourFortyMissingExecReviewerSignOff: 69,
	GroupEngagementThatHasNotBeenUnlinked: 70,
	CanvasFormsWithNoContent: 71,
	GroupComponentSummaryDocumentMissingContent: 72,
	ZeroByteElectronicFiles: 75,
	IndependenceViewTemplateNotSubmitted: 77,
	InconsistentRiskTaskRelationships: 92,
	PersonInCharge: 95,
	RiskFactorsUnrelatedToARiskOrMarkedAsNotARomm: 96,
	RisksUnrelatedToAnAssertionForGuidedWorkflow: 97,
	IncompleteMeasurementBasisForecastAmount: 98,
	IncompleteMeasurementBasisForecastAmountRationale: 99,
	IncompleteMeasurementBasisAdjustedAmount: 100,
	IncompletePlanningMateriality: 101,
	PlanningMaterialityGreaterThanMaximumAmount: 102,
	IncompletePlanningMaterialityRationale: 103,
	IncompleteTolerableError: 104,
	TeNotWithinRangeOfAllowedValues: 105,
	IncompleteTolerableErrorRationale: 106,
	IncompleteSad: 107,
	SadGreaterThanMaximum: 108,
	IncompleteSadRationale: 109,
	PICTaskWithoutAtLeastOneRelatedPICEvidence: 112,
	EQRTaskWithoutAtLeastOneRelatedEQREvidence: 113,
	PICEvidenceWithoutAtLeastOneRelatedPICTask: 114,
	EQREvidenceWithoutAtLeastOneRelatedEQRTask: 115,
	FinalizeCompleteAllPICSignoffRequirements: 116,
	FinalizeCompleteAllEQRSignoffRequirements: 117,
	FinalizeSmartAutomationEvidenceFiles: 118,
	TempFilesWithPreparerAndReviewerSignoffsError: 119,
	allOpenOrClearedCanvasFormComments: 120,
	TemporaryFilesWithPICRequirementUserOrKnowledge: 121,
	TemporaryFileWithEQRRequirementUserOrKnowledge: 122,
	DeletedFilesWithPICRequirementUserOnly: 123,
	DeletedFilesWithEQRRequirementUserOnly: 124,
	DocumentIsNotFinalized: 126,
	DocumentAssociatedToInvalidObject: 142,
	EstimateHigherLowerWithoutRelatedEstimateAccount: 154,
	EstimateHigherLowerRelatedToNonEstimateAccount: 155,
	RiskOrEstimateDoesNotMatchAction: 156,
	EstimateHigherLowerWithoutRelatedEstimateSCOT: 157,
	AccountWithEstimateWithoutRelatedHigherOrLowerEstimate: 158,
	EstimateSummaryEstimateAccountWithoutHigherOrLowerEstimate: 159,
	EstimateSummaryEstimateSCOTWithoutHigherOrLowerEstimate: 160,
	EstimateHigherRiskEstimateWithoutRelatedRisk: 162,
	DocumentCheckedOutOrInProcessOfBeingCheckedOutForCollaboration: 163,
	RelateEvidenceToEntityTask: 164,
	DocumentSignoffRequirementsDoNotMatchAction: 165,
	EstimateWithSigFraudRiskButNotHigherRisk: 166
};

export const hiddenValidationErrorCodes = {
	GroupEngagementUnlinked: 32224,
	GroupComponentSummary: 32226,
	ZeroSizeDocument: 32227
};

// #region Arc Timeline Validation Types
export const ArcTimeLineValidationTypes = {
	DocumentConflict: validationTypes.RemainingDocumentConflicts,
	DocumentsInMultiUserEditMode: validationTypes.DocumentCheckedOutOrInProcessOfBeingCheckedOutForCollaboration,
	DocumentIsNotFinalized: validationTypes.DocumentIsNotFinalized,
	AddressAllOpenReviewNotes: validationTypes.AddressOpenReviewNotes,
	RemoveTrackedChangesFromEvidence: validationTypes.RemoveTrackChangesFromEvidence,
	FinalizeCompleteAllPICSignoffRequirements: validationTypes.FinalizeCompleteAllPICSignoffRequirements,
	FinalizeCompleteAllEQRSignoffRequirements: validationTypes.FinalizeCompleteAllEQRSignoffRequirements,
	FinalizeSmartAutomationEvidenceFiles: validationTypes.FinalizeSmartAutomationEvidenceFiles,
	EvidencemissingSignoffs: validationTypes.SignoffOnAllEvidence,
	CanvasFormComment: validationTypes.allOpenOrClearedCanvasFormComments,
	UnlinkedSharedEvidence: validationTypes.UnlinkSharedEvidence,
	TaskswithoutEvidence: validationTypes.AddEvidenceToTaskWithoutEvidence,
	MarkTasksComplete: validationTypes.MarkTasksComplete,
	AccountsSummary: 9001,
	ScotSummary: 9002,
	CraSummary: 9003,
	ITSummary: 9004,
	AuditPlan: 9005,
	WorkPlan: 9006,
	UnassociateFinding: 9007,
	IndependenceCompliance: 9008,
	ConfirmAccuracyOfAuditorReport: validationTypes.ConfirmAccuracyOfAuditorReport,
	CompleteArchiveForm: validationTypes.CompleteArchiveForm,
	CompleteArchiveTask: validationTypes.CompleteArchiveTask,
	UnlinkGroupSharedEvidence: validationTypes.UnlinkGroupSharedEvidence,
	CanvasFormsWithNoContent: validationTypes.CanvasFormsWithNoContent,
	WCGWwithNoRelatedsubstantivetask: 9011,
	ITEvaluation: 9009,
	DocumentModifiedAfterReportReleaseDate: 9010,
	DuplicateFileNames: validationTypes.DuplicateFileNames,
	ITFlowCanvasForm: 9014,
	AdjustmentsModule: 9017,
	PersonInCharge: validationTypes.PersonInCharge,
	PICTaskWithoutAtLeastOneRelatedPICEvidence: validationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
	EQRTaskWithoutAtLeastOneRelatedEQREvidence: validationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
	RelateEvidenceToEntityTask: validationTypes.RelateEvidenceToEntityTask,
	PICEvidenceWithoutAtLeastOneRelatedPICTask: validationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
	EQREvidenceWithoutAtLeastOneRelatedEQRTask: validationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
	TempFilesWithPreparerAndReviewerSignoffsError: validationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
	TemporaryFilesWithPICRequirementUserOrKnowledge: validationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
	TemporaryFileWithEQRRequirementUserOrKnowledge: validationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
	DeletedFilesWithPICRequirementUserOnly: validationTypes.DeletedFilesWithPICRequirementUserOnly,
	DeletedFilesWithEQRRequirementUserOnly: validationTypes.DeletedFilesWithEQRRequirementUserOnly,
	IncompleteCanvasFormResponses: 9016,
	DocumentAssociatedToInvalidObject: validationTypes.DocumentAssociatedToInvalidObject
};
// #endregion

export const COUNT = 'COUNT';

export const ArcTimelineTypes = [
	{
		id: ArcTimeLineValidationTypes.DocumentConflict,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&filterdocumentconflict=true#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&filterdocumentcontent=${filters.documentContent.DocumentsInCollaborationMode}#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&filterdocumentcontent=${filters.documentContent.DocumentContentNotAvailable}#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
		url: `${reviewNoteRoutes.reviewNoteHub}?annotationstatusids=${reviewNoteStatus.Open.id}&annotationstatusids=${reviewNoteStatus.Cleared.id}&engagementid={ENGAGEMENTID}`,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&filterdocumentcontent=${filters.documentContent.trackedChanges}#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&filtercanvasformcontent=${filters.canvasForms.incompleteResponses}#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
		url: `${reportingRoutes.validationChecks}?engagementId={ENGAGEMENTID}`,
		isExternalUrl: true,
		displayAlways: COUNT,
		groupId: ArcTimelineGroups.FinalizeEvidence,
		quickLinkFlag: '',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
		url: `${documentRoutes.document}?category=documents&engagementId={ENGAGEMENTID}&filterfileextension=smartAutomation#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
		url: `${documentRoutes.document}?category=documents&engagementId={ENGAGEMENTID}&filtersignoffmissing=true#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
		url: `${documentRoutes.document}?category=documents&engagementId={ENGAGEMENTID}&filterexecutiverequirement=1&filterexecutiverequirement=2#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
		url: `${documentRoutes.document}?category=documents&engagementId={ENGAGEMENTID}&filterexecutiverequirement=3&filterexecutiverequirement=4#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
		url: `${documentRoutes.document}?category=documents&engagementId={ENGAGEMENTID}&filterexecutiverequirement=1&filterexecutiverequirement=2&filtermissingrelatedtask=1#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
		url: `${documentRoutes.document}?category=documents&engagementId={ENGAGEMENTID}&filterexecutiverequirement=3&filterexecutiverequirement=4&filtermissingrelatedtask=2#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&filtersharedevidence=1&filtersharedevidence=2#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	// {
	// 	id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
	// 	url: '#',
	// 	displayAlways: true,
	// 	quickLinkFlag: '',
	// 	groupId: ArcTimelineGroups.FinalizeEvidence,
	// 	typeButton: ArcTimelineTypeButton.icon
	// },
	{
		id: ArcTimeLineValidationTypes.DuplicateFileNames,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&filterduplicatefilename=true#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&view=temporaryFiles&filtersignoffmissing=false#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&view=temporaryFiles&filterexecutiverequirement=1&filterexecutiverequirement=2#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&view=temporaryFiles&filterexecutiverequirement=3&filterexecutiverequirement=4#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&view=recentlyDeleted&filterexecutiverequirement=1&filterexecutiverequirement=2#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
		url: `${documentRoutes.document}?category=documents&engagementid={ENGAGEMENTID}&view=recentlyDeleted&filterexecutiverequirement=3&filterexecutiverequirement=4#engagementOverview`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
		url: `${reportingRoutes.validationChecks}?engagementId={ENGAGEMENTID}`,
		isExternalUrl: true,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.FinalizeEvidence,
		typeButton: ArcTimelineTypeButton.icon
	},
	//GroupId 5 Complete remaining tasks.
	{
		id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
		url: `/tasks/${TaskCategories.AllTasks}/${TaskSubCategory.all}?engagementid={ENGAGEMENTID}&taskstatus=5&taskstatus=1&taskstatus=2&taskstatus=3`,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.CompleteRemainingTasks,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
		url: `/tasks/${TaskCategories.AllTasks}/${TaskSubCategory.all}?engagementid={ENGAGEMENTID}&assignmentstatus=1&assignmentstatus=2&assignmentstatus=3&assignmentstatus=4&taskstatus=1&taskstatus=2&taskstatus=3&taskstatus=4&tasktype=${TaskTypesFilter.epSignoffRequired}&filteranypicevidence=false`,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.CompleteRemainingTasks,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
		url: `/tasks/${TaskCategories.AllTasks}/${TaskSubCategory.all}?engagementid={ENGAGEMENTID}&assignmentstatus=1&assignmentstatus=2&assignmentstatus=3&assignmentstatus=4&taskstatus=1&taskstatus=2&taskstatus=3&taskstatus=4&tasktype=${TaskTypesFilter.eqrSignoffRequired}&filteranyeqrevidence=false`,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.CompleteRemainingTasks,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
		url: `${reportingRoutes.validationChecks}?engagementId={ENGAGEMENTID}`,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.CompleteRemainingTasks,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.MarkTasksComplete,
		url: `/tasks/${TaskCategories.AllTasks}/${TaskSubCategory.all}?engagementid={ENGAGEMENTID}&taskstatus=1&taskstatus=2&taskstatus=3`,
		displayAlways: true,
		quickLinkFlag: '',
		groupId: ArcTimelineGroups.CompleteRemainingTasks,
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.AccountsSummary,
		url: '{CANVASURL}#accountsummary',
		isExternalUrl: true,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasAccountSummary',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.ScotSummary,
		url: '{CANVASURL}#scotsummary',
		isExternalUrl: true,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasScotSummary',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.CraSummary,
		url: '{CANVASURL}#crasummary',
		isExternalUrl: true,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasCRASummary',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
		url: '{KRONOSURL}/fit?engagementid={ENGAGEMENTID}&documentid={ITFLOWISA315DOCUMENTID}&referrer={REFERERURL}',
		isExternalUrl: false,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasITFlowISA315',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.AdjustmentsModule,
		url: '/adjustmentmodule?engagementid={ENGAGEMENTID} ',
		isExternalUrl: false,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: '',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.ITSummary,
		url: '{CANVASURL}#itsummary',
		isExternalUrl: true,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasItSummary',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.AuditPlan,
		url: '{CANVASURL}#plan',
		isExternalUrl: true,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasAuditPlanSummary',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
		url: '/smartscreens/sem?engagementId={ENGAGEMENTID}&documentId={DOCUMENTSEM}',
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasSubstantiveEvaluationMatrix',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.ITEvaluation,
		url: '{CANVASURL}#itevaluation{ITEVALUATIONDOCUMENTID}',
		isExternalUrl: true,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasITProcessEvaluation',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
		url: '/smartscreens/440gl?engagementId={ENGAGEMENTID}&documentId={DOCUMENT440}',
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasModificationsAfterRRD',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.UnassociateFinding,
		url: '{CANVASURL}#findingsHub',
		isExternalUrl: true,
		displayAlways: true,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: '',
		typeButton: ArcTimelineTypeButton.icon
	},
	{
		id: ArcTimeLineValidationTypes.IndependenceCompliance,
		url: '/smartscreens/independence?engagementId={ENGAGEMENTID}&documentId={INDEPENDENCEDOCUMENT}',
		isExternalUrl: false,
		displayAlways: false,
		groupId: ArcTimelineGroups.ResolveValidations,
		quickLinkFlag: 'hasIndependence',
		typeButton: ArcTimelineTypeButton.icon
	}

	//These items are commented until confirmation

	// {
	// 	id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
	// 	url: '#',
	// 	displayAlways: true,
	// 	groupId: ArcTimelineGroups.ResolveValidations,
	// 	quickLinkFlag: 'hasWorkPlanSummary',
	// 	typeButton: ArcTimelineTypeButton.icon
	// },
	// {
	// 	id: ArcTimeLineValiValidateArcResponsedationTypes.CompleteArchiveForm,
	// 	url: '#',
	// 	displayAlways: false,
	// 	groupId: ArcTimelineGroups.ResolveValidations,
	// 	quickLinkFlag: 'hasWorkPlanSummary',
	// 	typeButton: ArcTimelineTypeButton.icon
	// },
	// {
	// 	id: ArcTimeLineValidationTypes.CompleteArchiveTask,
	// 	url: '#',
	// 	displayAlways: false,
	// 	groupId: ArcTimelineGroups.ResolveValidations,
	// 	quickLinkFlag: 'hasWorkPlanSummary',
	// 	typeButton: ArcTimelineTypeButton.icon
	// }
];

//Steps to identify where the API have error for archive.
export const ArcTimelineStepName = {
	ValidateEnagamentStatus: 'ValidateEnagamentStatus',
	UpdateEnagamentStatus: 'UpdateEnagamentStatus',
	InvalidateEngagementStatusCache: 'InvalidateEngagementStatusCache',
	ContentUpdateInProgressCheck: 'ContentUpdateInProgressCheck',
	EngagementChecklistValidation: 'EngagementChecklistValidation',
	CanvasArchiveCall: 'CanvasArchiveCall',
	EngagementDataValidation: 'EngagementDataValidation',
	ValidateArcResponse: 'ValidateArcResponse'
};

export const TasksFilterType = [
	{id: 1, filterType: 'TaskStatus', nameProp: 'TaskStatus', hasChild: false},
	{id: 2, filterType: 'TaskType', nameProp: 'TaskType', hasChild: false},
	{
		id: 3,
		filterType: 'AssignedTo',
		nameProp: 'AssignedTo',
		hasChild: false,
		loadOptionsFromServer: true
	},
	{
		id: 4,
		filterType: 'OpenAssignment',
		nameProp: 'OpenAssignments',
		hasChild: false,
		loadOptionsFromServer: true
	},
	{
		id: 5,
		filterType: 'AssignmentsUsersEngagementRoles',
		nameProp: 'OpenAssignments',
		hideDisplay: true,
		loadOptionsFromServer: true
	},
	{
		id: 6,
		filterType: 'ReviewNotesStatus',
		nameProp: 'ReviewNotesStatus',
		hasChild: false
	},
	{
		id: 7,
		filterType: 'ReviewNotesAssignedTo',
		nameProp: 'ReviewNotesAssignedTo',
		hasChild: false,
		loadOptionsFromServer: true
	},
	{
		id: 8,
		filterType: 'ReviewNotesCreatedBy',
		nameProp: 'ReviewNotesCreatedBy',
		hasChild: false,
		loadOptionsFromServer: true
	},
	{
		id: 9,
		filterType: 'TimePhase',
		nameProp: 'TimePhase',
		hasChild: false,
		loadOptionsFromServer: true
	},
	{id: 10, filterType: 'Milestone', nameProp: 'Milestone', hasChild: false},
	{
		id: 11,
		filterType: 'AuditPhase',
		nameProp: 'AuditPhase',
		altNameProp: 'AuditPhaseAlt',
		hasChild: false
	},
	{
		id: 12,
		filterType: 'DocumentConflict',
		nameProp: 'DocumentConflict',
		hasChild: false
	},
	{
		id: 13,
		filterType: 'Findings',
		nameProp: 'Findings',
		hasChild: false,
		hideForNonAudit: true
	},
	{
		id: 14,
		filterType: 'Entity',
		nameProp: 'Entity',
		hasChild: false,
		loadOptionsFromServer: true,
		hideForNonMest: true
	},
	{
		id: 15,
		filterType: 'IsBookmarked',
		nameProp: 'IsBookmarked',
		hasChild: false
	}
];

export const TagConfig = {
	taskDetailTagsCount: 8,
	taskListTagsCount: 1,
	groupByAttributeMapping: {
		groupId: 'engagementTagGroupId',
		groupName: 'engagementTagGroupName',
		childItemId: 'engagementTagId',
		childItemName: 'engagementTagName',
		groupByAttributeName: 'engagementTagGroupId',
		iconInformation: 'colorCode',
		entityCount: 'entityCount'
	},
	outputAttributesName: {
		groupChildrenListName: 'tags',
		childId: 'tagId',
		childName: 'tagName',
		parentGroupId: 'groupId',
		parentGroupName: 'groupName',
		iconName: 'colorCode',
		entityCount: 'entityCount'
	},
	tagItemPadding: 25,
	tagContainerPadding: 26
};

export const colorCodeMapping = {
	Red: 'error',
	Orange: 'warning',
	Teal: 'default',
	Blue: 'success',
	Purple: 'error',
	Green: 'warning'
};

export const ServiceRequestDetailDocumentsConfig = {
	maxItemsCountToBeShown: 2,
	taskListRequestCount: 10,
	groupByAttributeMapping: {
		groupId: 'engagementTagGroupId',
		groupName: 'engagementTagGroupName',
		childItemId: 'engagementTagId',
		childItemName: 'engagementTagName',
		groupByAttributeName: 'engagementTagGroupId',
		iconInformation: 'colorCode'
	},
	outputAttributesName: {
		groupChildrenListName: 'tags',
		childId: 'tagId',
		childName: 'tagName',
		parentGroupId: 'groupId',
		parentGroupName: 'groupName',
		iconName: 'colorCode'
	},
	tagItemPadding: 25,
	tagContainerPadding: 250
};

export const ServiceRequestDetailUserConfig = {
	maxEYContactsCountToBeShown: 2,
	maxAssignedUsersCountToBeShown: 3,
	groupByAttributeMapping: {
		groupId: 'engagementTagGroupId',
		groupName: 'engagementTagGroupName',
		childItemId: 'engagementTagId',
		childItemName: 'engagementTagName',
		groupByAttributeName: 'engagementTagGroupId',
		iconInformation: 'colorCode'
	},
	outputAttributesName: {
		groupChildrenListName: 'tags',
		childId: 'tagId',
		childName: 'tagName',
		parentGroupId: 'groupId',
		parentGroupName: 'groupName',
		iconName: 'colorCode'
	},
	tagItemPadding: 25,
	tagContainerPadding: 250
};

export const Entity = {
	Document: 1,
	LeadSchedule: 2,
	Account: 3,
	SCOT: 4,
	ITProcess: 5,
	AuditPlan: 6,
	Risk: 7,
	Task: 8,
	Misstatement: 9,
	Dificiency: 10,
	GAComponent: 11,
	GAComponentInstruction: 12,
	GAComponentEvidence: 13,
	GAScope: 14,
	GAPrimaryInstruction: 15,
	GAPrimary: 16,
	ClientRequest: 17,
	WCGW: 18,
	Control: 19,
	ITSOApplication: 20,
	CanvasForm: 21,
	FormSection: 22,
	FormBody: 23,
	Assertion: 24,
	ClientEngagement: 25,
	ClientGroup: 26,
	EngagementTag: 27,
	Engagement: 28,
	FormHeader: 29,
	FormStatus: 30,
	EngagementUser: 31,
	ClientGroupUser: 32,
	PSPIndex: 33,
	ITControl: 34,
	ITRisk: 35,
	AutomationLineItem: 36,
	PMAmount: 37,
	TEAmount: 38,
	SADNominalAmount: 39,
	UMTAmount: 40,
	Annotation: 41,
	EngagementComment: 42,
	Assignment: 43,
	PACEType: 44,
	TaskSection: 45,
	CalendarEvent: 46,
	TimePhase: 47,
	Approval: 48,
	DocumentQuickReference: 49,
	STEntity: 50,
	Estimate: 51,
	GLAccount: 52, // this as per entity table of Engagement DB
	ITApplication: 52,
	SampleItem: 53,
	SampleTagGroups: 54,
	AdjustmentValidation: 55
};

export const TagType = {
	Filtering: 'Filtering',
	Notes: 'Notes'
};

export const ManageSampleTags = {
	FilteringNotArchived: 'filteringNotArchived'
};

export const enumGAMLayer = {
	digital: 'digital',
	complex: 'complex',
	listed: 'listed',
	groupAudit: 'groupAudit',
	pcaobfs: 'pcaobfs',
	pcaobia: 'pcaobia',
	countryId: 'countryId',
	languageId: 'languageId'
};

export const enumBtnStatus = {
	ON: 1,
	OFF: 2
};

export const serviceRequestStatus = [
	{id: 11, status: 'Accepted', icon: actionIcCheckCircle24px},
	{id: 12, status: 'Requested', icon: actionIcAutorenew24px},
	{id: 13, status: 'Rejected'},
	{id: 17, status: 'SubmissionError'},
	{id: 14, status: 'Draft'},
	{id: 15, status: 'Completed', icon: avIcPlaylistAddCheck24px},
	{id: 16, status: 'Prior Period - Complete'},
	{id: 22, status: 'N/A'},
	{id: 24, status: 'Action required'}
];

export const KnowledgeEntityTypeEnum = {
	Account: 1,
	ITProcess: 2,
	SCOT: 3,
	WCGW: 4,
	ScotControl: 5,
	ITApplication: 6,
	ITControl: 10,
	Estimate: 13,
	OSP: 14
};

export const KnowledgeEngagementEntityMapping = [
	{KnowledgeId: 1, EngagementId: 3, EntityName: 'Account'},
	{KnowledgeId: 2, EngagementId: 5, EntityName: 'ITProcess'},
	{KnowledgeId: 3, EngagementId: 4, EntityName: 'SCOT'},
	{KnowledgeId: 5, EngagementId: 19, EntityName: 'ScotControl'},
	{KnowledgeId: 6, EngagementId: 20, EntityName: 'ITApplication'},
	{KnowledgeId: 10, EngagementId: 34, EntityName: 'ITControl'},
	{KnowledgeId: 13, EngagementId: 51, EntityName: 'Estimate'}
];

export const ServiceRequestDetailTabs = {
	GeneralInfo: 1,
	Tasks: 2
};

export const TaskListTabs = {
	AllTasks: 2,
	Accounts: 6,
	Itso: 5,
	Scot: 4
};

export const DocumentSelection = {
	add: 'add',
	remove: 'remove',
	clear: 'clear'
};

export const counterOperation = {
	increment: 'increment',
	decrement: 'decrement',
	reset: 'reset'
};

export const ServiceRequestSteps = {
	SelectServiceOffering: 1,
	SelectTasks: 2,
	SetDueDate: 3,
	AddInstructions: 4
};

export const ServiceRequestStepsIndex = {
	SelectServiceOffering: 0,
	SelectTasks: 1,
	SetDueDate: 2,
	AddInstructions: 3
};

export const ServiceRequestStatus = {
	Undefined: 0,
	Accepted: 1,
	Pending: 2,
	Rejected: 3,
	Draft: 4,
	Completed: 5,
	InQueue: 6,
	PriorperiodComplete: 7,
	ParentAccepted: 11,
	ParentRequested: 12,
	ParentRejected: 13,
	ParentDraft: 14,
	ParentCompleted: 15,
	ParentPriorperiod: 16,
	ParentError: 17,
	SubmissionError: 18
};

export const AnnotationStatus = {
	Open: 1,
	Closed: 2,
	Assigned: 3,
	Reassigned: 4,
	Cleared: 5,
	Rejected: 6,
	Reopened: 7,
	Resolved: 8,
	ContentRemoved: 9
};

export const bulkAssignment = {
	assign: 1,
	timephase: 2,
	tag: 3
};

export const assignmentTypes = {
	preparer: '1',
	detailReviewer: '2',
	generalReviewer: '3',
	partner: '4',
	eqr: '5',
	other: '6'
};

export const userRoleTypes = {
	partnerInCharge: 1,
	engagementPartner: 2,
	executiveDirector: 3,
	seniorManager: 5,
	manager: 6
};

export const actionTags = {
	open: 'open',
	openReadOnly: 'openr'
};

export const ProfileActionType = {
	ProfileSubmitFirstTime: 1,
	ProfileSubmitRollForward: 2,
	ProfileEdit: 3,
	GlobalContentUpdate: 4,
	ImportPSPs: 5,
	ImportPSTs: 6,
	CanvasFormContentUpdate: 7,
	ImportGAInstructions: 8,
	Addmanualform: 9,
	ProfileDelivery: 10,
	SyncProfileUpdate: 12
};

export const ServiceTaskBadgeType = {
	Scheduled: 1,
	Suggested: 2,
	PriorPeriod: 3
};

export const manageAssignmentStatus = {
	unassigned: 1,
	onTrack: 2,
	overdue: 3
};

export const unassignedId = -111;

export const circleProportions = {
	empty: 'empty',
	half: 'half',
	full: 'full'
};

export const confidentialityTypes = {
	DEFAULT: 0,
	LOW: 1,
	MODERATE: 2,
	HIGH: 3

	// CONFIDENTIAL: 4
};

export const jsonDocumentPatchOperations = {
	add: 'add',
	remove: 'remove',
	replace: 'replace',
	copy: 'copy',
	move: 'move',
	test: 'test'
};

export const milestoneBuildTaskIds = {
	accounts: 4,
	scots: 9,
	itso: 14,
	cra: 16,
	auditPlan: 28,
	groupStructure: 44,
	groupInstructions: 48,
	review: 51
};

export const attributeListSkipTaskOpen = ['tagIcon', 'nextWaveIcon', 'tagMenu', 'nextWaveMenu', 'selectCheckbox'];

export const fourDigitMax = 9999;

export const TaskListFilter = {
	cacheTimeout: 2
};

export const rightToLeftDisplayLanguages = [
	{displayLanguageId: 11, value: 'Hebrew'},
	{displayLanguageId: 14, value: 'Arabic'}
];

export const userTheme = {
	dark: 'dark',
	light: 'light'
};

export const KnowledgeTaskTypes = [
	TaskTypeEnum.PRIMARY_STANDARD_TASK,
	TaskTypeEnum.PRIMARY_SUBSTANTIVE_PROCEDURE_TASK,
	TaskTypeEnum.PRIMARY_GROUP_TASK,
	TaskTypeEnum.COMPONENT_GROUP_TASK,
	TaskTypeEnum.COMPONENT_GROUP_TASK_UNLINKED
];

export const invalidGroupNameCharacters = ['|'];

//Copyhub-Create Package-Package Type Enum
// ids to match CopyObjectGroupTypeId
export const PackageTypeEnum = {
	DEFAULT: 0,
	V2CANVASEVIDENCE: 20,
	V2ENGAGEMENT: 21,
	V2ACCOUNTS: 22,
	V2SCOTS: 23,
	V2ENGAGEMENTROLLFORWARDCOPY: 24,
	V2ENGAGEMENTTEMPLATE: 25,
	V2EVIDENCEBULKEXPORT: 26,
	V2EXTERNALDOCUMENTS: 27,
	KNOWLEDGEDELIVEREDEVIDENCE: 28,
	ENGAGEMENTBYENTITY: 29
};

export const copyFileCategoryEnum = {
	OTHER: 0,
	EVIDENCE: 1,
	TEMPORARYFILES: 2,
	RECENTLYDELETEDFILES: 3,
	PRIORPERIODEVIDENCE: 4,
	HISTORYFILES: 5,
	EYDOCUMENTS: 6,
	EXTERNALDOCUMENTS: 7,
	CANVASFORMS: 8
};

export const copyRequestStatusEnum = {
	EXPIRED: 0,
	READY: 1,
	SENT: 2,
	RECEIVED: 3,
	EXPORTINPROGRESS: 4,
	EXPORTSUCCESS: 5,
	EXPORTERROR: 6,
	IMPORTINPROGRESS: 7,
	IMPORTSUCCESS: 8,
	IMPORTERROR: 9,
	DECLINED: 10,
	COPYINPROGRESS: 11,
	DRAFT: 13,
	SENDINPROGRESS: 14,
	DELIVERYINPROGRESS: 15,
	DELIVERYERROR: 16
};

export const groupAuditType = {
	primary: 1,
	region: 2,
	component: 3
};

export const activityFeedQuery = {
	primary: 'primary',
	component: 'component',
	region: 'region',
	documents: 'documents',
	instructions: 'instructions',
	linkRequests: 'linkrequests',
	received: 'received',
	returned: 'returned',
	sent: 'sent',
	accepted: 'accepted',
	unlinked: 'unlinked',
	resolved: 'resolved',
	rejected: 'rejected'
};

export const activityFeedRoute = [
	{id: groupAuditType.primary, route: activityFeedQuery.primary},
	{id: groupAuditType.component, route: activityFeedQuery.component},
	{id: groupAuditType.region, route: activityFeedQuery.region}
];

export const activityFeedSection = {
	documents: 1,
	instructions: 2,
	linkRequests: 3
};

export const activityFeedSectionRoutes = [
	{id: activityFeedSection.documents, route: activityFeedQuery.documents},
	{id: activityFeedSection.instructions, route: activityFeedQuery.instructions},
	{id: activityFeedSection.linkRequests, route: activityFeedQuery.linkRequests}
];

export const activityFeedItems = {
	received: 1,
	returned: 2,
	sent: 3,
	accepted: 4,
	unlinked: 5,
	resolved: 6,
	rejected: 7
};

export const activityFeedItemRoutes = [
	{id: activityFeedItems.received, route: activityFeedQuery.received},
	{id: activityFeedItems.returned, route: activityFeedQuery.returned},
	{id: activityFeedItems.sent, route: activityFeedQuery.sent},
	{id: activityFeedItems.accepted, route: activityFeedQuery.accepted},
	{id: activityFeedItems.unlinked, route: activityFeedQuery.unlinked},
	{id: activityFeedItems.rejected, route: activityFeedQuery.rejected},
	{id: activityFeedItems.resolved, route: activityFeedQuery.resolved}
];

export const activityFeedEntities = {
	primaryReceived: 'PrimaryReceived',
	primaryReturned: 'PrimaryReturned',
	componentSent: 'ComponentSent',
	componentReturned: 'ComponentReturned',
	componentResolved: 'ComponentResolved'
};

export const activityFeedFilters = [
	{
		type: activityFeedQuery.primary,
		item: activityFeedQuery.received,
		entity: activityFeedEntities.primaryReceived,
		category: documentCategoryNames.evidence
	},
	{
		type: activityFeedQuery.primary,
		item: activityFeedQuery.returned,
		entity: activityFeedEntities.primaryReturned,
		category: documentCategoryNames.evidence
	},
	{
		type: activityFeedQuery.component,
		item: activityFeedQuery.sent,
		entity: activityFeedEntities.componentSent,
		category: documentCategoryNames.evidence
	},
	{
		type: activityFeedQuery.component,
		item: activityFeedQuery.returned,
		entity: activityFeedEntities.componentReturned,
		category: documentCategoryNames.componentReturned
	},
	{
		type: activityFeedQuery.component,
		item: activityFeedQuery.resolved,
		entity: activityFeedEntities.componentResolved,
		category: documentCategoryNames.componentResolved
	}
];

export const activityType = {
	createReviewNote: 1,
	clearReviewNote: 4,
	primaryLinkAccept: 12,
	primaryLinkReject: 13,
	primaryUnlink: 16,
	primaryAcceptInstruction: 18,
	primaryRejectInstruction: 19,
	primaryReturnEvidence: 24,
	primaryAssignComponent: 25,
	componentUnassigned: 26,
	primaryEvidenceReceived: 27,
	componentEvidenceSent: 28,
	componentReturnEvidence: 29,
	primarySendLink: 31,
	primarySendInstruction: 32,
	componentAcceptInstruction: 33,
	componentRejectInstruction: 34,
	componentAcceptUpdatetInstruction: 35,
	componentRejectUpdateInstruction: 36,
	componentFinalizeEvidence: 37,
	primaryComponentUnlink: 41,
	componentPrimaryUnlink: 42,
	canvasSendClientRequest: 44,
	clientRespondToClientRequest: 45,
	canvasRejectClientRequest: 46,
	canvasWithdrawClientRequest: 47,
	canvasDeleteClientRequest: 48,
	canvasAcceptClientRequest: 49,
	CEARecallClientRequest: 50,
	canvasCompleteClientRequest: 51,
	memberDeactivated: 53,
	memberReactivated: 54,
	memberRoleChanged: 55,
	clientGroupUserInvited: 56,
	clientGroupUserDeactivated: 57,
	clientGroupUserReactivated: 58,
	clearDocumentReturnedtoComponent: 63,
	componentClearReturnedDocument: 64,
	closeReviewNote: 65,
	openReviewNote: 66,
	reviewerSignOff: 67,
	preparerSignOff: 68,
	documentVersionConflictResolved: 69,
	componentReceivedInstruction: 70,
	documentOverwrite: 71
};

export const activityTypeText = {
	createReviewNote: 'createReviewNote',
	clearReviewNote: 'clearReviewNote',
	closeReviewNote: 'closeReviewNote',
	openReviewNote: 'openReviewNote',
	reviewerSignOff: 'reviewerSignOff',
	preparerSignOff: 'preparerSignOff'
};

export const activityTypeRoute = [
	{section: activityFeedQuery.documents, item: activityFeedQuery.received, route: 'documentReceived'},
	{section: activityFeedQuery.documents, item: activityFeedQuery.returned, route: 'documentReturned'},
	{section: activityFeedQuery.documents, item: activityFeedQuery.sent, route: 'documentSent'},
	{section: activityFeedQuery.documents, item: activityFeedQuery.resolved, route: 'documentFinalized'},
	{section: activityFeedQuery.instructions, item: activityFeedQuery.sent, route: 'instructionSent'},
	{section: activityFeedQuery.instructions, item: activityFeedQuery.received, route: 'instructionReceived'},
	{section: activityFeedQuery.instructions, item: activityFeedQuery.rejected, route: 'instructionRejected'},
	{section: activityFeedQuery.instructions, item: activityFeedQuery.accepted, route: 'InstructionAccepted'},
	{section: activityFeedQuery.linkRequests, item: activityFeedQuery.sent, route: 'linkSent'},
	{section: activityFeedQuery.linkRequests, item: activityFeedQuery.accepted, route: 'linkAccepted'},
	{section: activityFeedQuery.linkRequests, item: activityFeedQuery.unlinked, route: 'linkUnlinked'}
];

export const activityFeedItemProperty = {
	primaryInstructionsAccepted: 'primaryInstructionsAccepted',
	primaryInstructionsSent: 'primaryInstructionsSent',
	primaryInstructionsRejected: 'primaryInstructionsRejected',
	primaryLinkRequestsAccepted: 'primaryLinkRequestsAccepted',
	primaryLinkRequestsSent: 'primaryLinkRequestsSent',
	primaryLinkRequestsUnlinked: 'primaryLinkRequestsUnlinked',
	componentInstructionsReceived: 'componentInstructionsReceived',
	componentInstructionsAccepted: 'componentInstructionsAccepted'
};

export const linkStatus = {
	documentReturned: 3,
	documentSent: 4,
	documentFinalized: 5,
	instructionSent: 6,
	instructionReceived: 7,
	instructionAccepted: 8,
	linkSent: 10,
	linkUnlinked: 12
};

export const linkType = {
	sent: 'sent',
	accepted: 'accepted',
	unlinked: 'unlinked'
};

export const instructionType = {
	sent: 'sent',
	received: 'received',
	rejected: 'rejected',
	accepted: 'accepted'
};

export const instructionStatus = {
	notSent: 1,
	pending: 2,
	accepted: 3,
	rejected: 4,
	systemError: 5,
	expired: 6,
	sent: 7,
	unlinked: 8,
	queued: 9
};

export const componentSettingEnum = {
	COLUMNSETTING: 1,
	ITEMCOMPONENT: 2,
	HEADERCOMPONENT: 3,
	FETCHCOMPONENT: 4
};

export const eyCanvas = 'EY Canvas';

export const copyhubDocumentTypeIdList = [7, 49, 82];

export const copyhubFITDocumentTypeIdList = [80, 82];

export const externalDocumentTypeIdList = [];

export const packageObjectProperties = {
	documentName: 'documentName',
	accountName: 'accountName',
	scotName: 'scotName',
	fileExt: 'fileExt',
	defaultProperty: 'name'
};

export const customFiltersQueryConstant = {
	AssignedTo: 'AssignedTo',
	Attachments: 'Attachments',
	CreatedBy: 'CreatedBy',
	Status: 'Status',
	DueAfter: 'DueAfter',
	DueBefore: 'DueBefore',
	Errors: 'Errors',
	Overdue: 'Overdue',
	Tag: 'Tag',
	TimePhase: 'TimePhase',
	Type: 'Type'
};

export const filterCacheDuration = 0;
export const dashboardExecutiveRoleIds = [6, 5, 3, 4, 2, 11, 1, 2, 17];
export const userMemberType = {
	executive: 1,
	teamMember: 2
};

export const userDashboardMemberType = {
	teamMember: 'teammembers',
	executive: ''
};

// collaborate tags

export const defaultClientTagColor = 'Gray';
export const defaultEYTagColor = 'Yellow';
export const searchMaxLengthTags = 100;
export const searchMaxLengthEYContact = 100;

export const colorOptions = [
	{value: 'Red', label: 'Red', className: 'red'},
	{value: 'Orange', label: 'Orange', className: 'orange'},
	{value: 'Teal', label: 'Teal', className: 'teal'},
	{value: 'Blue', label: 'Blue', className: 'blue'},
	{value: 'Purple', label: 'Purple', className: 'purple'},
	{value: 'Green', label: 'Green', className: 'green'},
	{value: 'Yellow', label: 'Yellow', className: 'yellow', ignore: true},
	{value: 'Gray', label: 'Gray', className: 'gray', ignore: true}
];

export const syncStatus = {
	notSynchronized: 1,
	syncInTransit: 2,
	syncInProcess: 3,
	synchronized: 4,
	deleteInTransit: 5,
	deleteInProcess: 6,
	deleted: 7,
	noHostEngagement: 8,
	syncError: 9
};

export const tagTypeAction = {
	create: 20,
	edit: 21,
	delete: 1,
	existing: 0
};

export const statusCheckBoxTags = {
	none: 0,
	some: 1,
	all: 2
};

export const todoListTimeframeOptions = {
	byDay: 'day',
	byWeek: 'week',
	byMonth: 'month',
	all: 'all',
	overdue: 'overdue'
};

export const collaborationRelateFilesTabs = {
	evidence: 1,
	temporaryFiles: 2,
	priorPeriodEvidence: 3,
	externalDocuments: 4,
	clientRequestClientAnalytics: 5
};

export const collaborationQuickFiltersTabsConstanst = {
	all: 'all',
	draft: 'draft',
	pending: 'pending',
	received: 'received',
	accepted: 'accepted'
};

export const collaborationPriorityQuickFilters = {
	all: 'all',
	high: 'high',
	critical: 'critical',
	normal: 'normal',
	highAndCritical: 'highAndCritical'
};

export const collaborationFilterTypeEnum = {
	myrequests: 'my',
	allrequests: 'all',
	calendar: 'calendar',
	requests: 'requests',
	events: 'events',
	analytics: 'analytics'
};

export const collaborationParentView = {
	myProgress: 'myProgress',
	allView: 'allView',
	engagementOverview: 'engagementOverview'
};

export const sortOrder = {
	Asc: 'Asc',
	Desc: 'Desc'
};

export const defaultPageSize = 20;
export const defaultCurrentPage = 1;

export const clientRequestNoteTab = {
	comments: 1,
	history: 2
};
export const clientRequestDocumentsTabIDs = {
	externalDocuments: 'externalDocuments',
	taskDocuments: 'taskDocuments',
	deletedDocuments: 'deletedDocuments',
	priorPeriodDocuments: 'priorPeriodDocuments'
};
//Enums for client request status
export const clientRequestStatus = {
	Draft: 1,
	NoClientContact: 2,
	Sent: 3,
	SystemError: 4,
	InvalidClientContact: 5,
	PendingResponse: 6,
	Received: 7,
	Accepted: 8,
	Returned: 9,
	Withdrawn: 10,
	SendInTransit: 11,
	AcceptInTransit: 12,
	WithdrawInTransit: 13,
	DeleteInTransit: 14,
	ReturnInTransit: 15,
	ResponseInTransit: 16,
	Deleted: 17,
	InvalidClientContactReturned: 18,
	RecallInTransit: 19,
	Recalled: 20,
	CompletionInTransit: 21,
	RecallInProgress: 22,
	RecalledFromAccepted: 27,
	RecallInTransitfromAccepted: 28
};
export const ClientRequestOperationMode = {
	AddCustomRequest: 1,
	AddCustomRequestTask: 2,
	ReturnRequest: 3,
	HelixCustomRequest: 4
};

export const ParentDraft = [
	clientRequestStatus.Draft,
	clientRequestStatus.NoClientContact,
	clientRequestStatus.InvalidClientContact,
	clientRequestStatus.Withdrawn,
	clientRequestStatus.SendInTransit,
	clientRequestStatus.DeleteInTransit,
	clientRequestStatus.Deleted
];

export const ExcludedClientRequestStatusForSyncingCommentsInExternalExternalApplication = [
	clientRequestStatus.Draft,
	clientRequestStatus.NoClientContact,
	clientRequestStatus.InvalidClientContact,
	clientRequestStatus.SendInTransit,
	clientRequestStatus.DeleteInTransit,
	clientRequestStatus.Deleted
];

export const ParentAccepted = [clientRequestStatus.RecallInTransitfromAccepted, clientRequestStatus.Accepted];

export const ParentReceived = [
	clientRequestStatus.Received,
	clientRequestStatus.AcceptInTransit,
	clientRequestStatus.InvalidClientContactReturned,
	clientRequestStatus.RecallInTransit,
	clientRequestStatus.ReturnInTransit
];

export const ParentPendingResponse = [
	clientRequestStatus.Recalled,
	clientRequestStatus.CompletionInTransit,
	clientRequestStatus.RecalledFromAccepted,
	clientRequestStatus.Returned,
	clientRequestStatus.WithdrawInTransit,
	clientRequestStatus.PendingResponse,
	clientRequestStatus.ResponseInTransit
];

export const ParentInTransit = [
	clientRequestStatus.SendInTransit,
	clientRequestStatus.AcceptInTransit,
	clientRequestStatus.WithdrawInTransit,
	clientRequestStatus.DeleteInTransit,
	clientRequestStatus.ReturnInTransit,
	clientRequestStatus.ResponseInTransit,
	clientRequestStatus.RecallInTransit,
	clientRequestStatus.CompletionInTransit,
	clientRequestStatus.RecallInTransitfromAccepted
];

export const EnableComments = [
	clientRequestStatus.Draft,
	clientRequestStatus.NoClientContact,
	clientRequestStatus.InvalidClientContact,
	clientRequestStatus.Withdrawn,
	clientRequestStatus.Deleted
];

export const urls = {
	MANAGE_TEAM_USERS: 'eyusers.json/'
};

export const colorArray = [
	'Maroon100',
	'Maroon200',
	'Maroon300',
	'Maroon400',
	'Maroon500',
	'Maroon600',
	'Maroon700',
	'black',
	'blackyellow',
	'blue100',
	'blue200',
	'blue300',
	'blue400',
	'blue500',
	'blue600',
	'blue600yellow400',
	'blue700',
	'gr50black',
	'gr50grey450',
	'gr50grey600',
	'green100',
	'green200',
	'green300',
	'green400',
	'green500',
	'green600',
	'green700',
	'grey50',
	'grey100',
	'grey100blue15',
	'grey100blue500',
	'grey100grey450',
	'grey100grey550',
	'grey200',
	'grey225',
	'grey250',
	'grey300',
	'grey300black',
	'grey400',
	'grey450',
	'grey500',
	'grey500grey450',
	'grey500grey600',
	'grey550',
	'grey600',
	'orange100',
	'orange200',
	'orange300',
	'orange400',
	'orange500',
	'orange600',
	'orange700',
	'purple100',
	'purple200',
	'purple300',
	'purple400',
	'purple500',
	'purple600',
	'purple700',
	'red100',
	'red200',
	'red300',
	'red400',
	'red500',
	'red600',
	'red700',
	'teal100',
	'teal200',
	'teal300',
	'teal400',
	'teal500',
	'teal600',
	'teal700',
	'white',
	'whiteGrey200',
	'whiteGrey250',
	'whiteGrey450',
	'whiteGrey550',
	'whiteblack',
	'yellow400'
];

export const gaScopes = {
	referenceOnly: 0,
	full: 1,
	specific: 2,
	specificAuditProcedures: 3,
	review: 4
};

export const gaScopesRoutes = {
	groupScopes: 'GroupScopes',
	groupComponents: 'GroupComponents',
	groupInstructions: 'GroupInstructions',
	groupSections: 'GroupSections',
	expandTeams: '?expand=teams',
	expandInstructions: '?expand=instructions',
	expandTasks: '?expand=tasks',
	filterAssignedToTeam: '?filterAssignedToTeamDetails=true',
	filterAssignedToTeamWithTeams: '?filterAssignedToTeamWithTeams=true',
	teamsToSend: '?expand=gsTeamsToSend',
	groupLinks: 'GroupLinks',
	sendInstructions: 'SendInstructions',
	getTeamsExpandGAScopes: '?expand=gascopes'
};
export const minimunDate = '0001-01-01T00:00:00';
export const groupSnapshotsRoutes = {
	groupSnapshots: 'GroupSnapshots',
	isSentVersion: '?isSentVersion=true',
	scopeIdParam: (id) => `&scopeId=${id}`
};
export const receiveInstructionsRoutes = {
	groupSets: 'GroupSets',
	groupComponents: 'GroupComponents',
	receiveInstructions: 'ReceiveInstructions',
	gaComponentIdParam: (id) => `gaComponentId=${id}`,
	gaAcceptedVersionsParam: 'expand=gaacceptedversions',
	groupDocuments: 'GroupDocuments',
	groupVersions: 'GroupVersions',
	documentId: 'documentId',
	instructionStatus: `?gAInstructionStatus=${linkType.accepted}&gAInstructionStatus=${linkType.unlinked}`
};

export const snapshotComparisonIds = {
	noChange: 0,
	new: 1,
	added: 2,
	modified: 3,
	updated: 4,
	removed: 5,
	itemsRemoved: 6
};

export const defaultPageSizeHelixAnalyzers = 20;

//Paging options for helix analyzers

export const pagingOptionsHelixAnalyzers = {
	options: [20, 50, 100, 200]
};

//Paging options for new collab request detail docs

export const pagingOptionsDocuments = {
	options: [10, 20, 50]
};

//Paging options for activity feed

export const defaultPageSizeDocuments = 10;

export const defaultCurrentPageCollabDocs = 1;

export const defaultCurrentPageLeadSheet = 25;
export const leadSheetPagingOptions = {
	options: [25, 50]
};

export const historyActions = {
	sent: 'sent',
	accepted: 'accepted',
	received: 'received',
	returned: 'returned',
	withdrawn: 'withdrawn',
	complete: 'complete',
	recalled: 'recalled',
	notification_submit: 'notification_submit',
	notification_success: 'notification_success',
	notification_error: 'notification_error',
	restore_document: 'restore_document',
	delete_document: 'delete_document',
	assignedto: 'assignedto',
	editrequest: 'editrequest',
	prioritychange: 'prioritychange'
};

export const ipInputType = {
	ipAddress: 'ipAddress',
	ipRange: 'ipRange',
	cidrBlock: 'cidrBlock'
};

export const ipFilterType = {
	ipAddress: 'AddressFilter',
	ipRange: 'RangeFilter',
	cidrBlock: 'CidrBlockFilter'
};

export const clientRequestActions = {
	sendRequest: 'SendClientRequests',
	withdraw: 'ClientRequestWithdraw'
};

export const MSGraphURL = 'https://graph.microsoft.com/v1.0/users/{0}/photo/$value';

export const clientRequestTypes = {
	userCreated: 1,
	automationHubCreated: 2,
	clientEvent: 3
};

export const clientRequestDescriptionMaxCharacters = 4000;

export const ipV4Regex = /(^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$)/;

export const fontSizeMapping = {
	S: {fontSize: 10, lineHeight: 16},
	M: {fontSize: 12, lineHeight: 20},
	L: {fontSize: 14, lineHeight: 20},
	XL: {fontSize: 16, lineHeight: 22},
	XXL: {fontSize: 20, lineHeight: 24}
};

export const fontWeightMapping = {
	lighter: 100,
	light: 300,
	normal: 400,
	bold: 600
};

export const knowledgeInstructionSections = {
	keyInformation: 'keyInformation',
	scopeOfWork: 'scopeOfWork',
	groupTasks: 'reportingForms',
	proceduresPerformedCentrally: 'proceduresPerformedCentrally'
};

export const knowledgeInstructionsSectionsIds = {
	keyInformation: 1,
	scopeOfWork: 2,
	groupTasks: 3,
	proceduresPerformedCentrally: 4
};

export const EngagementCommentStatus = {
	open: 1,
	cleared: 2,
	closed: 3
};

export const EngagementCommentStatusIds = {
	[1]: 'open',
	[2]: 'cleared',
	[3]: 'closed'
};
export const groupStatusTaskUIfiltersId = {
	documentReceived: 1,
	documentPending: 2,
	overdue: 3
};

export const groupStatusDocumentUIfiltersId = {
	received: 2,
	prepared: 5,
	reviewed: 6,
	returned: 4,
	rejectInTransit: 8
};

export const gaDocumentStatusFiltersId = {
	notSend: 0,
	inProgress: 2,
	draftSend: 3,
	finalSend: 9,
	returned: 10
};

/* Notes modal constants */
export const reviewNoteTypes = {
	task: 1,
	document: 2
};

export const engagementSources = {
	currentEngagement: 1,
	otherEngagement: 2,
	allEngagements: 3
};

//RequestTable headers
export const customizedTableDropdownNames = {
	1: 'assignedTo',
	2: 'group',
	3: 'dueDate',
	4: 'sentDate',
	5: 'receivedDate',
	6: 'acceptedDate',
	7: 'status',
	8: 'priorityType',
	9: 'tags'
};

export const priorityTypesIds = {
	normal: 1,
	high: 3,
	critical: 4
};

export const customAndQuickFilters = {
	status: 'status',
	priority: 'priority'
};

export const requestTableHeaders = {
	assignedTo: 'assignedTo',
	group: 'group',
	dueDate: 'dueDate',
	sentDate: 'sentDate',
	receivedDate: 'receivedDate',
	acceptedDate: 'acceptedDate',
	status: 'status',
	priorityType: 'priorityType',
	tags: 'tags'
};

export const auditPlanFilterKeys = {
	auditPlanFilter: 'auditPlanFilter',
	auditPlanSearchFilter: 'auditPlanSearchFilter',
	auditPlanScotListKey: 'auditPlanScotListKey',
	auditPlanITProcessListKey: 'auditPlanITProcessListKey',
	auditPlanListKeys: ['auditPlanScotListKey', 'auditPlanITProcessListKey']
};

//RequestTable All tab default selection
export const allTabCustomizedOptions = [
	{id: 1, checked: true},
	{id: 2, checked: false},
	{id: 3, checked: true},
	{id: 4, checked: false},
	{id: 5, checked: false},
	{id: 6, checked: false},
	{id: 7, checked: true},
	{id: 8, checked: true},
	{id: 9, checked: false}
];

export const collaborationAllTabsCustomizedOptions = [
	{id: 2, checked: false},
	{id: 3, checked: true},
	{id: 4, checked: false},
	{id: 5, checked: false},
	{id: 6, checked: false},
	{id: 7, checked: true},
	{id: 8, checked: true},
	{id: 9, checked: false}
];

//RequestTable draft tab default selection
export const draftTabCustomizedOptions = [
	{id: 1, checked: true},
	{id: 2, checked: false},
	{id: 3, checked: true},
	{id: 4, checked: false},
	{id: 5, checked: false},
	{id: 6, checked: false},
	{id: 7, checked: true},
	{id: 8, checked: true},
	{id: 9, checked: false}
];

//RequestTable pending tab default selection
export const pendingTabCustomizedOptions = [
	{id: 1, checked: true},
	{id: 2, checked: false},
	{id: 3, checked: true},
	{id: 4, checked: true},
	{id: 5, checked: false},
	{id: 6, checked: false},
	{id: 7, checked: true},
	{id: 8, checked: true},
	{id: 9, checked: false}
];

//RequestTable received tab default selection
export const receivedTabCustomizedOptions = [
	{id: 1, checked: true},
	{id: 2, checked: false},
	{id: 3, checked: true},
	{id: 4, checked: false},
	{id: 5, checked: true},
	{id: 6, checked: false},
	{id: 7, checked: true},
	{id: 8, checked: true},
	{id: 9, checked: false}
];

//RequestTable accepted tab default selection
export const acceptedTabCustomizedOptions = [
	{id: 1, checked: true},
	{id: 2, checked: false},
	{id: 3, checked: true},
	{id: 4, checked: false},
	{id: 5, checked: false},
	{id: 6, checked: true},
	{id: 7, checked: true},
	{id: 8, checked: true},
	{id: 9, checked: false}
];

export const notesFilter = {
	allNotes: 1,
	myNotes: 2,
	authoredByMeNotes: 3
};
/* Notes modal constants */

// Enum for Advanced Search Columns - a part of story #1018039
export const advancedSearchColumnIds = {
	title: 1,
	referenceNumber: 2,
	documents: 3,
	comments: 4
};

/* Loading indicator types */
export const loadingIndicatorTypes = {
	progress: 'progress',
	standard: 'standard'
};

export const gaRoleTypes = {
	primary: 1,
	regional: 2,
	component: 3
};

export const dragAndDropContainerSources = {
	addRequestDocumentsList: 'addRequestDocumentsList',
	requestDocumentsList: 'requestDocumentsList'
};

export const gaRecommendationType = {
	required: 1,
	optional: 2,
	notApplicable: 3
};

export const requestDocumentOperationType = {
	remove: 1,
	delete: 2,
	restore: 3
};

export const groupSummaryTabs = {
	assignedTeams: 1,
	instructions: 2,
	tasks: 3
};

export const ISOMomentFormat = 'YYYY-MM-DD';
export const EngagementClientYearEndDate = '2023-12-15T00:00:00';

export const TaskListTypes = {
	ScopeAndStrategy: 3,
	SCOTs: 4,
	ITSOs: 5,
	Accounts: 6,
	GeneralExecution: 7,
	Conclusion: 8,
	Risks: 10
};

export const documentAditionalProps = {
	enableOpenDocument: true,
	showShared: false,
	showConfidential: false,
	size: 'Large'
};

export const subServiceLineId = {
	audit: 1,
	FIDS: 2,
	FAAS: 9,
	CCaSS: 11
};

export const EYApplications = {
	EYCanvas: {
		id: 1,
		name: 'EY Canvas'
	},
	EYCanvasClientPortal: {
		id: 2,
		name: 'EY Canvas Client Portal'
	},
	EYCanvasOversight: {
		id: 3,
		name: 'EY Canvas Oversight'
	},
	EYCanvasEconomics: {
		id: 4,
		name: 'EY Canvas Economics'
	},
	EYAtlas: {
		id: 5,
		name: 'EY Atlas'
	},
	EYHelix: {
		id: 6,
		name: 'EY Helix'
	},
	EYSmartAutomation: {
		id: 7,
		name: 'EY Smart Automation'
	}
};

export const bulkAssignmentConstants = {
	successMessageDuration: 3000,
	add: 'add',
	replace: 'replace',
	updateDueDate: 'updateduedate',
	tasks: 'tasks',
	dragType: 'dragType',

	actionIds: {
		add: '1',
		remove: '2',
		replace: '3',
		updateDueDays: '4'
	}
};

export const PermissionKey = {
	AdministerEngagement: 4
};

export const FilterKeys = {
	bulkTaskFilterKey: '{0}#bulktasks',
	piceqrTaskFilterKey: '{0}#piceqrtasks',
	piceqrDocFilterKey: '{0}#piceqrdocuments',
	piceqrRNHFilterKey: '{0}#PICEQRRNH',
	drilldownTaskFilterKey: '{0}#drilldowntasks',
	drilldownRNHFilterKey: '{0}#DrillDownRNH',
	drilldownClientReqFilterKey: '{0}#DrillDownClientReq',
	piceqrTaskSearchFilterKey: '{0}#piceqrtaskfilters',
	piceqrDocSearchFilterKey: '{0}#piceqrdocfilters',
	piceqrRNHSearchFilterKey: '{0}#piceqrrnhfilters',
	myProgressRNHFilterKey: '{0}#MyProgressRNH',
	myProgressTasksFilterKey: '{0}#myprogresstasks',
	myProgressCollaboration: '{0}#myProgressCollaboration',
	reviewNotesNewViewFilterKey: '{0}#reviewNotesNewViewFilterKey',
	collaborationV2FilterKey: '{0}#collaborationV2FilterKey',
	allTaskFilterKey: '{0}#alltasks',
	filtersOnBulkRequest: '{0}#filtersOnBulkRequests'
};

export const QuickFilterActionTypes = {
	// Adv options quick filter action types
	unassigned: 1,
	assignedto: 2,
	assignmentype: 3,
	assignmentstatus: 4,
	timephase: 5,
	tag: 6,

	// PIC EQR dashboard quick filter action types
	taskstatus: 7,
	auditphase: 8,
	syncfilter: 9,
	eptasksignoff: 10,
	eqrtasksignoff: 11,
	epdocsignoff: 12,
	eqrdocsignoff: 13,
	reviewnotesassignedto: 14,
	reviewnotesauthoredby: 15
};

export const QuickFilterModes = {
	add: 1,
	remove: 2,
	edit: 3
};

export const QuickFilterTypes = {
	assignmentstatus: 'assignmentstatus',
	assignedto: 'assignedto',
	assignmenttype: 'assignmenttype',
	timephase: 'timephase',
	tag: 'tag',
	auditphase: 'auditphase',
	taskstatus: 'taskstatus',
	eptasks: 'eptasks',
	eqrtasks: 'eqrtasks',
	docauditphase: 'filterauditphase',
	docnotsignedoffby: 'filternotsignedoffbyuser',
	filterexecutiverequirement: 'filterexecutiverequirement',
	filterresponsiveness: 'filterresponsiveness',
	searchtype: 'searchtype',
	searchstring: 'searchstring',
	reviewnotesassignedto: 'reviewnotesassignedto',
	reviewnotesauthoredby: 'reviewnotesauthoredby',
	annotationstatusids: 'annotationstatusids',
	filterduedatestart: 'filterduedatestart',
	filterduedateend: 'filterduedateend'
};

export const QuickFilterEpicTypes = {
	advoptions: 1,
	piceqrtask: 2,
	piceqrdoc: 3,
	piceqrreviewnote: 4,
	task: 5
};

export const QuickFilterSignoffTypes = {
	epnodocumentsignoff: '3',
	epsomedocumentsignoff: '2',
	epalldocumentsignoff: '1',
	eqrnodocumentsignoff: '6',
	eqrsomedocumentsignoff: '5',
	eqralldocumentsignoff: '4',
	isepsignoffrequired: '1',
	isepsignoffuserrequired: '2',
	iseqrsignoffrequired: '3',
	iseqrsignoffuserrequired: '4'
};

export const FilterMainMenu = {
	filtergrouptasks: 0,
	filtergroupassignments: 1,
	filtergroupreviewnotes: 2,
	filtergroupdocumentsignoffs: 3,
	filtergroupprojectmanagement: 4,
	filtergroupother: 5
};

export const ExecutiveDashboardButtons = {
	tasksView: 1,
	documentsView: 2,
	reviewNotesView: 3,

	// Tasks view buttons
	currentlyAssigned: 11,
	upcoming: 12,
	completed: 13,
	allAssigned: 14,

	// Documents view buttons
	pic: 21,
	eqr: 22,
	picAndEqr: 23,
	responsiveToSR: 24,
	responsiveToFR: 25,

	// Review notes view buttons
	assignedToMe: 31,
	authoredByMe: 32
};

export const MESTReviewNoteTabs = {
	open: 'Open',
	cleared: 'Cleared',
	closed: 'Closed'
};

export const AssignmentStatusType = {
	current: 'current',
	upcoming: 'upcoming',
	completed: 'completed',
	allassigned: 'allassigned'
};

export const SearchTypes = {
	contains: 1,
	startsWith: 2
};

export const UserOrRoleTypes = {
	user: 'user',
	role: 'role'
};

export const AutoAssignAssignmentTypes = {
	partner: 'partner',
	eqr: 'eqr'
};

export const SearchFilterConstants = {
	searchType: 'searchType',
	searchString: 'searchString'
};

export const CanvasCoreLoaderViewTypes = {
	inlineView: 'inlineView',
	blockView: 'blockView',
	inFrontView: 'inFrontView'
};

export const AssignmentStatus = {
	Open: 'Open',
	Inprogress: 'In progress',
	Closed: 'Closed',
	Unassigned: 'Unassigned'
};

export const ExecutiveDashboardConstants = {
	commonParentName: 'executiveProgressSummary' // for list of PIC/EQR progress.
};

export const ContentUpdateStatus = {
	NoFormsRestricted: 1,
	SomeFormsRestricted: 2,
	AllFormsRestricted: 3,
	SomeLinkedFormsRestricted: 4,
	AllCanvasFormsRestricted: 5,
	AllSyncFormProfileRestricted: 6
};

export const ControlRiskType = {
	Rely: 1,
	NotRely: 2,
	TestMp: 3
};

export const InherentRiskType = {
	Higher: 1,
	Lower: 2
};

export const RiskTypes = {
	Significant: 1,
	Fraud: 2,
	Inherent: 3
};

export const IRCRType = {
	InherentRiskType: 'InherentRiskType',
	ControlRiskType: 'ControlRiskType'
};
export const TaskLiteDisplayMode = {
	SliderView: 1,
	ModalView: 2
};

export const CRARefreshModes = {
	RefreshOnlyCount: 1,
	RefreshOnlyEntities: 2,
	RefreshCountAndEntities: 3,
	RefreshMutlipleEntities: 4,
	RefreshEntityAfterValidationCount: 5
};

export const WAS_ON_PIC = 'WAS_ON_PIC';

export const PSPContentUpdateStatus = {
	UpdateRequired: 1,
	UpdateInProgress: 2,
	UpdateComplete: 3,
	UpdateError: 4
};

export const UIReportIDs = {
	AllTasks: 1,
	TaskAssignments: 2,
	DeletedTasks: 3,
	TaskAnalysis: 4,
	TaskSummary: 5,
	ManageTeamInernalMember: 6,
	ManageTeamExternalMember: 7,
	SCOTSummaryReport: 8,
	UnmappedTasks: 9,
	SemReport: 10,
	ItAppSOSummaryReport: 11,
	AuditPlanReport: 12,
	CollaborationDetails_Summary: 13,
	CollaborationDetails_ActivityDetails: 14,
	GroupStructureSummary: 15,
	CRTSummary: 17,
	CRASummary: 16,
	SCOTsControlsReport: 18,
	ITProcessSCOTControlsReport: 19,
	ITProcessSummaryReport: 20,
	CRTAllControlsReport: 21,
	CanvasFormResponse: 22,
	ReviewNotesReport: 23,
	ControlFormResponse: 24,
	CRTStatisticsReport: 25,
	CanvasFormsIncomplete: 26,
	IndependenceSummaryReport: 27,
	MilestonesReport: 28,
	ArchiveForm: 29,
	CanvasFormsRelatedObjectsReport: 30,
	CRTQualityChecksReport: 31,
	CanvasFormsRelatedCommentsReport: 32,
	TrialBalanceReport: 33,
	GroupComponentAccountReport: 34,
	RisksToWCGWsReport: 35,
	GroupActivityReport: 36,
	LastPublishAndSend: 37,
	ComponentControlToAssertionReport: 38,
	ComponentControlToAccountInfoReport: 39,
	ComponentCanvasFormExport: 40,
	AccountDisclosuresReport: 41,
	MultiEntityTasks: 42,
	IPEControls: 43,
	IPESubstantive: 44,
	IPEITGC: 45
};

export const knowledgeAssertionTypeEnum = {
	BalanceSheetCompleteness: 1,
	BalanceSheetExistence: 2,
	BalanceSheetValuation: 3,
	BalanceSheetRightsandObligations: 4,
	BalanceSheetPresentationandDisclosure: 5,
	IncomeStatementCompleteness: 6,
	IncomeStatementOccurrence: 7,
	IncomeStatementMeasurement: 8,
	IncomeStatementPresentationandDisclosure: 9,
	BothCompleteness: 10,
	BothExistenceorOccurrence: 11,
	BothMeasurementorValuation: 12,
	BothRightsandObligations: 13,
	BothPresentationandDisclosure: 14
};

export const ReportExportFileNames = {
	AuditPlanReport: 'Audit Plan Report',
	AllTasks: 'Tasks All tasks',
	TaskAssignments: 'Tasks Task assignments',
	DeletedTasks: 'Tasks Deleted tasks',
	TaskAnalysis: 'Tasks Task analysis',
	TaskSummary: 'Tasks Task summary (Pilot)',
	TaskMultiEntity: 'Tasks Multi entity tasks',
	AllDocuments: 'Documents All documents',
	SignOffs: 'Documents Sign-off',
	DocumentsModified: 'Documents Documents modified after RRD',
	RequestsAndTasks: 'Collaboration Requests and tasks',
	RequestsAndTasksComments: 'Collaboration Requests and tasks comments',
	GroupReport: 'Group Report',
	GroupComponentAccountReport: 'Group component account mapping'
};

export const oneToEightDefaultWCGWs = [
	'01 - IPE Reference',
	'02 - Review Control risk designation (Review Control - higher, Review Control or N/A)',
	'03 - Responsive to a significant risk',
	'04 - Existence or Occurrence',
	'05 - Completeness',
	'06 - Measurement or Valuation',
	'07 - Rights and Obligations',
	'08 - Presentation and Disclosure'
];
export const CRASummaryReportsExportFileName = {
	Scot: 'CRA Summary Account SCOT WCGW Control',
	AssertionR: 'CRA Summary Account Assertion WCGW Control',
	CRASummary: 'CRA Summary CRA Summary'
};

export const CRTSummaryReportsExportFileName = {
	WCCGSummary: 'Controls Review Tool (CRT) WCGW summary',
	AssertionSummary: 'Controls Review Tool (CRT) Assertion summary',
	SCOTSummary: 'Controls Review Tool (CRT) SCOT summary',
	AllControls: 'Controls Review Tool (CRT) All controls',
	Statistics: 'Controls Review Tool (CRT) Statistics',
	QualityChecks: 'Controls Review Tool (CRT) Quality checks',
	ControlSummary: 'Controls Review Tool (CRT) Control summary'
};

export const ITAppSOSummaryReportsExportFileName = {
	ITAppSOSummary: 'IT App & SO Summary IT App/SO Summary',
	ITProcessSummary: 'IT App & SO Summary IT Process Summary',
	SCOTsControls: 'IT App & SO Summary SCOTs & Controls',
	ITProcessSCOTControls: 'IT App & SO Summary IT Process, SCOT, and Controls'
};

export const ArchiveFormReportsExportFileName = {
	archive: 'Archive form Archive'
};

export const CanvasFormReportsExportFileName = {
	CanvasFormResponse: 'Canvas Forms Canvas Form responses',
	CanvasFormsRelatedComments: 'Canvas Forms Related comments',
	CanvasFormsIncomplete: 'Canvas Forms Incomplete responses',
	CanvasFormsRelatedObjects: 'Canvas Forms Related objects',
	ControlFormResponse: 'Control Form responses'
};

export const FindingReportsExportFileName = {
	Deficiency: 'Findings Deficiency',
	Misstatement: 'Findings Misstatement',
	DeficiencyIT: 'Findings Deficiency-IT'
};

export const TeamMemberReportsExportFileName = {
	InternalMembers: 'Team Members Internal members',
	ExternalMembers: 'Team Members External members',
	IndependenceSummary: 'Team Members Independence Summary'
};

export const ScotSummaryReportsExportFileName = {
	SCOTSummary: 'SCOT Summary'
};

export const AuditPlanExportFileName = {
	AuditPlan: 'Audit Plan'
};

export const GroupStructureSummaryExportFileName = {
	GroupStructureSummary: 'Group Structure Summary'
};

export const AuditPlanRelatedEvidenceExportFileName = {
	AuditPlanRelatedEvidence: 'Audit Plan With Related Evidence'
};

export const GroupInstructionSummaryExportFileName = {
	GroupInstructionSummary: 'Group Instruction Summary',
	LastPublishAndSend: 'Last published and sent',
	GroupActivity: 'Component account mapping history'
};

export const CollaborationDetailsExportFileName = {
	collaborationSummary: 'Collaboration details Summary',
	collaborationActivity: 'Collaboration details Activity details'
};

export const ProjectInsightExportFileName = {
	canvasFormExport: 'Project Insight Canvas Form Export',
	scotToWCGWToControl: 'Project Insight SCOT to WCGW to Control',
	controlToITApplication: 'Project Insight Control to IT Application',
	controlToAssertion: 'Project Insight Control to Assertion',
	riskToWCGW: 'Project Insight Risks to WCGWs'
};

export const IpeExportFileName = {
	controls: 'Information produced by the entity (IPE) Controls',
	substantive: 'Information produced by the entity (IPE) Substantive',
	ITGC: 'Information produced by the entity (IPE) ITGC'
};

export const ComponentTeamGroupExportFileName = {
	controlToAssertion: 'Component team Control to Assertion',
	accountInformation: 'Component team Account information',
	canvasFormExport: 'Component team Canvas form export'
};

export const MilestonesExportFileName = {
	milestonesReport: 'Milestones Milestones Report',
	unmappedTasks: 'Milestones Unmapped tasks'
};

export const ReviewNotesReportsExportFileName = {
	ReviewNotes: 'Review Notes'
};

export const ValidationCheckReportsExportFileName = {
	ValidationChecks: 'Validation Checks'
};

export const TrialBalanceReportsExportFileName = {
	TrialBalance: 'Trial balance report'
};

export const AccountDisclosuresReportsExportFileName = {
	AccountDisclosures: 'Accounts and disclosures'
};

export const taskSummaryReportDueWeekId = {
	PastWeeks: 0,
	CurrentWeek: 1,
	NextWeek: 2,
	FutureWeeks: 3
};

export const DefaultPage = 1;

export const signOffRequirementsClientYearDate = '2023-12-15';

export const reportSection = {
	Section1: 'Section1',
	Section2: 'Section2',
	Section3: 'Section3'
};

export const selectDateCalculateDateToggle = {
	selectDate: 'selectDate',
	calculateDate: 'calculateDate'
};

export const taskAttributes = {
	relatedObjects: 6,
	allObjects: 7
};

export const invalidClientCode = '!!!';

export const priorityTypesList = {
	Normal: 1,
	High: 3,
	Critical: 4
};

export const VOICE_NOTE_MAX_RECORD_TIME = 30001;
export const VOICE_NOTE_DOCUMENT_SOURCE_ID = 8;

export const GuidedWorkflowV2DocumentTypes = [
	documentTypes.LIMITEDRISKDOCUMENTATION,
	documentTypes.ACCOUNT_CONCLUSION,
	documentTypes.GUIDEDWORKFLOWV2,
	documentTypes.ESTIMATESDOCUMENT,
	documentTypes.ANALYTICSDOCUMENT,
	documentTypes.MULTIENTITYENGAGEMENTPROFILE,
	documentTypes.MULTIENTITYSUBPROFILE,
	documentTypes.MULTIENTITYINDIVIDUALPROFILE,
	documentTypes.MULTIENTITYSUBPROFILE,
	documentTypes.ACCOUNTLEVELRISKASSESSMENT,
	documentTypes.PIC_CHECKLIST,
	documentTypes.EQR_CHECKLIST,
	documentTypes.GROUPSTRUCTUREGUIDEDWORKFLOW,
	documentTypes.GROUPINSTRUCTIONGUIDEDWORKFLOW,
	documentTypes.ALRA_INDIVIDUAL,
	documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT,
	documentTypes.GROUP_INVOLVEMENT_SUMMARY,
	documentTypes.ACCOUNT_STANDARD_WORKING_PAPER,
	documentTypes.ACCOUNT_STANDARD_WORKING_PAPER_TEMPORARY,
	documentTypes.ALRA_INDIVIDUAL_TEMPORARY,
	documentTypes.GUIDEDWORKFLOWV2_TEMPORARY,
	documentTypes.DETERMINEPMTESAD,
	documentTypes.IT_FLOW_ISA315,
	documentTypes.PROFILEV2,
	documentTypes.INDEPENDENCEFORMINDIVIDUAL,
	documentTypes.CONTROL_UNDERSTAND_CONTROLS,
	documentTypes.CONTROL_UNDERSTAND_CONTROLS_TEMPORARY,
	documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES,
	documentTypes.CONTROL_TEST_CONTROL_ATTRIBUTES_TEMPORARY,
	documentTypes.SCOT_WALKTHROUGH,
	documentTypes.SCOT_WALKTHROUGH_TEMPORARY,
	documentTypes.Estimate_Individual_Estimate_Temporary
];

export const isDocumentEligibleForDaaS = ['docx', 'docm', 'pptx', 'xlsx', 'xlsb', 'xlsm', 'xltx'];
export const isDocumentParentEligibleForDaaS = [
	'evidences',
	'temporaryfiles',
	'teampinneddocuments',
	'mypinneddocuments'
];

export const daasOptions = {
	checkout: 'checkout',
	checkin: 'checkin'
};

export const CanvasFormOpenType = {
	New: 1,
	Existing: 2,
	Drawer: 3
};

export const AnalyticApprovalStatus = {
	Draft: 1,
	PendingApproval: 2,
	NotApproved: 3,
	Approved: 4,
	Expired: 5
};

export const categoryMapping = {
	all: TaskCategories.AllTasks,
	account: TaskCategories.ExecutionAccounts,
	scot: TaskCategories.ExecutionSCOTs,
	itprocess: TaskCategories.ExecutionITSOs,
	risk: TaskCategories.Risks,
	auditphase: TaskCategories.TaskSection,
	scopestrategy: TaskCategories.TaskSection,
	conclusion: TaskCategories.TaskSection,
	execution: TaskCategories.TaskSection,
	multientity: TaskCategories.Entities,
	documents: 'documents'
};

export const DrillDownCategories = {
	all: 'all',
	conclusion: 'conclusion',
	scopestrategy: 'scopestrategy',
	execution: 'execution',
	account: 'account',
	scot: 'scot',
	itprocess: 'itprocess',
	risk: 'risk',
	auditphase: 'auditphase',
	multientity: 'multientity',
	documents: 'documents'
};

export const DrillDownCategoryMapingForKeyDoc = {
	scopestrategy: 'TaskSection',
	conclusion: 'TaskSection',
	execution: 'TaskSection',
	account: 'Account',
	scot: 'SCOT',
	itprocess: 'ITProcess',
	risk: 'Risk'
};

export const TaskFilterTypes = [
	'taskstatus',
	'tasktype',
	'eptasks',
	'eqrtasks',
	'filteranypicevidence',
	'filteranyeqrevidence',
	'assignmentstatus',
	'assignedto',
	'assignmenttype',
	'reviewnotesstatus',
	'reviewnotesassignedto',
	'reviewnotesauthoredby',
	'missingsignoffs',
	'nodocumentsignedoffby',
	'somedocumentsignedoffby',
	'alldocumentsignedoffby',
	'timephase',
	'milestone',
	'auditphase',
	'tag',
	'schedulerrequest',
	'scheduleroffering',
	'documentconflict',
	'findings',
	'isbookmarked',
	'entity',
	'filterduedatestart',
	'filterduedateend',
	'filtervalidationgroup'
];

export const ReviewNoteFilterTypes = [
	'reviewnotesauthoredby',
	'reviewnotesassignedto',
	'prioritytype',
	'duedateend',
	'duedatestart'
];

export const ViewTypes = {
	tasks: 'tasks',
	documents: 'documents',
	reviewnotes: 'reviewnotes',
	collaboration: 'collaboration',
	assignments: 'assignments',
	cardView: 'Card view',
	tableView: 'Table view'
};

export const DrillDownQSParams = {
	category: 'category',
	entityuid: 'entityuid',
	view: 'viewtype',
	userid: 'userid',
	duedate: 'duedate',
	entities: 'entities',
	timephaseid: 'timephaseid',
	engagementid: 'engagementid',
	deeplinkdocumentid: 'deeplinkdocumentid',
	deeplinktaskid: 'deeplinktaskid',
	trialbalanceid: 'trialbalanceid'
};

export const DrillDownMiscConstants = {
	tasksection: 'tasksection',
	itso: 'itso',
	taskSectionID: 'taskSectionID',
	filtertimephase: 'filtertimephase',
	timephase: 'timephase',
	allTasks: 'allTasks',
	teamSummary: 'teamSummary'
};

export const TaskDrawerModes = {
	DrawerWithMultipleTasks: 1,
	DrawerWithSingleTask: 2
};

export const DocumentArrayFilters = ['filtermultientityids'];

export const DocumentMergeFilters = ['filtertimephase', 'timephase'];

export const BulkActionTypes = {
	handoff: 'handoff',
	assignment: 'assignment',
	markComplete: 'markcomplete',
	tags: 'tags',
	timePhases: 'timephases',
	delete: 'delete',
	relateEvidence: 'relateevidence',
	relateTickMarks: 'relatetickmarks',
	removeReference: 'removeReference'
};

export const RowTypes = {
	header: 'header-row',
	data: 'data-row'
};

export const EntityAttributeMapping = {
	account: 'accountName',
	scot: 'scotName',
	itprocess: 'itProcessName',
	risk: 'riskName',
	auditphase: 'taskGroupSectionName',
	conclusion: 'taskGroupSectionName',
	execution: 'taskGroupSectionName',
	scopestrategy: 'taskGroupSectionName'
};

export const reportPIC = 'PIC';
export const reportEP = 'EP';
export const exportColumnWidth = 101;

export const AccountDocumentTypes = [94, 110, 114];
export const EstimateDocumentTypes = [93];
export const ControlDocumentTypes = [121, 123];
export const ScotDocumentTypes = [126];

export const trialBalanceType = {
	Planning: 1,
	FinancialStatment: 3
};

export const trialBalanceTypeCategory = {
	CurrentPeriod: 2
};

export const importStatus = {
	ImportCompleted: 3
};

export const reviewNotesStatus = {
	open: {label: 'Open', index: 0},
	cleared: {label: 'Cleared', index: 1}
};

export const materialityPeriod = {
	current: 'currentPeriod',
	prior: 'priorPeriod'
};

export const financialStatementType = {
	Asset: 1,
	CurrentAsset: 2,
	NonCurrentAsset: 3,
	Liability: 4,
	CurrentLiability: 5,
	NonCurrentLiability: 6,
	Equity: 7,
	Revenue: 8,
	Expense: 9,
	NonOperatingIncome: 10,
	OtherComprehensiveIncome: 11,
	Other: 12,
	AccountType: 13,
	AccountSubType: 14,
	AccountClass: 15,
	AccountSubClass: 16,
	NetIncomeExpense: 17
};

export const frameSubEvent = {
	MORE_MENU_CLICK: 'MoreMenuClick',
	CLOSE_MENU: 'CloseMenu',
	UPDATE_FRAME_TITLE: 'UpdateFrameTitle'
};

export const ExecutionType = {
	ExecutedInEngagement: 1,
	GroupExecutedInComponentEngagement: 2,
	GroupExecutedInPrimaryAndComponentEngagement: 3
};

export const numberFormats = [
	{id: 0, value: '1,234,567,890', label: 'numbericStlye1', title: '1,234,567,890', decimalSeparator: '.'},
	{id: 1, value: '1,23,45,67,890', label: 'numbericStlye7', title: '1,23,45,67,890', decimalSeparator: '.'},
	{id: 2, value: '1 234 567 890', label: 'numbericStlye2', title: '1 234 567 890', decimalSeparator: '.'},
	{id: 3, value: '1.234.567.890', label: 'numbericStlye3', title: '1.234.567.890', decimalSeparator: ','}
];

export const engagementAccessTypeEnum = {
	Others: 1,
	IndependenceOnly: 2
};

export const buildStepIds = {
	accounts: 'accounts-menu',
	scots: 'scots-menu',
	itAppProcess: 'it-app-process-menu',
	cra: 'cra-menu',
	auditPlan: 'audit-plan-menu',
	workPlan: 'work-plan-menu'
};
export const buildStepTypes = {
	document: 1,
	task: 2
};

export const buildStepsToTaskBuildMileStoneIds = {
	accounts: [1, 31],
	scots: [5, 6, 7, 8, 32, 38, 57],
	itAppProcess: [],
	cra: [2, 15, 30, 3],
	auditPlan: [18, 19, 20, 21, 25, 26, 27, 29, 39, 56],
	workPlan: [49, 50]
};

export const buildStepTaskMilestoneIds = [
	1,
	31,
	5,
	32,
	6,
	7,
	38,
	8,
	2,
	15,
	30,
	3,
	18,
	19,
	20,
	21,
	25,
	26,
	27,
	29,
	39,
	50,
	56,
	57
];

export const responsiveTaskTypes = {
	PSPOSP: 1,
	Control: 2,
	TOC: 3
};

export const importOspConstants = {
	taskTypeId: 16,
	auditPhaseId: 2
};

export const profileAnswerOptions = {
	USGAAS: 149,
	IntegratedAudit: 314,
	Digital: 348
};

export const helixViewerErrorCodes = {
	unautorizedUser: 1000,
	bookmarkNotFound: 1012,
	unautorizedAccessToBookmark: 1010,
	authenticationError: 1997,
	genericError: 1999
};

export const taskListHeaderColumnLabels = [
	{
		id: 1,
		columnName: 'Type',
		sortParam: 'knowledge',
		className: 'type'
	},
	{
		id: 2,
		columnName: 'Name',
		sortParam: 'taskname',
		className: 'name'
	},
	{
		id: 3,
		columnName: 'Due date',
		sortParam: 'duedate',
		className: 'duedate'
	}
];

export const subCategoty = [
	{
		id: 1,
		title: 'Show all',
		value: 1,
		className: 'motif-active'
	},
	{
		id: 2,
		title: 'To prepare',
		value: 2,
		className: ''
	},
	{
		id: 3,
		title: 'To review',
		value: 3,
		className: ''
	}
];

export const gaComponentStatusList = [
	{
		id: 1,
		label: 'Not sent',
		icon: contentIcRemoveCircle24px
	},
	{
		id: 3,
		label: 'Draft version sent',
		icon: deviceIcAccessTime24px
	},
	{
		id: 9,
		label: 'Final version sent',
		icon: actionIcCheckCircle24px
	}
];

// #region Engagement Maps

export const auditPhaseIds = {
	ScopeAndStrategy: 1,
	Execution: 2,
	Conclusion: 3,
	PerformEngagementActivities: 4,
	IdentifyAndAssessRisks: 5,
	RespondToRisks: 6,
	ConcludeAndReport: 7
};
export const auditPhaseDisplayProps = {
	[auditPhaseIds.ScopeAndStrategy]: {colorCode: 'var(--maroon-600)', displayOrder: 100},
	[auditPhaseIds.Execution]: {colorCode: 'var(--blue-600)', displayOrder: 200},
	[auditPhaseIds.Conclusion]: {colorCode: 'var(--teal-500)', displayOrder: 300},
	[auditPhaseIds.PerformEngagementActivities]: {colorCode: 'var(--maroon-600)', displayOrder: 110},
	[auditPhaseIds.IdentifyAndAssessRisks]: {colorCode: 'var(--purple-600)', displayOrder: 120},
	[auditPhaseIds.RespondToRisks]: {colorCode: 'var(--blue-600)', displayOrder: 210},
	[auditPhaseIds.ConcludeAndReport]: {colorCode: 'var(--teal-600)', displayOrder: 310}
};

export const auditPhaseDisplayTypes = {
	DefaultBorder: 1,
	ThickBorder: 2
};

export const clickEventTypeIds = {
	CanvasTask: 1,
	CanvasForm: 2,
	CanvasView: 3,
	OtherLink: 4
};

export const MapEventViewTypes = {
	ArchieveCheckList: 'archievechecklist',
	FindingsHub: 'findingshub',
	PicEqrDashboard: 'piceqrdashboard',
	Collaboration: 'collaboration',
	ReviewNoteHub: 'reviewnotehub',
	FinancialStatements: 'financialstatements',
	EngagementOverview: 'engagementoverview',
	AllDocuments: 'alldocuments',
	AllTasks: 'alltasks',
	DataConnectionHelixImport: 'dataconnectionheliximport'
};

export const MapEventViewTypeUrls = {
	[MapEventViewTypes.ArchieveCheckList]: {path: herculesRoutes.archiveTimeline},
	[MapEventViewTypes.FindingsHub]: {path: '', hash: '#findingsHub'},
	[MapEventViewTypes.PicEqrDashboard]: {path: herculesRoutes.dashboard, hash: '#partnerProgress'},
	[MapEventViewTypes.Collaboration]: {path: herculesRoutes.collaborationv2},
	[MapEventViewTypes.ReviewNoteHub]: {path: herculesRoutes.reviewNotes},
	[MapEventViewTypes.FinancialStatements]: {path: herculesRoutes.financialStatements},
	[MapEventViewTypes.EngagementOverview]: {
		path: herculesRoutes.dashboard,
		hash: '#engagementOverview'
	},
	[MapEventViewTypes.AllDocuments]: {
		path: herculesRoutes.dashboard,
		search: {category: 'documents'},
		hash: '#engagementOverview'
	},
	[MapEventViewTypes.AllTasks]: {path: herculesRoutes.tasks},
	[MapEventViewTypes.DataConnectionHelixImport]: {path: herculesRoutes.helixProjects}
};

// #endregion Engagement Maps

export const superModalSummaryLinks = {
	ACCOUNTSSUMMARY: 101,
	SCOTSSUMMARY: 102,
	CRASUMMARY: 103,
	IT_FLOW_ISA315: 104,
	ITSOSUMMARY: 105,
	AUDITPLAN: 106,
	ITEVALUATIONSMARTFORM: 107,
	WORKPLANSUMMARY: 108
};
export const financialStatementsTypesNode = {
	accountClass: 2,
	eyAccount: 3,
	glAccount: 4
};
export const financialStatementsSubTypes = {
	accountClass: 3
};

export const engagementMap = {
	topicSessionKey: '{0}#selectedTopics'
};

export const filterAccountTypes = [
	'significantAccount',
	'limitedRiskAccount',
	'insignificantAccount',
	'significantDisclosure'
];
export const misstatementTypes = {
	manualTopUpAdjustment: 6
};
export const misstatementPeriodTypes = {
	currentPeriod: 1,
	comparativePeriod: 2,
	secondComparativePeriod: 3
};
export const filterExecutionType = ['executedInThisEngagement', 'groupExecutedInPrimaryAndComponentEngagement'];

export const receiveInstructionSwitcherIds = {
	groupInstructions: 'groupInstructions',
	groupRiskAssessment: 'groupRiskAssessment',
	documents: 'documents'
};

export const mobile = {
	adobeAnalyticsPrefix: 'Mobile'
};

export const reducerOperations = {
	Add: 'Add',
	Remove: 'Remove'
};

export const groupInstructionsConstants = {
	fields: {
		c: [1, 6, 10],
		eo: [2, 7, 11],
		mv: [3, 8, 12],
		ro: [4, 13],
		pd: [5, 9, 14]
	}
};

export const highLowRisk = Object.freeze({
	highRisk: 1,
	lowRisk: 2
});

export const analyzerConnectionTypes = [
	{
		connectionType: 'Scope & strategy',
		value: 'scopeStrategy'
	},
	{
		connectionType: 'Financial Statement',
		value: 'financialStatements'
	}
];

export const noteActions = {
	CreateNote: 1,
	EditNote: 2
};

export const GAITypes = {
	Assertions: 'assertion',
	InherentRisk: 'inherentRisk'
};

export const GAILevels = [
	{
		type: GAITypes.Assertions,
		accountLevel: 1,
		riskLevel: 2
	},
	{
		type: GAITypes.InherentRisk,
		accountLevel: 1,
		assertionLevel: 2,
		riskLevel: 3
	}
];

export const availableAnalyticsStatus = ['Analytics available', 'Analytics ready'];
export const analyticsAvailable = 'Analytics available';

export const connectionType = {
	ScopeStrategy: 'ScopeStrategy',
	FinancialStatements: 'FinancialStatements'
};

export const currencyType = {
	Functional: 'Functional',
	Reporting: 'Reporting'
};

export const fiscalCalendarFilter = 'Fiscal calendar';
export const currencyDataFilter = 'currencyData';
export const functionalCurrencyFilter = 'FunctionalCurrency';
export const functionalCurrencyCdFilter = 'functionalCurrencyCd';
export const reportingCurrencyFilter = 'ReportingCurrency';
export const reportingCurrencyCdFilter = 'reportingCurrencyCd';
export const businessUnit = 'Business unit';

export const motifInputEventType = {
	change: 'change',
	click: 'click'
};

export const AssertionRowsGAI = [
	{
		id: 1,
		assertionname: 'Completeness',
		assertionabbreviation: 'C',
		statementtypeid: 2,
		displayorder: 1
	},
	{
		id: 2,
		assertionname: 'Existence',
		assertionabbreviation: 'E',
		statementtypeid: 2,
		displayorder: 2
	},
	{
		id: 3,
		assertionname: 'Valuation',
		assertionabbreviation: 'V',
		statementtypeid: 2,
		displayorder: 3
	},
	{
		id: 4,
		assertionname: 'Rights and Obligations',
		assertionabbreviation: 'R&O',
		statementtypeid: 2,
		displayorder: 4
	},
	{
		id: 5,
		assertionname: 'Presentation and Disclosure',
		assertionabbreviation: 'P&D',
		statementtypeid: 2,
		displayorder: 5
	},
	{
		id: 6,
		assertionname: 'Completeness',
		assertionabbreviation: 'C',
		statementtypeid: 1,
		displayorder: 6
	},
	{
		id: 7,
		assertionname: 'Occurrence',
		assertionabbreviation: 'O',
		statementtypeid: 1,
		displayorder: 7
	},
	{
		id: 8,
		assertionname: 'Measurement',
		assertionabbreviation: 'M',
		statementtypeid: 1,
		displayorder: 8
	},
	{
		id: 9,
		assertionname: 'Presentation and Disclosure',
		assertionabbreviation: 'P&D',
		statementtypeid: 1,
		displayorder: 9
	},
	{
		id: 10,
		assertionname: 'Completeness',
		assertionabbreviation: 'C',
		statementtypeid: 3,
		displayorder: 10
	},
	{
		id: 11,
		assertionname: 'Existence/Occurrence',
		assertionabbreviation: 'E/O',
		statementtypeid: 3,
		displayorder: 11
	},
	{
		id: 12,
		assertionname: 'Measurement/Valuation',
		assertionabbreviation: 'M/V',
		statementtypeid: 3,
		displayorder: 12
	},
	{
		id: 13,
		assertionname: 'Rights and Obligations',
		assertionabbreviation: 'R&O',
		statementtypeid: 3,
		displayorder: 13
	},
	{
		id: 14,
		assertionname: 'Presentation and Disclosure',
		assertionabbreviation: 'P&D',
		statementtypeid: 3,
		displayorder: 14
	}
];

export const entityView = {
	Entity: 'entity',
	Default: 'default'
};

export const oversightProjectType = {
	MyActiveProjects: 1,
	OtherProjects: 2
};

export const NavConfig = [
	{
		url: 'dashboard',
		icon: 'LandingPage'
	},
	{
		url: 'dashboard/maps',
		icon: 'Maps'
	},
	{
		url: 'tasks',
		icon: 'TaskPage'
	},
	{
		url: 'dashboard',
		qString: 'category=documents',
		icon: 'DocumentsPage'
	},
	{
		url: 'financialstatements',
		icon: 'FinancialStatements'
	},
	{
		url: 'reviewnotes',
		icon: 'ReviewNotesPage'
	},
	{
		url: 'collaboration',
		icon: 'CollaborationPage'
	}
];

export const referenceTypes = {
	document: 'Document',
	tickMark: 'Tick mark'
};

// Represents  the level of modal.
export const modalLevels = {
	defaultLevel: 0
};

export const inherentRiskTypeId = {
	NONE: 0,
	HIGHER: 1,
	LOWER: 2,
	NOT_RELEVANT: 3
};

export const collaborationMyProgressFiltersItemsName = {
	priority: 'priority',
	duebefore: 'duebefore',
	dueafter: 'dueafter',
	overdue: 'overdue',
	accepted: 'accepted'
};

export const helixfiscalDropDownLabelStructure = 'Period {0} - {1}';

export const graphAxisLabels = {
	overdueGreater90: 'Overdue > 90',
	overdueBet31_90: 'Overdue 31-90',
	overdueBet10_30: 'Overdue 10-30',
	overdueBet1_9: 'Overdue 1-9',
	daysGreater90: '> 90',
	daysBet31_90: '31-90',
	daysBet10_30: '10-30',
	daysBet1_9: '1-9',
	overdue: 'Overdue'
};
export const ImportStatus = {
	ImportRequestedFromHelix: 1,
	ImportBeingProcessedByEYCanvas: 2,
	ImportCompleted: 3,
	ErrorNoPreviousImport: 4,
	ErrorPreviousSuccessfulImport: 5
};

export const HelixImportStatus = {
	InQueue: 1,
	InProgress: 2,
	Completed: 3,
	Error: 4,
	NotStarted: 5,
	Disconnected: 6
};

export const TrialBalanceType = {
	Planning: 1,
	PlanningPriorPeriod: 2,
	FinancialStatements: 3,
	FinancialStatementsPriorPeriod: 4
};

export const graInstructionSectionLabel = 'Group risk assessment';

export const collaborationV2SortingNameColumns = {
	referenceNumber: 'ReferenceNumber',
	title: 'Title',
	fullName: 'AssignedTo',
	status: 'Status',
	dueDate: 'DueDate',
	priority: 'PriorityTypeID'
};

export const ipeSpecificColumns = [
	'ControlID',
	'ControlName',
	'AccountID',
	'AccountName',
	'ITControlID',
	'ITControlName'
];

export const permissionsPolicy = 'clipboard-write';
